/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AddHostingResult = {
  __typename?: 'AddHostingResult';
  show?: Maybe<Podcast>;
  subscription?: Maybe<Subscription>;
};

export type AdditionalFile = {
  __typename?: 'AdditionalFile';
  duration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AdditionalFileInput = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AdditionalInput = {
  artist?: InputMaybe<Scalars['String']['input']>;
  artwork_url?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  episode_number?: InputMaybe<Scalars['String']['input']>;
  explicit?: InputMaybe<Scalars['Boolean']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  publish_now?: InputMaybe<Scalars['Boolean']['input']>;
  season_number?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AdminFile = {
  __typename?: 'AdminFile';
  audioJobId?: Maybe<Scalars['ID']['output']>;
  bucket: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobStatus?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type AlituCancelSchedulePublishResponse = {
  __typename?: 'AlituCancelSchedulePublishResponse';
  success: Scalars['Boolean']['output'];
};

export type AlituPublishResponse = {
  __typename?: 'AlituPublishResponse';
  success: Scalars['Boolean']['output'];
};

export type AlituPublishedEpisodes = {
  __typename?: 'AlituPublishedEpisodes';
  episodes: Array<Episode>;
  total: Scalars['Int']['output'];
};

export type AlituUnpublishResponse = {
  __typename?: 'AlituUnpublishResponse';
  success: Scalars['Boolean']['output'];
};

export type AlituUpdatePublishedDate = {
  __typename?: 'AlituUpdatePublishedDate';
  success: Scalars['Boolean']['output'];
};

export type ApiKey = {
  __typename?: 'ApiKey';
  apiKeyId: Scalars['String']['output'];
  apiKeyValue: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type ApiKeyUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AppStat = {
  __typename?: 'AppStat';
  appName: Scalars['String']['output'];
  downloads: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
};

export type AppleShowStatus = {
  __typename?: 'AppleShowStatus';
  exists: Scalars['Boolean']['output'];
};

export type ArtworkInput = {
  artworkUploadKey?: InputMaybe<Scalars['String']['input']>;
  deleteArtwork?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssumeUser = {
  __typename?: 'AssumeUser';
  sessionId: Scalars['ID']['output'];
  user: User;
};

export type AudioItem = {
  __typename?: 'AudioItem';
  end: Scalars['Float']['output'];
  resource: Scalars['String']['output'];
  sourceStart: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
  type: TimelineItemType;
};

export type BackgroundItem = {
  __typename?: 'BackgroundItem';
  end: Scalars['Float']['output'];
  fadeInDuration: Scalars['Float']['output'];
  fadeOutDuration: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  resource: Scalars['String']['output'];
  sourceStart: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
  type: TimelineItemType;
  volume: Scalars['Float']['output'];
};

export type BleepItem = {
  __typename?: 'BleepItem';
  end: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  resource: Scalars['String']['output'];
  sourceStart: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
  type: TimelineItemType;
};

export type Call = {
  __typename?: 'Call';
  createdAt: Scalars['String']['output'];
  creator: User;
  creatorTwilioId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  job?: Maybe<Job>;
  ongoing: Scalars['Boolean']['output'];
  room: Scalars['ID']['output'];
  solo: Scalars['Boolean']['output'];
};

export type CallExistsResponse = {
  __typename?: 'CallExistsResponse';
  callExists: Scalars['Boolean']['output'];
  isVideoFeatureEnabled: Scalars['Boolean']['output'];
  isVideoRecordingFeatureEnabled: Scalars['Boolean']['output'];
  recordingType?: Maybe<RecordingType>;
};

export type Captivate = {
  __typename?: 'Captivate';
  token?: Maybe<Scalars['JSON']['output']>;
};

export type CaptivateShow = {
  id: Scalars['ID']['input'];
  timeZone: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CaptivateShows = {
  __typename?: 'CaptivateShows';
  feedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  timeZone: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CaptivateUploadResponse = {
  __typename?: 'CaptivateUploadResponse';
  success: Scalars['Boolean']['output'];
};

export type CastosLoginResponse = {
  __typename?: 'CastosLoginResponse';
  isTokenValid: Scalars['Boolean']['output'];
};

export type CastosPodcast = {
  __typename?: 'CastosPodcast';
  feedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CastosPublishResponse = {
  __typename?: 'CastosPublishResponse';
  success: Scalars['Boolean']['output'];
};

export type ChangePasswordResponse = {
  __typename?: 'ChangePasswordResponse';
  reason?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ClipTimingsInput = {
  duration: Scalars['Float']['input'];
  timelineStart: Scalars['Float']['input'];
};

export type CodecFormat = {
  __typename?: 'CodecFormat';
  duration: Scalars['String']['output'];
};

export type CodecInformation = {
  __typename?: 'CodecInformation';
  format?: Maybe<CodecFormat>;
};

export type Company = {
  isVatIdValid?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  vatNumber: Scalars['String']['input'];
};

export type ConnectAlituHostResponse = {
  __typename?: 'ConnectAlituHostResponse';
  show: Podcast;
  success: Scalars['Boolean']['output'];
};

export type Countries = {
  __typename?: 'Countries';
  alpha2Code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  region: Scalars['String']['output'];
  regionalBlocs?: Maybe<Array<Maybe<RegionalBlocs>>>;
};

export type Coupon = {
  __typename?: 'Coupon';
  amount_off?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  duration_in_months?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percent_off?: Maybe<Scalars['Float']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
};

export type CreateFileResponse = {
  __typename?: 'CreateFileResponse';
  fileId: Scalars['ID']['output'];
  jobId: Scalars['ID']['output'];
};

export type CreateRecordingResponse = {
  __typename?: 'CreateRecordingResponse';
  fileId?: Maybe<Scalars['ID']['output']>;
};

export type CreateUserResponse = {
  __typename?: 'CreateUserResponse';
  session: Scalars['ID']['output'];
  show: Podcast;
  user: User;
};

export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<StripeAddress>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type CustomerTaxId = {
  __typename?: 'CustomerTaxId';
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DeleteSubdomainResponse = {
  __typename?: 'DeleteSubdomainResponse';
  success: Scalars['Boolean']['output'];
};

export type DeletedEpisodeResponse = {
  __typename?: 'DeletedEpisodeResponse';
  deletedEpisodeId: Scalars['ID']['output'];
};

export type Discount = {
  __typename?: 'Discount';
  coupon?: Maybe<Coupon>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Episode = {
  __typename?: 'Episode';
  artworkUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  file?: Maybe<File>;
  hasArtwork?: Maybe<Scalars['Boolean']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchivedVersion?: Maybe<Scalars['Boolean']['output']>;
  metaData: EpisodeMetaData;
  publishedAt?: Maybe<Scalars['String']['output']>;
  schedulePublishAt?: Maybe<Scalars['String']['output']>;
  shouldIncludeTranscriptInRss?: Maybe<Scalars['Boolean']['output']>;
  shouldSuggestDescription?: Maybe<Scalars['Boolean']['output']>;
  shouldSuggestTitle?: Maybe<Scalars['Boolean']['output']>;
  timeline: Array<EpisodeFile>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type EpisodeFile = {
  __typename?: 'EpisodeFile';
  additionalFiles?: Maybe<Array<AdditionalFile>>;
  audioTimeline?: Maybe<Array<TimelineItem>>;
  bucket?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  fade: EpisodeFileFade;
  hasMosaic: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  job?: Maybe<Job>;
  name: Scalars['String']['output'];
  overlapDuration?: Maybe<Scalars['Float']['output']>;
  tags: Array<Scalars['String']['output']>;
  trimmedDuration?: Maybe<Scalars['Float']['output']>;
  type: EpisodeFileType;
  uniqueId: Scalars['ID']['output'];
};

export type EpisodeFileFade = {
  __typename?: 'EpisodeFileFade';
  fadeVolume?: Maybe<Scalars['Float']['output']>;
  isFadingIn?: Maybe<Scalars['Boolean']['output']>;
  isFadingOut?: Maybe<Scalars['Boolean']['output']>;
};

export type EpisodeFileInput = {
  additionalFiles?: InputMaybe<Array<AdditionalFileInput>>;
  audioTimeline?: InputMaybe<Array<TimelineItemInput>>;
  fade?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  overlapDuration?: InputMaybe<Scalars['Float']['input']>;
  trimmedDuration?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uniqueId?: InputMaybe<Scalars['ID']['input']>;
};

export type EpisodeFileJob = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  schema?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export enum EpisodeFileType {
  Intro = 'intro',
  Outro = 'outro',
  Timeline = 'timeline'
}

export type EpisodeMetaData = {
  __typename?: 'EpisodeMetaData';
  description?: Maybe<Scalars['String']['output']>;
  episodeNumber?: Maybe<Scalars['Float']['output']>;
  hostNames?: Maybe<Scalars['String']['output']>;
  isExplicit?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  seasonNumber?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  type?: Maybe<EpisodeType>;
};

export type EpisodeMetaDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  episodeNumber?: InputMaybe<Scalars['Float']['input']>;
  hostNames?: InputMaybe<Scalars['String']['input']>;
  isExplicit?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['String']['input']>;
  seasonNumber?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EpisodeType>;
};

export type EpisodeStats = {
  __typename?: 'EpisodeStats';
  deletedAt?: Maybe<Scalars['Date']['output']>;
  episodeId: Scalars['ID']['output'];
  episodeNumber?: Maybe<Scalars['String']['output']>;
  forever: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  quarter: Scalars['Int']['output'];
  today: Scalars['Int']['output'];
  week: Scalars['Int']['output'];
  yesterday: Scalars['Int']['output'];
};

export enum EpisodeType {
  Bonus = 'bonus',
  Full = 'full',
  Trailer = 'trailer'
}

/** Personalisation Question asked during signup: How experienced are you with podcasting? */
export enum ExperienceLevel {
  Experienced = 'experienced',
  New = 'new'
}

export type FailedRssFeed = {
  __typename?: 'FailedRssFeed';
  error?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['ID']['output'];
};

export type File = {
  __typename?: 'File';
  aiJob?: Maybe<Job>;
  audioJob?: Maybe<Job>;
  bucket: Scalars['String']['output'];
  codecInformation: CodecInformation;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  job?: Maybe<Job>;
  metaDataJob?: Maybe<Job>;
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  transcriptionJob?: Maybe<Job>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<UserFile>>;
  videoJob?: Maybe<Job>;
};

export type FileListItem = {
  __typename?: 'FileListItem';
  audioJob?: Maybe<FileListItemAudioJob>;
  bookmarked?: Maybe<Scalars['Boolean']['output']>;
  bucket?: Maybe<Scalars['String']['output']>;
  codecInformation?: Maybe<CodecInformation>;
  createdAt: Scalars['String']['output'];
  fileCount: Scalars['Int']['output'];
  fileId?: Maybe<Scalars['ID']['output']>;
  folderId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type FileListItemAudioJob = {
  __typename?: 'FileListItemAudioJob';
  hasMosaic?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum FileType {
  Audio = 'audio',
  Video = 'video'
}

export type FilteredProjectFiles = {
  __typename?: 'FilteredProjectFiles';
  files?: Maybe<Array<File>>;
  total: Scalars['Int']['output'];
};

export type Folder = {
  __typename?: 'Folder';
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type GenerateTitlesAndSummariesResponse = {
  __typename?: 'GenerateTitlesAndSummariesResponse';
  episode: Episode;
  jobId: Scalars['ID']['output'];
};

export enum Host {
  Alitu = 'alitu',
  Buzzsprout = 'buzzsprout',
  Captivate = 'captivate',
  Castos = 'castos',
  Libsyn = 'libsyn',
  Podbean = 'podbean',
  Spreaker = 'spreaker',
  Transistor = 'transistor'
}

export type HostInput = {
  host: Host;
};

export type HostTokenResponse = {
  __typename?: 'HostTokenResponse';
  createdAt?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type HostUploadResponse = {
  __typename?: 'HostUploadResponse';
  progressKey: Scalars['ID']['output'];
  uploading: Scalars['Boolean']['output'];
};

export type HostedShow = {
  __typename?: 'HostedShow';
  hostingSuspended?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  rssFeedUrl: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type HostedShowsResponse = {
  __typename?: 'HostedShowsResponse';
  shows?: Maybe<Array<Maybe<HostedShow>>>;
  total: Scalars['Int']['output'];
};

export type HostingAveragesStatsResponse = {
  __typename?: 'HostingAveragesStatsResponse';
  dailyAverage?: Maybe<Scalars['Float']['output']>;
  monthlyAverage?: Maybe<Scalars['Float']['output']>;
  weeklyAverage?: Maybe<Scalars['Float']['output']>;
};

export type HostingCountriesResponse = {
  __typename?: 'HostingCountriesResponse';
  countriesStats?: Maybe<Scalars['JSON']['output']>;
};

export type HostingDevicesResponse = {
  __typename?: 'HostingDevicesResponse';
  allDownloads?: Maybe<Scalars['Int']['output']>;
  mobileDownloads?: Maybe<Scalars['Int']['output']>;
};

export type HostingEpisodeStatsOverviewResponse = {
  __typename?: 'HostingEpisodeStatsOverviewResponse';
  downloadsForever?: Maybe<Scalars['Int']['output']>;
  downloadsLastMonth?: Maybe<Scalars['Int']['output']>;
  downloadsLastQuarter?: Maybe<Scalars['Int']['output']>;
  downloadsLastWeek?: Maybe<Scalars['Int']['output']>;
  downloadsToday?: Maybe<Scalars['Int']['output']>;
  downloadsYesterday?: Maybe<Scalars['Int']['output']>;
};

export type HostingLimitOffender = {
  __typename?: 'HostingLimitOffender';
  hostingLimit: Scalars['Int']['output'];
  prevMonth1?: Maybe<Scalars['Int']['output']>;
  prevMonth2?: Maybe<Scalars['Int']['output']>;
  prevMonth3?: Maybe<Scalars['Int']['output']>;
  userId: Scalars['Int']['output'];
};

export type HostingOsStatsResponse = {
  __typename?: 'HostingOSStatsResponse';
  androidDownloads?: Maybe<Scalars['Int']['output']>;
  iosDownloads?: Maybe<Scalars['Int']['output']>;
  linuxDownloads?: Maybe<Scalars['Int']['output']>;
  macosDownloads?: Maybe<Scalars['Int']['output']>;
  others?: Maybe<Scalars['Int']['output']>;
  windowsDownloads?: Maybe<Scalars['Int']['output']>;
};

export type HostingStatsResponse = {
  __typename?: 'HostingStatsResponse';
  downloadsAllTime?: Maybe<Scalars['Int']['output']>;
  downloadsLastMonth?: Maybe<Scalars['Int']['output']>;
  downloadsLastQuarter?: Maybe<Scalars['Int']['output']>;
  downloadsLastWeek?: Maybe<Scalars['Int']['output']>;
  downloadsToday?: Maybe<Scalars['Int']['output']>;
  downloadsYesterday?: Maybe<Scalars['Int']['output']>;
};

export type ImportPodcastRssResponse = {
  __typename?: 'ImportPodcastRssResponse';
  success: Scalars['Boolean']['output'];
  url: PodcastUrl;
};

export type Invoice = {
  __typename?: 'Invoice';
  amount_due: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  customer_address?: Maybe<StripeAddress>;
  customer_tax_ids?: Maybe<Array<CustomerTaxId>>;
  discount?: Maybe<Discount>;
  id: Scalars['ID']['output'];
  lines: InvoiceLines;
  payment_intent?: Maybe<PaymentIntent>;
};

export type InvoiceLineData = {
  __typename?: 'InvoiceLineData';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type InvoiceLines = {
  __typename?: 'InvoiceLines';
  data?: Maybe<Array<InvoiceLineData>>;
};

export type Job = {
  __typename?: 'Job';
  createdAt: Scalars['String']['output'];
  hash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  schema: Scalars['JSON']['output'];
  status: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type JobSpec = {
  __typename?: 'JobSpec';
  assets?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  episodeId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  jobSpecHash: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
  queue?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  storeAssets?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  userId: Scalars['ID']['output'];
};

export type JoinCallResponse = {
  __typename?: 'JoinCallResponse';
  id: Scalars['ID']['output'];
  room: Scalars['ID']['output'];
  token: Scalars['ID']['output'];
};

export type LibsynPublishResponse = {
  __typename?: 'LibsynPublishResponse';
  success: Scalars['Boolean']['output'];
};

export type LibsynShow = {
  __typename?: 'LibsynShow';
  feedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type LibsynTokenRespose = {
  __typename?: 'LibsynTokenRespose';
  deleted: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['ID']['output']>;
};

export type LibsynUploadAdditional = {
  is_draft: Scalars['Boolean']['input'];
  item_body?: InputMaybe<Scalars['String']['input']>;
  item_title: Scalars['String']['input'];
  release_date: Scalars['String']['input'];
  show_id: Scalars['ID']['input'];
};

export type Log = {
  __typename?: 'Log';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobId?: Maybe<Scalars['ID']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  session: Scalars['ID']['output'];
  show: Podcast;
  subscription?: Maybe<Subscription>;
  user: User;
};

export enum MagicFilter {
  Fillers = 'fillers',
  Silences = 'silences'
}

export type Mutation = {
  __typename?: 'Mutation';
  _?: Maybe<Scalars['Boolean']['output']>;
  addAuphonicMetadata: Scalars['String']['output'];
  addCallDuration?: Maybe<Scalars['Boolean']['output']>;
  addCallTrack: Scalars['JSON']['output'];
  addFileToFolder?: Maybe<Scalars['Boolean']['output']>;
  addHosting: AddHostingResult;
  addShow: Scalars['ID']['output'];
  addSubscriptionToUser?: Maybe<Scalars['Boolean']['output']>;
  alituCancelSchedulePublish: AlituCancelSchedulePublishResponse;
  alituPublish: AlituPublishResponse;
  /** Create or update scheduled publish time for an episode. */
  alituSchedulePublish: AlituPublishResponse;
  alituUnpublish: AlituUnpublishResponse;
  alituUpdatePublishedDate: AlituUpdatePublishedDate;
  bulkDeleteFiles?: Maybe<Scalars['JSON']['output']>;
  buzzsproutLogin: SuccessResponse;
  buzzsproutLogout: Scalars['JSON']['output'];
  buzzsproutPublish: SuccessResponse;
  cancelHostingSubscription: Subscription;
  captivateLogin: Captivate;
  captivateLogout: Scalars['JSON']['output'];
  captivatePublish: CaptivateUploadResponse;
  castosLogin: CastosLoginResponse;
  castosLogout: Scalars['JSON']['output'];
  castosPublish: CastosPublishResponse;
  changePassword: ChangePasswordResponse;
  concatenateChunks: Scalars['JSON']['output'];
  connectAlituHost: ConnectAlituHostResponse;
  createApiKey: ApiKey;
  createCall: JoinCallResponse;
  createChunkUploadUrl: UploadUrlResponse;
  createCustomer: CreateCustomerResult;
  createEpisode: Episode;
  createExportClipToLibraryJob: JobSpec;
  createExportJob: JobSpec;
  createFile: CreateFileResponse;
  createFolder?: Maybe<Folder>;
  createMetaDataJob: JobSpec;
  createMusicEditorEditJob: Scalars['ID']['output'];
  createMusicEditorJob: Scalars['JSON']['output'];
  createRecording: CreateRecordingResponse;
  createRecordingUploadUrl: UploadUrlResponse;
  createSubscription: Subscription;
  createSubscriptionFromSetupIntent: Subscription;
  createUser: CreateUserResponse;
  createVideoJob: JobSpec;
  deleteAllUserData: Scalars['Boolean']['output'];
  deleteApiKey: ApiKey;
  deleteEpisode: DeletedEpisodeResponse;
  deleteFolder?: Maybe<Scalars['Boolean']['output']>;
  deleteHostToken: Podcast;
  deleteRecording?: Maybe<Scalars['Boolean']['output']>;
  deleteSubdomain: DeleteSubdomainResponse;
  deleteSubscription: Subscription;
  duplicateEpisode: Episode;
  generateTitlesAndSummaries: GenerateTitlesAndSummariesResponse;
  generateTranscription: Scalars['String']['output'];
  getRssAndPopulateBuzzsproutShowDetails: Podcast;
  getRssAndPopulatePodbeanShowDetails: Podcast;
  importPodcastRss: ImportPodcastRssResponse;
  joinCall: JoinCallResponse;
  libsynLogout: Scalars['JSON']['output'];
  libsynPublish: LibsynPublishResponse;
  linkFile: Scalars['JSON']['output'];
  login: LoginResponse;
  logout: Scalars['JSON']['output'];
  pauseRecording?: Maybe<Scalars['Boolean']['output']>;
  pauseSubscription: Subscription;
  podbeanLogout: Scalars['JSON']['output'];
  podbeanPublish: PodbeanPublishResponse;
  populateAppleClaimToken: Podcast;
  populateShowDetailsFromRss: Podcast;
  recoverDeletedFile: RecoverDeletedFileResponse;
  redirectRss: RedirectRssResponse;
  regenerateAllRssFeeds: RegenerateAllRssFeedsResponse;
  regenerateRss: RegenerateRssResponse;
  removeFile: Scalars['Boolean']['output'];
  removeFileFromFolder?: Maybe<Scalars['Boolean']['output']>;
  removeShow: RemoveShowResponse;
  renewAlituHosting: Podcast;
  renewShow: RenewShowResponse;
  renewSubscription: Subscription;
  requestResetPassword: ResetPasswordResponse;
  rerunJob: JobSpec;
  resetPassword: ChangePasswordResponse;
  splitEpisodeClip: Episode;
  spreakerLogout: Scalars['JSON']['output'];
  spreakerPublish: SpreakerPublishResponse;
  submitShowToApple?: Maybe<Podcast>;
  suspendHosting: SuspendHostingResponse;
  /** Switches the subscription plan billing interval between monthly and yearly */
  switchPlanType: Subscription;
  transistorLogin: TransistorResponse;
  transistorLogout: Scalars['JSON']['output'];
  transistorPublish: TransistorPublishResponse;
  unlinkFile: Scalars['Boolean']['output'];
  unpauseSubscription: Subscription;
  updateApiKey: ApiKey;
  updateCallLock?: Maybe<Scalars['Boolean']['output']>;
  updateContent: UpdateContentResponse;
  updateEpisode: Episode;
  updateFile: Scalars['Boolean']['output'];
  updateFolder?: Maybe<Scalars['Boolean']['output']>;
  updatePersonalisation: UpdatePersonalisationResponse;
  updatePodcast: Podcast;
  updateRecordingRules: Scalars['JSON']['output'];
  updateTranscription?: Maybe<Transcription>;
  updateTransitionDefaults: Podcast;
  updateUser: User;
  updateUserFile: Scalars['Boolean']['output'];
  /** Tells Stripe to immediately end trial */
  upgradeFromTrial: Subscription;
  uploadUrls: Array<UploadUrl>;
  validatePassword: ValidatePasswordResponse;
};


export type MutationAddAuphonicMetadataArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationAddCallDurationArgs = {
  duration: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAddCallTrackArgs = {
  callId: Scalars['ID']['input'];
  instanceId: Scalars['String']['input'];
  startTime: Scalars['Date']['input'];
};


export type MutationAddFileToFolderArgs = {
  fileId: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationAddHostingArgs = {
  hostingPlan: Scalars['String']['input'];
};


export type MutationAddShowArgs = {
  name: Scalars['String']['input'];
};


export type MutationAddSubscriptionToUserArgs = {
  customerId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAlituCancelSchedulePublishArgs = {
  episodeId: Scalars['ID']['input'];
};


export type MutationAlituPublishArgs = {
  episodeId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAlituSchedulePublishArgs = {
  episodeId: Scalars['ID']['input'];
  schedulePublishAt?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAlituUnpublishArgs = {
  episodeId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAlituUpdatePublishedDateArgs = {
  episodeId: Scalars['ID']['input'];
  publishedAt: Scalars['String']['input'];
};


export type MutationBulkDeleteFilesArgs = {
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationBuzzsproutLoginArgs = {
  podcastId: Scalars['ID']['input'];
  token: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationBuzzsproutLogoutArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationBuzzsproutPublishArgs = {
  additional: AdditionalInput;
  episodeId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCaptivateLoginArgs = {
  apiKey: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
  username: Scalars['String']['input'];
};


export type MutationCaptivateLogoutArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationCaptivatePublishArgs = {
  captivateShow: CaptivateShow;
  episodeId: Scalars['ID']['input'];
  isDraft: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCastosLoginArgs = {
  token: Scalars['ID']['input'];
};


export type MutationCastosLogoutArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationCastosPublishArgs = {
  episodeId: Scalars['ID']['input'];
  podcastId: Scalars['ID']['input'];
};


export type MutationChangePasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationConcatenateChunksArgs = {
  callId: Scalars['ID']['input'];
  instanceId: Scalars['String']['input'];
};


export type MutationCreateApiKeyArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateCallArgs = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  isSolo?: InputMaybe<Scalars['Boolean']['input']>;
  recordOnConnect: Scalars['Boolean']['input'];
  recordingType?: InputMaybe<RecordingType>;
  twilioId: Scalars['String']['input'];
};


export type MutationCreateChunkUploadUrlArgs = {
  callId: Scalars['ID']['input'];
  instanceId: Scalars['String']['input'];
  timestamp: Scalars['Date']['input'];
};


export type MutationCreateCustomerArgs = {
  address?: InputMaybe<StripeAddressParam>;
  company?: InputMaybe<Company>;
  hostingPlan?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  plan: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateEpisodeArgs = {
  metaData: EpisodeMetaDataInput;
};


export type MutationCreateExportClipToLibraryJobArgs = {
  addToEpisode?: InputMaybe<Scalars['Boolean']['input']>;
  clipTimings?: InputMaybe<ClipTimingsInput>;
  episodeId: Scalars['ID']['input'];
  exportedFilename: Scalars['String']['input'];
  uniqueId: Scalars['ID']['input'];
};


export type MutationCreateExportJobArgs = {
  episodeId: Scalars['ID']['input'];
};


export type MutationCreateFileArgs = {
  duration: Scalars['Float']['input'];
  filename: Scalars['String']['input'];
  isUniversal?: InputMaybe<Scalars['Boolean']['input']>;
  keys: Array<Scalars['ID']['input']>;
  skipAuphonic?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: Scalars['String']['input'];
};


export type MutationCreateFolderArgs = {
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationCreateMetaDataJobArgs = {
  episodeId: Scalars['ID']['input'];
  metaData: EpisodeMetaDataInput;
};


export type MutationCreateMusicEditorEditJobArgs = {
  fileId: Scalars['ID']['input'];
  timeline: Scalars['JSON']['input'];
};


export type MutationCreateMusicEditorJobArgs = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  introDuration?: InputMaybe<Scalars['Float']['input']>;
  music: Scalars['JSON']['input'];
  musicVolume?: InputMaybe<Scalars['Float']['input']>;
  outroDuration?: InputMaybe<Scalars['Float']['input']>;
  voice: Scalars['JSON']['input'];
};


export type MutationCreateRecordingArgs = {
  callId: Scalars['ID']['input'];
  duration: Scalars['Float']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateRecordingUploadUrlArgs = {
  callId: Scalars['ID']['input'];
  instanceId: Scalars['String']['input'];
};


export type MutationCreateSubscriptionArgs = {
  address?: InputMaybe<StripeAddressParam>;
  company?: InputMaybe<Company>;
  hostingPlan?: InputMaybe<Scalars['String']['input']>;
  isEuropeanUnion: Scalars['Boolean']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  plan: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  withTrial?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateSubscriptionFromSetupIntentArgs = {
  setupIntentId: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  email: Scalars['String']['input'];
  emailOptIn: Scalars['Boolean']['input'];
  marketingData?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationCreateVideoJobArgs = {
  episodeId: Scalars['ID']['input'];
};


export type MutationDeleteAllUserDataArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationDeleteApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEpisodeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFolderArgs = {
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationDeleteHostTokenArgs = {
  input: HostInput;
};


export type MutationDeleteRecordingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSubdomainArgs = {
  id: Scalars['ID']['input'];
  subdomain: Scalars['String']['input'];
};


export type MutationDeleteSubscriptionArgs = {
  isPausing?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDuplicateEpisodeArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateTitlesAndSummariesArgs = {
  episodeId: Scalars['ID']['input'];
};


export type MutationGenerateTranscriptionArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationImportPodcastRssArgs = {
  rssFeedUrl: Scalars['String']['input'];
};


export type MutationJoinCallArgs = {
  callPermalink: Scalars['ID']['input'];
  twilioId: Scalars['String']['input'];
};


export type MutationLibsynLogoutArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationLibsynPublishArgs = {
  additional: LibsynUploadAdditional;
  episodeId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationLinkFileArgs = {
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationPauseRecordingArgs = {
  id: Scalars['ID']['input'];
  paused: Scalars['Boolean']['input'];
};


export type MutationPauseSubscriptionArgs = {
  typeformFormId: Scalars['String']['input'];
  typeformResponseId: Scalars['String']['input'];
};


export type MutationPodbeanPublishArgs = {
  additional: PodbeanAdditional;
  episodeId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationPopulateAppleClaimTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationPopulateShowDetailsFromRssArgs = {
  rssFeedUrl: Scalars['String']['input'];
};


export type MutationRecoverDeletedFileArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationRedirectRssArgs = {
  rssFeedUrl: Scalars['String']['input'];
};


export type MutationRegenerateRssArgs = {
  showId: Scalars['ID']['input'];
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationRemoveFileFromFolderArgs = {
  fileId: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationRemoveShowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRenewAlituHostingArgs = {
  showId: Scalars['ID']['input'];
};


export type MutationRenewShowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRenewSubscriptionArgs = {
  paymentMethod: Scalars['String']['input'];
};


export type MutationRequestResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationRerunJobArgs = {
  jobId: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSplitEpisodeClipArgs = {
  firstFileName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  secondFileName: Scalars['String']['input'];
  splitTime: Scalars['Float']['input'];
  uniqueId: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSpreakerLogoutArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationSpreakerPublishArgs = {
  additional: SpreakerAdditionalInput;
  episodeId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSuspendHostingArgs = {
  suspensionType?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationTransistorLoginArgs = {
  token: Scalars['ID']['input'];
};


export type MutationTransistorPublishArgs = {
  episodeId: Scalars['ID']['input'];
  isDraft: Scalars['Boolean']['input'];
  showId: Scalars['ID']['input'];
};


export type MutationUnlinkFileArgs = {
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationUpdateApiKeyArgs = {
  id: Scalars['ID']['input'];
  input: ApiKeyUpdateInput;
};


export type MutationUpdateCallLockArgs = {
  id: Scalars['ID']['input'];
  locked: Scalars['Boolean']['input'];
};


export type MutationUpdateContentArgs = {
  content: Scalars['JSON']['input'];
  section: Scalars['String']['input'];
};


export type MutationUpdateEpisodeArgs = {
  artwork?: InputMaybe<ArtworkInput>;
  clearFileField?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  metaData?: InputMaybe<EpisodeMetaDataInput>;
  shouldIncludeTranscriptInRss?: InputMaybe<Scalars['Boolean']['input']>;
  shouldSuggestDescription?: InputMaybe<Scalars['Boolean']['input']>;
  shouldSuggestTitle?: InputMaybe<Scalars['Boolean']['input']>;
  timeline?: InputMaybe<Array<EpisodeFileInput>>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateFileArgs = {
  id: Scalars['ID']['input'];
  newData?: InputMaybe<UpdateFile>;
  projectId: Scalars['ID']['input'];
  removeData?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationUpdateFolderArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationUpdatePersonalisationArgs = {
  experienceLevel?: InputMaybe<ExperienceLevel>;
  heardAboutFrom?: InputMaybe<Scalars['String']['input']>;
  podcastPurpose?: InputMaybe<PodcastPurpose>;
};


export type MutationUpdatePodcastArgs = {
  adobeArtwork?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  podcast: PodcastInput;
  shouldRegenerateRssFeed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateRecordingRulesArgs = {
  callPermalink: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type MutationUpdateTranscriptionArgs = {
  fileId: Scalars['ID']['input'];
  speakerNames: Array<Scalars['String']['input']>;
};


export type MutationUpdateTransitionDefaultsArgs = {
  data: TransitionDefaultsInput;
};


export type MutationUpdateUserArgs = {
  input?: InputMaybe<UserInput>;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateUserFileArgs = {
  fileId: Scalars['ID']['input'];
  newData?: InputMaybe<UpdateUserFile>;
  userId: Scalars['ID']['input'];
};


export type MutationUploadUrlsArgs = {
  numberOfFiles: Scalars['Int']['input'];
};


export type MutationValidatePasswordArgs = {
  password: Scalars['String']['input'];
};

export type MuteItem = {
  __typename?: 'MuteItem';
  end: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  resource: Scalars['String']['output'];
  sourceStart: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
  type: TimelineItemType;
};

export type PauseCollection = {
  __typename?: 'PauseCollection';
  behaviour?: Maybe<Scalars['String']['output']>;
  resumes_at?: Maybe<Scalars['Int']['output']>;
};

export type Payload = {
  __typename?: 'Payload';
  message: Scalars['String']['output'];
  progressKey: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  client_secret: Scalars['String']['output'];
};

export type PaymentStatus = {
  __typename?: 'PaymentStatus';
  failureMessage?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type Permissions = {
  __typename?: 'Permissions';
  episodeLimit?: Maybe<Scalars['Int']['output']>;
  tier: Tier;
};

export type PodbeanAdditional = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PodbeanPublishResponse = {
  __typename?: 'PodbeanPublishResponse';
  success: Scalars['Boolean']['output'];
};

export type Podcast = {
  __typename?: 'Podcast';
  appleClaimToken?: Maybe<Scalars['String']['output']>;
  artworkUrl?: Maybe<Scalars['String']['output']>;
  autoCenterPreference?: Maybe<Scalars['Boolean']['output']>;
  autoZoomPreference?: Maybe<Scalars['Boolean']['output']>;
  bitratePreference: Scalars['Int']['output'];
  categories?: Maybe<PodcastCategories>;
  copyright?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  feedLimit?: Maybe<Scalars['Int']['output']>;
  hasAlituHosting: Scalars['Boolean']['output'];
  host?: Maybe<Host>;
  hostName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isExplicit: Scalars['Boolean']['output'];
  language?: Maybe<Scalars['String']['output']>;
  links: PodcastLinks;
  lockFeed: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  processingSettings: ProcessingSettings;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  rssFeedUrl?: Maybe<Scalars['String']['output']>;
  showExpiresAt?: Maybe<Scalars['String']['output']>;
  showHostingExpiresAt?: Maybe<Scalars['String']['output']>;
  statsUrlPrefix?: Maybe<Scalars['String']['output']>;
  subdomain?: Maybe<Scalars['String']['output']>;
  submittedThroughAppleApi?: Maybe<Scalars['Boolean']['output']>;
  thirdPartyRssFeed?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  transcriptionPreferences: TranscriptionPreferences;
  transitionDefaults?: Maybe<TransitionDefaults>;
  type?: Maybe<PodcastType>;
  url?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
  waveformPreference: WaveformPreference;
};

export type PodcastCategories = {
  __typename?: 'PodcastCategories';
  category?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  thirdCategory?: Maybe<Scalars['String']['output']>;
};

/** To remove a podcast field, explicitly set it to null. */
export type PodcastInput = {
  /** Upload key passed from the presigned URL upload. This is used to identify the file in the Ingress bucket. */
  artworkUploadKey?: InputMaybe<Scalars['String']['input']>;
  autoCenterPreference?: InputMaybe<Scalars['Boolean']['input']>;
  autoZoomPreference?: InputMaybe<Scalars['Boolean']['input']>;
  bitratePreference?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  /** Pass 'true' to delete podcast artwork */
  deleteArtwork?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  feedLimit?: InputMaybe<Scalars['Int']['input']>;
  hostName?: InputMaybe<Scalars['String']['input']>;
  isExplicit?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<PodcastLinksInput>;
  lockFeed?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  processingSettings?: InputMaybe<ProcessingSettingsInput>;
  statsUrlPrefix?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  thirdCategory?: InputMaybe<Scalars['String']['input']>;
  thirdPartyRssFeed?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  transcriptionLanguage?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PodcastType>;
  url?: InputMaybe<Scalars['String']['input']>;
  waveformPreference?: InputMaybe<Scalars['String']['input']>;
};

export type PodcastLinks = {
  __typename?: 'PodcastLinks';
  alituBadge?: Maybe<Scalars['Boolean']['output']>;
  apple?: Maybe<Scalars['String']['output']>;
  deezer?: Maybe<Scalars['String']['output']>;
  facebookGroup?: Maybe<Scalars['String']['output']>;
  facebookPage?: Maybe<Scalars['String']['output']>;
  iHeartRadio?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  pandora?: Maybe<Scalars['String']['output']>;
  spotify?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type PodcastLinksInput = {
  alituBadge?: InputMaybe<Scalars['Boolean']['input']>;
  apple?: InputMaybe<Scalars['String']['input']>;
  deezer?: InputMaybe<Scalars['String']['input']>;
  facebookGroup?: InputMaybe<Scalars['String']['input']>;
  facebookPage?: InputMaybe<Scalars['String']['input']>;
  iHeartRadio?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  pandora?: InputMaybe<Scalars['String']['input']>;
  spotify?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

/** Personalisation Question asked during signup: What is your podcast for? */
export enum PodcastPurpose {
  Business = 'business',
  Cause = 'cause',
  Employer = 'employer',
  Hobby = 'hobby'
}

export enum PodcastType {
  Episodic = 'episodic',
  Serial = 'serial'
}

export type PodcastUrl = {
  __typename?: 'PodcastUrl';
  rss: Scalars['String']['output'];
};

export type ProcessingSettings = {
  __typename?: 'ProcessingSettings';
  bgNoiseRemoval: Scalars['Boolean']['output'];
  removeBreathings: Scalars['Boolean']['output'];
  voiceAutoEq: Scalars['Boolean']['output'];
};

export type ProcessingSettingsInput = {
  bgNoiseRemoval: Scalars['Boolean']['input'];
  removeBreathings: Scalars['Boolean']['input'];
  voiceAutoEq: Scalars['Boolean']['input'];
};

export type Project = {
  __typename?: 'Project';
  categories?: Maybe<ProjectCategories>;
  description?: Maybe<Scalars['String']['output']>;
  feedLimit?: Maybe<Scalars['Int']['output']>;
  hasAlituHosting: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isExplicit?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  processingSettings: ProcessingSettings;
  showExpiresAt?: Maybe<Scalars['String']['output']>;
  slug: Scalars['Int']['output'];
  subdomain?: Maybe<Scalars['String']['output']>;
  transitionDefaults?: Maybe<TransitionDefaults>;
  type?: Maybe<ProjectType>;
  url?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type ProjectCategories = {
  __typename?: 'ProjectCategories';
  category?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  thirdCategory?: Maybe<Scalars['String']['output']>;
};

export type ProjectFilesAndFolders = {
  __typename?: 'ProjectFilesAndFolders';
  files?: Maybe<Array<FileListItem>>;
  total: Scalars['Int']['output'];
};

export enum ProjectType {
  Episodic = 'episodic',
  Serial = 'serial'
}

export type PromoCode = {
  __typename?: 'PromoCode';
  amount_off?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  duration_in_months?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  percent_off?: Maybe<Scalars['Float']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  trial_days?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  _?: Maybe<Scalars['Boolean']['output']>;
  alituEpisodesCountPerShow: Scalars['Int']['output'];
  alituHostedShows?: Maybe<HostedShowsResponse>;
  allJobs?: Maybe<Array<Job>>;
  allLogs?: Maybe<Array<Log>>;
  assumeUser: AssumeUser;
  billingPortal: Scalars['String']['output'];
  buzzsproutAccessToken: Scalars['JSON']['output'];
  call?: Maybe<Call>;
  callExists: CallExistsResponse;
  captivateCredentials: Captivate;
  captivateShows?: Maybe<Array<CaptivateShows>>;
  captivateUploadProgress?: Maybe<Array<Log>>;
  castosPodcasts: Array<CastosPodcast>;
  checkAppleShowStatus?: Maybe<AppleShowStatus>;
  checkSubdomain?: Maybe<SubdomainRecord>;
  countries?: Maybe<Array<Countries>>;
  customer: Customer;
  episode: Episode;
  episodeJob: Job;
  episodeJobs?: Maybe<Array<Job>>;
  episodes: Array<Episode>;
  episodesCount: Scalars['Int']['output'];
  episodesCountPerUser: Scalars['Int']['output'];
  file?: Maybe<File>;
  getApiKeys: Array<ApiKey>;
  getAppsStats: Array<AppStat>;
  getCallCreator?: Maybe<Call>;
  getCountriesStats: HostingCountriesResponse;
  getDefaultMusic?: Maybe<File>;
  getDevicesStats: HostingDevicesResponse;
  getEpisodeDownloadsOverviewStats: HostingEpisodeStatsOverviewResponse;
  getEpisodeStats: HostingStatsResponse;
  getFolders?: Maybe<Array<Maybe<Folder>>>;
  getHostsLatestLog?: Maybe<Log>;
  getLibsynShows: Array<LibsynShow>;
  getLibsynToken: LibsynTokenRespose;
  getOSStats: HostingOsStatsResponse;
  getPaymentMethods?: Maybe<Array<Scalars['JSON']['output']>>;
  getPodbeanToken: Token;
  getPodcastAveragesStats: HostingAveragesStatsResponse;
  getPodcastStats: HostingStatsResponse;
  getProjectFiles: FilteredProjectFiles;
  getProjectFilesAndFolders: ProjectFilesAndFolders;
  getRecordingRules: Scalars['String']['output'];
  getShowDetailsStats: ShowDetailsStatsResult;
  getSpreakerShows: Array<SpreakerShow>;
  getSpreakerToken: Scalars['JSON']['output'];
  getTranscriptionUsageAndLimit?: Maybe<TranscriptionUsageAndLimitResponse>;
  getUserFiles: Array<Maybe<File>>;
  getUserFilesForAdmin: Array<Maybe<AdminFile>>;
  host?: Maybe<Host>;
  hostToken?: Maybe<HostTokenResponse>;
  hostingLimitOffenders?: Maybe<Array<Maybe<HostingLimitOffender>>>;
  job: Job;
  jobLogs?: Maybe<Array<Log>>;
  libsynUploadAssetProgress?: Maybe<Array<Log>>;
  permissions?: Maybe<Permissions>;
  project: Project;
  projectFileDownload: Scalars['String']['output'];
  projects?: Maybe<Array<Project>>;
  promoCode?: Maybe<PromoCode>;
  show: Podcast;
  shows: Array<Podcast>;
  signupPageContent?: Maybe<SignupPageContent>;
  subscription: Subscription;
  subscriptionPrice: SubscriptionPrice;
  tax: SubscriptionTax;
  transcription?: Maybe<Transcription>;
  transcriptionSpeakerNames?: Maybe<SpeakerNames>;
  transcriptionStatus?: Maybe<Scalars['String']['output']>;
  transistorShows?: Maybe<Array<TransistorShow>>;
  universalFiles: UniversalFilesResponse;
  upcomingInvoice?: Maybe<UpcomingInvoice>;
  uploadBuzzsproutAssetProgress: Array<Log>;
  uploadPodbeanAssetProgress: Array<Log>;
  uploadSpreakerAssetProgress?: Maybe<Array<Log>>;
  user: User;
  users?: Maybe<Array<User>>;
};


export type QueryAlituHostedShowsArgs = {
  limit: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllJobsArgs = {
  hasFailed?: InputMaybe<Scalars['Boolean']['input']>;
  isRunning?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryAllLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
};


export type QueryAssumeUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryBuzzsproutAccessTokenArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryCallArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCallExistsArgs = {
  callPermalink: Scalars['ID']['input'];
};


export type QueryCaptivateCredentialsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryCaptivateShowsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryCaptivateUploadProgressArgs = {
  progressKey: Scalars['String']['input'];
};


export type QueryCheckAppleShowStatusArgs = {
  appleShowId: Scalars['String']['input'];
};


export type QueryCheckSubdomainArgs = {
  subdomain: Scalars['String']['input'];
};


export type QueryEpisodeArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEpisodeJobArgs = {
  episodeId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryEpisodeJobsArgs = {
  episodeId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryEpisodesArgs = {
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  jobStatus?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEpisodesCountArgs = {
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  jobStatus?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFileArgs = {
  id: Scalars['ID']['input'];
  isUniversal?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
};


export type QueryGetAppsStatsArgs = {
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCallCreatorArgs = {
  callPermalink: Scalars['ID']['input'];
};


export type QueryGetCountriesStatsArgs = {
  period: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryGetDefaultMusicArgs = {
  projectId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type QueryGetDevicesStatsArgs = {
  period: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryGetEpisodeDownloadsOverviewStatsArgs = {
  episodeId: Scalars['ID']['input'];
};


export type QueryGetEpisodeStatsArgs = {
  episodeId: Scalars['ID']['input'];
};


export type QueryGetHostsLatestLogArgs = {
  host: Scalars['String']['input'];
  jobId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryGetLibsynTokenArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetOsStatsArgs = {
  period: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryGetPodcastAveragesStatsArgs = {
  period: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryGetPodcastStatsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryGetProjectFilesArgs = {
  limit: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProjectFilesAndFoldersArgs = {
  folderId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRecordingRulesArgs = {
  callPermalink: Scalars['ID']['input'];
};


export type QueryGetShowDetailsStatsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  order: Scalars['String']['input'];
};


export type QueryGetSpreakerShowsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetSpreakerTokenArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetUserFilesArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryGetUserFilesForAdminArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryHostTokenArgs = {
  input: HostInput;
};


export type QueryJobArgs = {
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryJobLogsArgs = {
  jobId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryLibsynUploadAssetProgressArgs = {
  progressKey: Scalars['ID']['input'];
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectFileDownloadArgs = {
  fileId: Scalars['ID']['input'];
  filename?: InputMaybe<Scalars['String']['input']>;
  isVideo?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryProjectsArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryPromoCodeArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  planType: Scalars['String']['input'];
  promoCode: Scalars['String']['input'];
};


export type QueryShowArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySubscriptionPriceArgs = {
  countryCode: Scalars['String']['input'];
  hostingPlan?: InputMaybe<Scalars['String']['input']>;
  planType: Scalars['String']['input'];
};


export type QueryTaxArgs = {
  countryCode: Scalars['String']['input'];
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTranscriptionArgs = {
  fileId: Scalars['ID']['input'];
};


export type QueryTranscriptionSpeakerNamesArgs = {
  fileId: Scalars['ID']['input'];
};


export type QueryTranscriptionStatusArgs = {
  fileId: Scalars['ID']['input'];
};


export type QueryUniversalFilesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
};


export type QueryUploadBuzzsproutAssetProgressArgs = {
  progressKey: Scalars['ID']['input'];
};


export type QueryUploadPodbeanAssetProgressArgs = {
  progressKey: Scalars['ID']['input'];
};


export type QueryUploadSpreakerAssetProgressArgs = {
  progressKey: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum RecordingType {
  Audio = 'audio',
  AudioVideo = 'audioVideo'
}

export type RecoverDeletedFileResponse = {
  __typename?: 'RecoverDeletedFileResponse';
  success: Scalars['Boolean']['output'];
};

export type RedirectRssResponse = {
  __typename?: 'RedirectRssResponse';
  success: Scalars['Boolean']['output'];
};

export type RegenerateAllRssFeedsResponse = {
  __typename?: 'RegenerateAllRssFeedsResponse';
  failed: Array<FailedRssFeed>;
  updated: Array<UpdatedRssFeed>;
};

export type RegenerateRssResponse = {
  __typename?: 'RegenerateRssResponse';
  success: Scalars['Boolean']['output'];
};

export type RegionalBlocs = {
  __typename?: 'RegionalBlocs';
  name?: Maybe<Scalars['String']['output']>;
};

export type RemoveShowResponse = {
  __typename?: 'RemoveShowResponse';
  success: Scalars['Boolean']['output'];
};

export type RemovedAudioItem = {
  __typename?: 'RemovedAudioItem';
  duration: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  magicFilter?: Maybe<MagicFilter>;
  resource: Scalars['String']['output'];
  sourceStart: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
  type: TimelineItemType;
};

export type RenewShowResponse = {
  __typename?: 'RenewShowResponse';
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordResponse = {
  __typename?: 'ResetPasswordResponse';
  success: Scalars['Boolean']['output'];
};

export type ShowDetailsStatsResult = {
  __typename?: 'ShowDetailsStatsResult';
  episodeStats: Array<EpisodeStats>;
  total: Scalars['Int']['output'];
};

export type SignupPageContent = {
  __typename?: 'SignupPageContent';
  mainTitle?: Maybe<Scalars['String']['output']>;
  sidebarContent?: Maybe<Scalars['String']['output']>;
};

export type SilenceItem = {
  __typename?: 'SilenceItem';
  end: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  start: Scalars['Float']['output'];
  type: TimelineItemType;
};

export type SpeakerNames = {
  __typename?: 'SpeakerNames';
  fileId?: Maybe<Scalars['ID']['output']>;
  speakerNames?: Maybe<Array<Scalars['String']['output']>>;
};

export type SpreakerAdditionalInput = {
  showId: Scalars['ID']['input'];
};

export type SpreakerPublishResponse = {
  __typename?: 'SpreakerPublishResponse';
  success: Scalars['Boolean']['output'];
};

export type SpreakerShow = {
  __typename?: 'SpreakerShow';
  feedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type StripeAddress = {
  __typename?: 'StripeAddress';
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type StripeAddressParam = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type SubdomainRecord = {
  __typename?: 'SubdomainRecord';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  cancel_at_period_end: Scalars['Boolean']['output'];
  currency: Scalars['String']['output'];
  current_period_end: Scalars['Int']['output'];
  discount?: Maybe<Discount>;
  hasAlreadyPaused: Scalars['Boolean']['output'];
  hostingExpiresAt?: Maybe<Scalars['String']['output']>;
  hostingLimit: Scalars['Int']['output'];
  hostingSuspended?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latest_invoice?: Maybe<Invoice>;
  metadata?: Maybe<SubscriptionMetaData>;
  pause_collection?: Maybe<PauseCollection>;
  pending_setup_intent?: Maybe<Scalars['String']['output']>;
  plans?: Maybe<Array<SubscriptionPlan>>;
  status: Scalars['String']['output'];
  trial_end?: Maybe<Scalars['Int']['output']>;
  trial_start?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionMetaData = {
  __typename?: 'SubscriptionMetaData';
  countryCode?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  interval: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  tax_rates?: Maybe<Array<Maybe<SubscriptionPlanTaxRate>>>;
  trial_period_days?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionPlanTaxRate = {
  __typename?: 'SubscriptionPlanTaxRate';
  id?: Maybe<Scalars['ID']['output']>;
};

export type SubscriptionPrice = {
  __typename?: 'SubscriptionPrice';
  currency: Scalars['String']['output'];
  price: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type SubscriptionTax = {
  __typename?: 'SubscriptionTax';
  percentage: Scalars['Float']['output'];
  taxId: Scalars['String']['output'];
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  success: Scalars['Boolean']['output'];
};

export type SuspendHostingResponse = {
  __typename?: 'SuspendHostingResponse';
  success: Scalars['Boolean']['output'];
};

/** The status of the user account */
export enum Tier {
  /** The user is logged out */
  None = 'none',
  /** The user has supplied card details and is on a free trial */
  Trial = 'trial',
  /** The user created an account but has not yet created a subscription */
  TrialSignupIncomplete = 'trialSignupIncomplete',
  /** The user is an active paying customer */
  Unlimited = 'unlimited'
}

export type TimelineItem = AudioItem | BackgroundItem | BleepItem | MuteItem | RemovedAudioItem | SilenceItem;

export type TimelineItemInput = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  fadeInDuration?: InputMaybe<Scalars['Float']['input']>;
  fadeOutDuration?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  magicFilter?: InputMaybe<MagicFilter>;
  resource?: InputMaybe<Scalars['String']['input']>;
  sourceStart?: InputMaybe<Scalars['Float']['input']>;
  start: Scalars['Float']['input'];
  type: TimelineItemType;
  volume?: InputMaybe<Scalars['Float']['input']>;
};

export enum TimelineItemType {
  Audio = 'audio',
  Background = 'background',
  Bleep = 'bleep',
  Mute = 'mute',
  RemovedAudio = 'removedAudio',
  Silence = 'silence'
}

export type Token = {
  __typename?: 'Token';
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type Transcription = {
  __typename?: 'Transcription';
  createdAt: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  fileId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  speakerNames?: Maybe<Array<Scalars['String']['output']>>;
  status: Scalars['String']['output'];
};

export type TranscriptionPreferences = {
  __typename?: 'TranscriptionPreferences';
  language?: Maybe<Scalars['String']['output']>;
};

export type TranscriptionUsageAndLimitResponse = {
  __typename?: 'TranscriptionUsageAndLimitResponse';
  limit: Scalars['Float']['output'];
  usage: Scalars['Float']['output'];
};

export type TransistorPublishResponse = {
  __typename?: 'TransistorPublishResponse';
  success: Scalars['Boolean']['output'];
};

export type TransistorResponse = {
  __typename?: 'TransistorResponse';
  isTokenValid: Scalars['Boolean']['output'];
};

export type TransistorShow = {
  __typename?: 'TransistorShow';
  description: Scalars['String']['output'];
  /** feedUrl is optional because private shows do not have feed url */
  feedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type TransitionDefaultIntro = {
  __typename?: 'TransitionDefaultIntro';
  fadeVolume?: Maybe<Scalars['Float']['output']>;
  isFadingOut?: Maybe<Scalars['Boolean']['output']>;
  overlap?: Maybe<Scalars['Float']['output']>;
};

export type TransitionDefaultIntroInput = {
  fadeVolume?: InputMaybe<Scalars['Float']['input']>;
  isFadingOut?: InputMaybe<Scalars['Boolean']['input']>;
  overlap?: InputMaybe<Scalars['Float']['input']>;
};

export type TransitionDefaultOutro = {
  __typename?: 'TransitionDefaultOutro';
  fadeVolume?: Maybe<Scalars['Float']['output']>;
  isFadingIn?: Maybe<Scalars['Boolean']['output']>;
  overlap?: Maybe<Scalars['Float']['output']>;
};

export type TransitionDefaultOutroInput = {
  fadeVolume?: InputMaybe<Scalars['Float']['input']>;
  isFadingIn?: InputMaybe<Scalars['Boolean']['input']>;
  overlap?: InputMaybe<Scalars['Float']['input']>;
};

export type TransitionDefaults = {
  __typename?: 'TransitionDefaults';
  intro?: Maybe<TransitionDefaultIntro>;
  outro?: Maybe<TransitionDefaultOutro>;
};

export type TransitionDefaultsInput = {
  intro?: InputMaybe<TransitionDefaultIntroInput>;
  outro?: InputMaybe<TransitionDefaultOutroInput>;
};

export type UniversalFile = {
  __typename?: 'UniversalFile';
  duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAddedToLibrary: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  users?: Maybe<Scalars['JSON']['output']>;
};

export type UniversalFilesCategory = {
  __typename?: 'UniversalFilesCategory';
  files: Array<UniversalFile>;
  name: Scalars['String']['output'];
  previewFile?: Maybe<Scalars['JSON']['output']>;
};

export type UniversalFilesResponse = {
  __typename?: 'UniversalFilesResponse';
  categories: Array<UniversalFilesCategory>;
  total: Scalars['Int']['output'];
};

export type UpcomingInvoice = {
  __typename?: 'UpcomingInvoice';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type UpdateContentResponse = {
  __typename?: 'UpdateContentResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateFile = {
  aiJobId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<FileType>;
  use?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserFile = {
  bookmarked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatedRssFeed = {
  __typename?: 'UpdatedRssFeed';
  projectId: Scalars['ID']['output'];
};

export type UploadUrl = {
  __typename?: 'UploadUrl';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type UploadUrlResponse = {
  __typename?: 'UploadUrlResponse';
  url: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  activeProjectId: Scalars['ID']['output'];
  address?: Maybe<Scalars['String']['output']>;
  autoCenterPreference: Scalars['Boolean']['output'];
  autoZoomPreference: Scalars['Boolean']['output'];
  bitratePreference: Scalars['Int']['output'];
  callPermalink: Scalars['ID']['output'];
  company?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailOptIn: Scalars['Boolean']['output'];
  experienceLevel?: Maybe<ExperienceLevel>;
  firstName: Scalars['String']['output'];
  heardAboutFrom?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAuthenticated?: Maybe<Scalars['Boolean']['output']>;
  isTester: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  marketingData?: Maybe<Scalars['JSON']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  podcastPurpose?: Maybe<PodcastPurpose>;
  role: Scalars['String']['output'];
  session: Scalars['String']['output'];
  transcriptionPreferences: TranscriptionPreferences;
  waveformPreference: WaveformPreference;
};

export type UserFile = {
  __typename?: 'UserFile';
  userFile: Scalars['JSON']['output'];
};

export type UserInput = {
  activeProjectId?: InputMaybe<Scalars['ID']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  autoCenterPreference?: InputMaybe<Scalars['Boolean']['input']>;
  autoZoomPreference?: InputMaybe<Scalars['Boolean']['input']>;
  bitratePreference?: InputMaybe<Scalars['Int']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isTester?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingData?: InputMaybe<Scalars['JSON']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  transcriptionLanguage?: InputMaybe<Scalars['String']['input']>;
  waveformPreference?: InputMaybe<Scalars['String']['input']>;
};

export type UsersInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ValidatePasswordResponse = {
  __typename?: 'ValidatePasswordResponse';
  reason?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** How the waveform should be drawn in Alitu Waves */
export enum WaveformPreference {
  /** Draw the waveform in full detail */
  Pro = 'pro',
  /** Draw the waveform as simplified bars */
  Simple = 'simple'
}

export type CreateCustomerResult = {
  __typename?: 'createCustomerResult';
  clientSecret: Scalars['String']['output'];
  setupIntentId: Scalars['String']['output'];
};

export type IsAuthenticatedResponse = {
  __typename?: 'isAuthenticatedResponse';
  isAuthenticated: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type UpdatePersonalisationResponse = {
  __typename?: 'updatePersonalisationResponse';
  user: User;
};

export type ApiKeyFragment = { __typename?: 'ApiKey', id: string, name: string, createdAt: any };

export type CreatedApiKeyFragment = { __typename?: 'ApiKey', id: string, apiKeyValue: string, name: string, createdAt: any };

export type GetApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApiKeysQuery = { __typename?: 'Query', getApiKeys: Array<{ __typename?: 'ApiKey', id: string, name: string, createdAt: any }> };

export type CreateApiKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createApiKey: { __typename?: 'ApiKey', id: string, apiKeyValue: string, name: string, createdAt: any } };

export type UpdateApiKeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ApiKeyUpdateInput;
}>;


export type UpdateApiKeyMutation = { __typename?: 'Mutation', updateApiKey: { __typename?: 'ApiKey', id: string, name: string, createdAt: any } };

export type DeleteAPiKeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAPiKeyMutation = { __typename?: 'Mutation', deleteApiKey: { __typename?: 'ApiKey', id: string, name: string, createdAt: any } };

export type CreateMetaDataJobMutationVariables = Exact<{
  episodeId: Scalars['ID']['input'];
  metaData: EpisodeMetaDataInput;
}>;


export type CreateMetaDataJobMutation = { __typename?: 'Mutation', createMetaDataJob: { __typename?: 'JobSpec', id: string } };

export type ShowFragmentFragment = { __typename?: 'Podcast', id: string, name?: string | null, description?: string | null, language?: string | null, feedLimit?: number | null, isExplicit: boolean, type?: PodcastType | null, email?: string | null, hostName?: string | null, timeZone?: string | null, lockFeed: boolean, statsUrlPrefix?: string | null, hasAlituHosting: boolean, userId: string, showExpiresAt?: string | null, artworkUrl?: string | null, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference?: boolean | null, autoCenterPreference?: boolean | null, copyright?: string | null, subdomain?: string | null, showHostingExpiresAt?: string | null, rssFeedUrl?: string | null, redirectUrl?: string | null, host?: Host | null, thirdPartyRssFeed?: string | null, appleClaimToken?: string | null, submittedThroughAppleApi?: boolean | null, categories?: { __typename?: 'PodcastCategories', category?: string | null, subcategory?: string | null, thirdCategory?: string | null } | null, transitionDefaults?: { __typename?: 'TransitionDefaults', intro?: { __typename?: 'TransitionDefaultIntro', overlap?: number | null, fadeVolume?: number | null, isFadingOut?: boolean | null } | null, outro?: { __typename?: 'TransitionDefaultOutro', overlap?: number | null, fadeVolume?: number | null, isFadingIn?: boolean | null } | null } | null, processingSettings: { __typename?: 'ProcessingSettings', voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean }, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null }, links: { __typename?: 'PodcastLinks', apple?: string | null, spotify?: string | null, alituBadge?: boolean | null, facebookPage?: string | null, facebookGroup?: string | null, twitter?: string | null, instagram?: string | null, linkedin?: string | null, youtube?: string | null, website?: string | null, pandora?: string | null, iHeartRadio?: string | null, deezer?: string | null } };

export type ShowQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ShowQuery = { __typename?: 'Query', show: { __typename?: 'Podcast', id: string, name?: string | null, description?: string | null, language?: string | null, feedLimit?: number | null, isExplicit: boolean, type?: PodcastType | null, email?: string | null, hostName?: string | null, timeZone?: string | null, lockFeed: boolean, statsUrlPrefix?: string | null, hasAlituHosting: boolean, userId: string, showExpiresAt?: string | null, artworkUrl?: string | null, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference?: boolean | null, autoCenterPreference?: boolean | null, copyright?: string | null, subdomain?: string | null, showHostingExpiresAt?: string | null, rssFeedUrl?: string | null, redirectUrl?: string | null, host?: Host | null, thirdPartyRssFeed?: string | null, appleClaimToken?: string | null, submittedThroughAppleApi?: boolean | null, categories?: { __typename?: 'PodcastCategories', category?: string | null, subcategory?: string | null, thirdCategory?: string | null } | null, transitionDefaults?: { __typename?: 'TransitionDefaults', intro?: { __typename?: 'TransitionDefaultIntro', overlap?: number | null, fadeVolume?: number | null, isFadingOut?: boolean | null } | null, outro?: { __typename?: 'TransitionDefaultOutro', overlap?: number | null, fadeVolume?: number | null, isFadingIn?: boolean | null } | null } | null, processingSettings: { __typename?: 'ProcessingSettings', voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean }, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null }, links: { __typename?: 'PodcastLinks', apple?: string | null, spotify?: string | null, alituBadge?: boolean | null, facebookPage?: string | null, facebookGroup?: string | null, twitter?: string | null, instagram?: string | null, linkedin?: string | null, youtube?: string | null, website?: string | null, pandora?: string | null, iHeartRadio?: string | null, deezer?: string | null } } };

export type UpdateTransitionDefaultsMutationVariables = Exact<{
  data: TransitionDefaultsInput;
}>;


export type UpdateTransitionDefaultsMutation = { __typename?: 'Mutation', updateTransitionDefaults: { __typename?: 'Podcast', id: string, name?: string | null, description?: string | null, language?: string | null, feedLimit?: number | null, isExplicit: boolean, type?: PodcastType | null, email?: string | null, hostName?: string | null, timeZone?: string | null, lockFeed: boolean, statsUrlPrefix?: string | null, hasAlituHosting: boolean, userId: string, showExpiresAt?: string | null, artworkUrl?: string | null, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference?: boolean | null, autoCenterPreference?: boolean | null, copyright?: string | null, subdomain?: string | null, showHostingExpiresAt?: string | null, rssFeedUrl?: string | null, redirectUrl?: string | null, host?: Host | null, thirdPartyRssFeed?: string | null, appleClaimToken?: string | null, submittedThroughAppleApi?: boolean | null, categories?: { __typename?: 'PodcastCategories', category?: string | null, subcategory?: string | null, thirdCategory?: string | null } | null, transitionDefaults?: { __typename?: 'TransitionDefaults', intro?: { __typename?: 'TransitionDefaultIntro', overlap?: number | null, fadeVolume?: number | null, isFadingOut?: boolean | null } | null, outro?: { __typename?: 'TransitionDefaultOutro', overlap?: number | null, fadeVolume?: number | null, isFadingIn?: boolean | null } | null } | null, processingSettings: { __typename?: 'ProcessingSettings', voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean }, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null }, links: { __typename?: 'PodcastLinks', apple?: string | null, spotify?: string | null, alituBadge?: boolean | null, facebookPage?: string | null, facebookGroup?: string | null, twitter?: string | null, instagram?: string | null, linkedin?: string | null, youtube?: string | null, website?: string | null, pandora?: string | null, iHeartRadio?: string | null, deezer?: string | null } } };

export type RenewAlituHostingMutationVariables = Exact<{
  showId: Scalars['ID']['input'];
}>;


export type RenewAlituHostingMutation = { __typename?: 'Mutation', renewAlituHosting: { __typename?: 'Podcast', id: string, name?: string | null, description?: string | null, language?: string | null, feedLimit?: number | null, isExplicit: boolean, type?: PodcastType | null, email?: string | null, hostName?: string | null, timeZone?: string | null, lockFeed: boolean, statsUrlPrefix?: string | null, hasAlituHosting: boolean, userId: string, showExpiresAt?: string | null, artworkUrl?: string | null, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference?: boolean | null, autoCenterPreference?: boolean | null, copyright?: string | null, subdomain?: string | null, showHostingExpiresAt?: string | null, rssFeedUrl?: string | null, redirectUrl?: string | null, host?: Host | null, thirdPartyRssFeed?: string | null, appleClaimToken?: string | null, submittedThroughAppleApi?: boolean | null, categories?: { __typename?: 'PodcastCategories', category?: string | null, subcategory?: string | null, thirdCategory?: string | null } | null, transitionDefaults?: { __typename?: 'TransitionDefaults', intro?: { __typename?: 'TransitionDefaultIntro', overlap?: number | null, fadeVolume?: number | null, isFadingOut?: boolean | null } | null, outro?: { __typename?: 'TransitionDefaultOutro', overlap?: number | null, fadeVolume?: number | null, isFadingIn?: boolean | null } | null } | null, processingSettings: { __typename?: 'ProcessingSettings', voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean }, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null }, links: { __typename?: 'PodcastLinks', apple?: string | null, spotify?: string | null, alituBadge?: boolean | null, facebookPage?: string | null, facebookGroup?: string | null, twitter?: string | null, instagram?: string | null, linkedin?: string | null, youtube?: string | null, website?: string | null, pandora?: string | null, iHeartRadio?: string | null, deezer?: string | null } } };

export type GetSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionQuery = { __typename?: 'Query', subscription: { __typename?: 'Subscription', id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end?: number | null, trial_start?: number | null, hostingExpiresAt?: string | null, hostingSuspended?: string | null, hostingLimit: number, hasAlreadyPaused: boolean, metadata?: { __typename?: 'SubscriptionMetaData', countryCode?: string | null } | null, plans?: Array<{ __typename?: 'SubscriptionPlan', nickname: string, amount: number, interval: string, currency: string }> | null, pause_collection?: { __typename?: 'PauseCollection', resumes_at?: number | null } | null, discount?: { __typename?: 'Discount', id?: string | null, coupon?: { __typename?: 'Coupon', id?: string | null, percent_off?: number | null, amount_off?: number | null, duration?: string | null, duration_in_months?: number | null } | null } | null } };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, email: string, session: string, address?: string | null, phone?: string | null, company?: string | null, role: string, isAuthenticated?: boolean | null, isTester: boolean, activeProjectId: string, callPermalink: string, emailOptIn: boolean, experienceLevel?: ExperienceLevel | null, podcastPurpose?: PodcastPurpose | null, heardAboutFrom?: string | null, createdAt: string, marketingData?: any | null, autoZoomPreference: boolean, autoCenterPreference: boolean, waveformPreference: WaveformPreference, bitratePreference: number, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null } } };

export type UploadUrlsMutationVariables = Exact<{
  numberOfFiles: Scalars['Int']['input'];
}>;


export type UploadUrlsMutation = { __typename?: 'Mutation', uploadUrls: Array<{ __typename?: 'UploadUrl', id: string, url: string }> };

export type CreateFileMutationVariables = Exact<{
  keys: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  type: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  skipAuphonic?: InputMaybe<Scalars['Boolean']['input']>;
  isUniversal?: InputMaybe<Scalars['Boolean']['input']>;
  duration: Scalars['Float']['input'];
}>;


export type CreateFileMutation = { __typename?: 'Mutation', createFile: { __typename?: 'CreateFileResponse', fileId: string, jobId: string } };

export type PermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PermissionsQuery = { __typename?: 'Query', permissions?: { __typename?: 'Permissions', tier: Tier, episodeLimit?: number | null } | null };

export type ShowsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShowsQuery = { __typename?: 'Query', shows: Array<{ __typename?: 'Podcast', id: string, name?: string | null, description?: string | null, language?: string | null, feedLimit?: number | null, isExplicit: boolean, type?: PodcastType | null, email?: string | null, hostName?: string | null, timeZone?: string | null, lockFeed: boolean, statsUrlPrefix?: string | null, hasAlituHosting: boolean, userId: string, showExpiresAt?: string | null, artworkUrl?: string | null, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference?: boolean | null, autoCenterPreference?: boolean | null, copyright?: string | null, subdomain?: string | null, showHostingExpiresAt?: string | null, rssFeedUrl?: string | null, redirectUrl?: string | null, host?: Host | null, thirdPartyRssFeed?: string | null, appleClaimToken?: string | null, submittedThroughAppleApi?: boolean | null, categories?: { __typename?: 'PodcastCategories', category?: string | null, subcategory?: string | null, thirdCategory?: string | null } | null, transitionDefaults?: { __typename?: 'TransitionDefaults', intro?: { __typename?: 'TransitionDefaultIntro', overlap?: number | null, fadeVolume?: number | null, isFadingOut?: boolean | null } | null, outro?: { __typename?: 'TransitionDefaultOutro', overlap?: number | null, fadeVolume?: number | null, isFadingIn?: boolean | null } | null } | null, processingSettings: { __typename?: 'ProcessingSettings', voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean }, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null }, links: { __typename?: 'PodcastLinks', apple?: string | null, spotify?: string | null, alituBadge?: boolean | null, facebookPage?: string | null, facebookGroup?: string | null, twitter?: string | null, instagram?: string | null, linkedin?: string | null, youtube?: string | null, website?: string | null, pandora?: string | null, iHeartRadio?: string | null, deezer?: string | null } }> };

export type AddShowMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type AddShowMutation = { __typename?: 'Mutation', addShow: string };

export type RemoveShowMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveShowMutation = { __typename?: 'Mutation', removeShow: { __typename?: 'RemoveShowResponse', success: boolean } };

export type RenewShowMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RenewShowMutation = { __typename?: 'Mutation', renewShow: { __typename?: 'RenewShowResponse', success: boolean } };

export type CreateEpisodeMutationVariables = Exact<{
  metaData: EpisodeMetaDataInput;
}>;


export type CreateEpisodeMutation = { __typename?: 'Mutation', episode: { __typename?: 'Episode', id: string } };

export type PopulateShowDetailsFromRssMutationVariables = Exact<{
  rssFeedUrl: Scalars['String']['input'];
}>;


export type PopulateShowDetailsFromRssMutation = { __typename?: 'Mutation', populateShowDetailsFromRss: { __typename?: 'Podcast', id: string, name?: string | null, description?: string | null, language?: string | null, feedLimit?: number | null, isExplicit: boolean, type?: PodcastType | null, email?: string | null, hostName?: string | null, timeZone?: string | null, lockFeed: boolean, statsUrlPrefix?: string | null, hasAlituHosting: boolean, userId: string, showExpiresAt?: string | null, artworkUrl?: string | null, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference?: boolean | null, autoCenterPreference?: boolean | null, copyright?: string | null, subdomain?: string | null, showHostingExpiresAt?: string | null, rssFeedUrl?: string | null, redirectUrl?: string | null, host?: Host | null, thirdPartyRssFeed?: string | null, appleClaimToken?: string | null, submittedThroughAppleApi?: boolean | null, categories?: { __typename?: 'PodcastCategories', category?: string | null, subcategory?: string | null, thirdCategory?: string | null } | null, transitionDefaults?: { __typename?: 'TransitionDefaults', intro?: { __typename?: 'TransitionDefaultIntro', overlap?: number | null, fadeVolume?: number | null, isFadingOut?: boolean | null } | null, outro?: { __typename?: 'TransitionDefaultOutro', overlap?: number | null, fadeVolume?: number | null, isFadingIn?: boolean | null } | null } | null, processingSettings: { __typename?: 'ProcessingSettings', voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean }, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null }, links: { __typename?: 'PodcastLinks', apple?: string | null, spotify?: string | null, alituBadge?: boolean | null, facebookPage?: string | null, facebookGroup?: string | null, twitter?: string | null, instagram?: string | null, linkedin?: string | null, youtube?: string | null, website?: string | null, pandora?: string | null, iHeartRadio?: string | null, deezer?: string | null } } };

export type GetRssAndPopulateBuzzsproutShowDetailsMutationVariables = Exact<{ [key: string]: never; }>;


export type GetRssAndPopulateBuzzsproutShowDetailsMutation = { __typename?: 'Mutation', getRssAndPopulateBuzzsproutShowDetails: { __typename?: 'Podcast', id: string, name?: string | null, description?: string | null, language?: string | null, feedLimit?: number | null, isExplicit: boolean, type?: PodcastType | null, email?: string | null, hostName?: string | null, timeZone?: string | null, lockFeed: boolean, statsUrlPrefix?: string | null, hasAlituHosting: boolean, userId: string, showExpiresAt?: string | null, artworkUrl?: string | null, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference?: boolean | null, autoCenterPreference?: boolean | null, copyright?: string | null, subdomain?: string | null, showHostingExpiresAt?: string | null, rssFeedUrl?: string | null, redirectUrl?: string | null, host?: Host | null, thirdPartyRssFeed?: string | null, appleClaimToken?: string | null, submittedThroughAppleApi?: boolean | null, categories?: { __typename?: 'PodcastCategories', category?: string | null, subcategory?: string | null, thirdCategory?: string | null } | null, transitionDefaults?: { __typename?: 'TransitionDefaults', intro?: { __typename?: 'TransitionDefaultIntro', overlap?: number | null, fadeVolume?: number | null, isFadingOut?: boolean | null } | null, outro?: { __typename?: 'TransitionDefaultOutro', overlap?: number | null, fadeVolume?: number | null, isFadingIn?: boolean | null } | null } | null, processingSettings: { __typename?: 'ProcessingSettings', voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean }, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null }, links: { __typename?: 'PodcastLinks', apple?: string | null, spotify?: string | null, alituBadge?: boolean | null, facebookPage?: string | null, facebookGroup?: string | null, twitter?: string | null, instagram?: string | null, linkedin?: string | null, youtube?: string | null, website?: string | null, pandora?: string | null, iHeartRadio?: string | null, deezer?: string | null } } };

export type GetRssAndPopulatePodbeanShowDetailsMutationVariables = Exact<{ [key: string]: never; }>;


export type GetRssAndPopulatePodbeanShowDetailsMutation = { __typename?: 'Mutation', getRssAndPopulatePodbeanShowDetails: { __typename?: 'Podcast', id: string, name?: string | null, description?: string | null, language?: string | null, feedLimit?: number | null, isExplicit: boolean, type?: PodcastType | null, email?: string | null, hostName?: string | null, timeZone?: string | null, lockFeed: boolean, statsUrlPrefix?: string | null, hasAlituHosting: boolean, userId: string, showExpiresAt?: string | null, artworkUrl?: string | null, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference?: boolean | null, autoCenterPreference?: boolean | null, copyright?: string | null, subdomain?: string | null, showHostingExpiresAt?: string | null, rssFeedUrl?: string | null, redirectUrl?: string | null, host?: Host | null, thirdPartyRssFeed?: string | null, appleClaimToken?: string | null, submittedThroughAppleApi?: boolean | null, categories?: { __typename?: 'PodcastCategories', category?: string | null, subcategory?: string | null, thirdCategory?: string | null } | null, transitionDefaults?: { __typename?: 'TransitionDefaults', intro?: { __typename?: 'TransitionDefaultIntro', overlap?: number | null, fadeVolume?: number | null, isFadingOut?: boolean | null } | null, outro?: { __typename?: 'TransitionDefaultOutro', overlap?: number | null, fadeVolume?: number | null, isFadingIn?: boolean | null } | null } | null, processingSettings: { __typename?: 'ProcessingSettings', voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean }, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null }, links: { __typename?: 'PodcastLinks', apple?: string | null, spotify?: string | null, alituBadge?: boolean | null, facebookPage?: string | null, facebookGroup?: string | null, twitter?: string | null, instagram?: string | null, linkedin?: string | null, youtube?: string | null, website?: string | null, pandora?: string | null, iHeartRadio?: string | null, deezer?: string | null } } };

export type SubmitShowToAppleMutationVariables = Exact<{ [key: string]: never; }>;


export type SubmitShowToAppleMutation = { __typename?: 'Mutation', submitShowToApple?: { __typename?: 'Podcast', id: string, name?: string | null, description?: string | null, language?: string | null, feedLimit?: number | null, isExplicit: boolean, type?: PodcastType | null, email?: string | null, hostName?: string | null, timeZone?: string | null, lockFeed: boolean, statsUrlPrefix?: string | null, hasAlituHosting: boolean, userId: string, showExpiresAt?: string | null, artworkUrl?: string | null, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference?: boolean | null, autoCenterPreference?: boolean | null, copyright?: string | null, subdomain?: string | null, showHostingExpiresAt?: string | null, rssFeedUrl?: string | null, redirectUrl?: string | null, host?: Host | null, thirdPartyRssFeed?: string | null, appleClaimToken?: string | null, submittedThroughAppleApi?: boolean | null, categories?: { __typename?: 'PodcastCategories', category?: string | null, subcategory?: string | null, thirdCategory?: string | null } | null, transitionDefaults?: { __typename?: 'TransitionDefaults', intro?: { __typename?: 'TransitionDefaultIntro', overlap?: number | null, fadeVolume?: number | null, isFadingOut?: boolean | null } | null, outro?: { __typename?: 'TransitionDefaultOutro', overlap?: number | null, fadeVolume?: number | null, isFadingIn?: boolean | null } | null } | null, processingSettings: { __typename?: 'ProcessingSettings', voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean }, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null }, links: { __typename?: 'PodcastLinks', apple?: string | null, spotify?: string | null, alituBadge?: boolean | null, facebookPage?: string | null, facebookGroup?: string | null, twitter?: string | null, instagram?: string | null, linkedin?: string | null, youtube?: string | null, website?: string | null, pandora?: string | null, iHeartRadio?: string | null, deezer?: string | null } } | null };

export type PopulateAppleClaimTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type PopulateAppleClaimTokenMutation = { __typename?: 'Mutation', populateAppleClaimToken: { __typename?: 'Podcast', id: string, name?: string | null, description?: string | null, language?: string | null, feedLimit?: number | null, isExplicit: boolean, type?: PodcastType | null, email?: string | null, hostName?: string | null, timeZone?: string | null, lockFeed: boolean, statsUrlPrefix?: string | null, hasAlituHosting: boolean, userId: string, showExpiresAt?: string | null, artworkUrl?: string | null, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference?: boolean | null, autoCenterPreference?: boolean | null, copyright?: string | null, subdomain?: string | null, showHostingExpiresAt?: string | null, rssFeedUrl?: string | null, redirectUrl?: string | null, host?: Host | null, thirdPartyRssFeed?: string | null, appleClaimToken?: string | null, submittedThroughAppleApi?: boolean | null, categories?: { __typename?: 'PodcastCategories', category?: string | null, subcategory?: string | null, thirdCategory?: string | null } | null, transitionDefaults?: { __typename?: 'TransitionDefaults', intro?: { __typename?: 'TransitionDefaultIntro', overlap?: number | null, fadeVolume?: number | null, isFadingOut?: boolean | null } | null, outro?: { __typename?: 'TransitionDefaultOutro', overlap?: number | null, fadeVolume?: number | null, isFadingIn?: boolean | null } | null } | null, processingSettings: { __typename?: 'ProcessingSettings', voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean }, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null }, links: { __typename?: 'PodcastLinks', apple?: string | null, spotify?: string | null, alituBadge?: boolean | null, facebookPage?: string | null, facebookGroup?: string | null, twitter?: string | null, instagram?: string | null, linkedin?: string | null, youtube?: string | null, website?: string | null, pandora?: string | null, iHeartRadio?: string | null, deezer?: string | null } } };

export type CheckAppleShowStatusQueryVariables = Exact<{
  appleShowId: Scalars['String']['input'];
}>;


export type CheckAppleShowStatusQuery = { __typename?: 'Query', checkAppleShowStatus?: { __typename?: 'AppleShowStatus', exists: boolean } | null };

export type AlituEpisodesCountPerShowQueryVariables = Exact<{ [key: string]: never; }>;


export type AlituEpisodesCountPerShowQuery = { __typename?: 'Query', alituEpisodesCountPerShow: number };

export type SubscriptionFragmentFragment = { __typename?: 'Subscription', id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end?: number | null, trial_start?: number | null, hostingExpiresAt?: string | null, hostingSuspended?: string | null, hostingLimit: number, hasAlreadyPaused: boolean, metadata?: { __typename?: 'SubscriptionMetaData', countryCode?: string | null } | null, plans?: Array<{ __typename?: 'SubscriptionPlan', nickname: string, amount: number, interval: string, currency: string }> | null, pause_collection?: { __typename?: 'PauseCollection', resumes_at?: number | null } | null };

export type SubscriptionDiscountFragmentFragment = { __typename?: 'Subscription', discount?: { __typename?: 'Discount', id?: string | null, coupon?: { __typename?: 'Coupon', id?: string | null, percent_off?: number | null, amount_off?: number | null, duration?: string | null, duration_in_months?: number | null } | null } | null };

export type SubscriptionInvoiceFragmentFragment = { __typename?: 'Subscription', latest_invoice?: { __typename?: 'Invoice', amount_due: number, currency: string, id: string, lines: { __typename?: 'InvoiceLines', data?: Array<{ __typename?: 'InvoiceLineData', amount: number, currency: string, description: string, quantity: number }> | null }, payment_intent?: { __typename?: 'PaymentIntent', client_secret: string } | null } | null };

export type AddHostingMutationVariables = Exact<{
  hostingPlan: Scalars['String']['input'];
}>;


export type AddHostingMutation = { __typename?: 'Mutation', addHosting: { __typename?: 'AddHostingResult', subscription?: { __typename?: 'Subscription', id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end?: number | null, trial_start?: number | null, hostingExpiresAt?: string | null, hostingSuspended?: string | null, hostingLimit: number, hasAlreadyPaused: boolean, metadata?: { __typename?: 'SubscriptionMetaData', countryCode?: string | null } | null, plans?: Array<{ __typename?: 'SubscriptionPlan', nickname: string, amount: number, interval: string, currency: string }> | null, pause_collection?: { __typename?: 'PauseCollection', resumes_at?: number | null } | null, discount?: { __typename?: 'Discount', id?: string | null, coupon?: { __typename?: 'Coupon', id?: string | null, percent_off?: number | null, amount_off?: number | null, duration?: string | null, duration_in_months?: number | null } | null } | null } | null, show?: { __typename?: 'Podcast', id: string, name?: string | null, description?: string | null, language?: string | null, feedLimit?: number | null, isExplicit: boolean, type?: PodcastType | null, email?: string | null, hostName?: string | null, timeZone?: string | null, lockFeed: boolean, statsUrlPrefix?: string | null, hasAlituHosting: boolean, userId: string, showExpiresAt?: string | null, artworkUrl?: string | null, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference?: boolean | null, autoCenterPreference?: boolean | null, copyright?: string | null, subdomain?: string | null, showHostingExpiresAt?: string | null, rssFeedUrl?: string | null, redirectUrl?: string | null, host?: Host | null, thirdPartyRssFeed?: string | null, appleClaimToken?: string | null, submittedThroughAppleApi?: boolean | null, categories?: { __typename?: 'PodcastCategories', category?: string | null, subcategory?: string | null, thirdCategory?: string | null } | null, transitionDefaults?: { __typename?: 'TransitionDefaults', intro?: { __typename?: 'TransitionDefaultIntro', overlap?: number | null, fadeVolume?: number | null, isFadingOut?: boolean | null } | null, outro?: { __typename?: 'TransitionDefaultOutro', overlap?: number | null, fadeVolume?: number | null, isFadingIn?: boolean | null } | null } | null, processingSettings: { __typename?: 'ProcessingSettings', voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean }, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null }, links: { __typename?: 'PodcastLinks', apple?: string | null, spotify?: string | null, alituBadge?: boolean | null, facebookPage?: string | null, facebookGroup?: string | null, twitter?: string | null, instagram?: string | null, linkedin?: string | null, youtube?: string | null, website?: string | null, pandora?: string | null, iHeartRadio?: string | null, deezer?: string | null } } | null } };

export type DeleteSubscriptionMutationVariables = Exact<{
  isPausing?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteSubscriptionMutation = { __typename?: 'Mutation', deleteSubscription: { __typename?: 'Subscription', id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end?: number | null, trial_start?: number | null, hostingExpiresAt?: string | null, hostingSuspended?: string | null, hostingLimit: number, hasAlreadyPaused: boolean, metadata?: { __typename?: 'SubscriptionMetaData', countryCode?: string | null } | null, plans?: Array<{ __typename?: 'SubscriptionPlan', nickname: string, amount: number, interval: string, currency: string }> | null, pause_collection?: { __typename?: 'PauseCollection', resumes_at?: number | null } | null, discount?: { __typename?: 'Discount', id?: string | null, coupon?: { __typename?: 'Coupon', id?: string | null, percent_off?: number | null, amount_off?: number | null, duration?: string | null, duration_in_months?: number | null } | null } | null } };

export type PauseSubscriptionMutationVariables = Exact<{
  typeformFormId: Scalars['String']['input'];
  typeformResponseId: Scalars['String']['input'];
}>;


export type PauseSubscriptionMutation = { __typename?: 'Mutation', pauseSubscription: { __typename?: 'Subscription', id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end?: number | null, trial_start?: number | null, hostingExpiresAt?: string | null, hostingSuspended?: string | null, hostingLimit: number, hasAlreadyPaused: boolean, metadata?: { __typename?: 'SubscriptionMetaData', countryCode?: string | null } | null, plans?: Array<{ __typename?: 'SubscriptionPlan', nickname: string, amount: number, interval: string, currency: string }> | null, pause_collection?: { __typename?: 'PauseCollection', resumes_at?: number | null } | null, discount?: { __typename?: 'Discount', id?: string | null, coupon?: { __typename?: 'Coupon', id?: string | null, percent_off?: number | null, amount_off?: number | null, duration?: string | null, duration_in_months?: number | null } | null } | null } };

export type CancelHostingSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelHostingSubscriptionMutation = { __typename?: 'Mutation', cancelHostingSubscription: { __typename?: 'Subscription', id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end?: number | null, trial_start?: number | null, hostingExpiresAt?: string | null, hostingSuspended?: string | null, hostingLimit: number, hasAlreadyPaused: boolean, metadata?: { __typename?: 'SubscriptionMetaData', countryCode?: string | null } | null, plans?: Array<{ __typename?: 'SubscriptionPlan', nickname: string, amount: number, interval: string, currency: string }> | null, pause_collection?: { __typename?: 'PauseCollection', resumes_at?: number | null } | null, discount?: { __typename?: 'Discount', id?: string | null, coupon?: { __typename?: 'Coupon', id?: string | null, percent_off?: number | null, amount_off?: number | null, duration?: string | null, duration_in_months?: number | null } | null } | null } };

export type UnpauseSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type UnpauseSubscriptionMutation = { __typename?: 'Mutation', unpauseSubscription: { __typename?: 'Subscription', id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end?: number | null, trial_start?: number | null, hostingExpiresAt?: string | null, hostingSuspended?: string | null, hostingLimit: number, hasAlreadyPaused: boolean, metadata?: { __typename?: 'SubscriptionMetaData', countryCode?: string | null } | null, plans?: Array<{ __typename?: 'SubscriptionPlan', nickname: string, amount: number, interval: string, currency: string }> | null, pause_collection?: { __typename?: 'PauseCollection', resumes_at?: number | null } | null, discount?: { __typename?: 'Discount', id?: string | null, coupon?: { __typename?: 'Coupon', id?: string | null, percent_off?: number | null, amount_off?: number | null, duration?: string | null, duration_in_months?: number | null } | null } | null } };

export type UpgradeFromTrialMutationVariables = Exact<{ [key: string]: never; }>;


export type UpgradeFromTrialMutation = { __typename?: 'Mutation', upgradeFromTrial: { __typename?: 'Subscription', id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end?: number | null, trial_start?: number | null, hostingExpiresAt?: string | null, hostingSuspended?: string | null, hostingLimit: number, hasAlreadyPaused: boolean, metadata?: { __typename?: 'SubscriptionMetaData', countryCode?: string | null } | null, plans?: Array<{ __typename?: 'SubscriptionPlan', nickname: string, amount: number, interval: string, currency: string }> | null, pause_collection?: { __typename?: 'PauseCollection', resumes_at?: number | null } | null, discount?: { __typename?: 'Discount', id?: string | null, coupon?: { __typename?: 'Coupon', id?: string | null, percent_off?: number | null, amount_off?: number | null, duration?: string | null, duration_in_months?: number | null } | null } | null } };

export type UpcomingInvoiceQueryVariables = Exact<{ [key: string]: never; }>;


export type UpcomingInvoiceQuery = { __typename?: 'Query', upcomingInvoice?: { __typename?: 'UpcomingInvoice', amount: number, currency: string } | null };

export type UserFragmentFragment = { __typename?: 'User', id: string, firstName: string, lastName?: string | null, email: string, session: string, address?: string | null, phone?: string | null, company?: string | null, role: string, isAuthenticated?: boolean | null, isTester: boolean, activeProjectId: string, callPermalink: string, emailOptIn: boolean, experienceLevel?: ExperienceLevel | null, podcastPurpose?: PodcastPurpose | null, heardAboutFrom?: string | null, createdAt: string, marketingData?: any | null, autoZoomPreference: boolean, autoCenterPreference: boolean, waveformPreference: WaveformPreference, bitratePreference: number, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null } };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginResponse', user: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, email: string, session: string, address?: string | null, phone?: string | null, company?: string | null, role: string, isAuthenticated?: boolean | null, isTester: boolean, activeProjectId: string, callPermalink: string, emailOptIn: boolean, experienceLevel?: ExperienceLevel | null, podcastPurpose?: PodcastPurpose | null, heardAboutFrom?: string | null, createdAt: string, marketingData?: any | null, autoZoomPreference: boolean, autoCenterPreference: boolean, waveformPreference: WaveformPreference, bitratePreference: number, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null } }, show: { __typename?: 'Podcast', id: string, name?: string | null, description?: string | null, language?: string | null, feedLimit?: number | null, isExplicit: boolean, type?: PodcastType | null, email?: string | null, hostName?: string | null, timeZone?: string | null, lockFeed: boolean, statsUrlPrefix?: string | null, hasAlituHosting: boolean, userId: string, showExpiresAt?: string | null, artworkUrl?: string | null, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference?: boolean | null, autoCenterPreference?: boolean | null, copyright?: string | null, subdomain?: string | null, showHostingExpiresAt?: string | null, rssFeedUrl?: string | null, redirectUrl?: string | null, host?: Host | null, thirdPartyRssFeed?: string | null, appleClaimToken?: string | null, submittedThroughAppleApi?: boolean | null, categories?: { __typename?: 'PodcastCategories', category?: string | null, subcategory?: string | null, thirdCategory?: string | null } | null, transitionDefaults?: { __typename?: 'TransitionDefaults', intro?: { __typename?: 'TransitionDefaultIntro', overlap?: number | null, fadeVolume?: number | null, isFadingOut?: boolean | null } | null, outro?: { __typename?: 'TransitionDefaultOutro', overlap?: number | null, fadeVolume?: number | null, isFadingIn?: boolean | null } | null } | null, processingSettings: { __typename?: 'ProcessingSettings', voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean }, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null }, links: { __typename?: 'PodcastLinks', apple?: string | null, spotify?: string | null, alituBadge?: boolean | null, facebookPage?: string | null, facebookGroup?: string | null, twitter?: string | null, instagram?: string | null, linkedin?: string | null, youtube?: string | null, website?: string | null, pandora?: string | null, iHeartRadio?: string | null, deezer?: string | null } }, subscription?: { __typename?: 'Subscription', id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end?: number | null, trial_start?: number | null, hostingExpiresAt?: string | null, hostingSuspended?: string | null, hostingLimit: number, hasAlreadyPaused: boolean, metadata?: { __typename?: 'SubscriptionMetaData', countryCode?: string | null } | null, plans?: Array<{ __typename?: 'SubscriptionPlan', nickname: string, amount: number, interval: string, currency: string }> | null, pause_collection?: { __typename?: 'PauseCollection', resumes_at?: number | null } | null, discount?: { __typename?: 'Discount', id?: string | null, coupon?: { __typename?: 'Coupon', id?: string | null, percent_off?: number | null, amount_off?: number | null, duration?: string | null, duration_in_months?: number | null } | null } | null } | null } };

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  isTester?: InputMaybe<Scalars['Boolean']['input']>;
  bitratePreference?: InputMaybe<Scalars['Int']['input']>;
  waveformPreference?: InputMaybe<Scalars['String']['input']>;
  autoZoomPreference?: InputMaybe<Scalars['Boolean']['input']>;
  autoCenterPreference?: InputMaybe<Scalars['Boolean']['input']>;
  transcriptionLanguage?: InputMaybe<Scalars['String']['input']>;
  activeProjectId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, email: string, session: string, address?: string | null, phone?: string | null, company?: string | null, role: string, isAuthenticated?: boolean | null, isTester: boolean, activeProjectId: string, callPermalink: string, emailOptIn: boolean, experienceLevel?: ExperienceLevel | null, podcastPurpose?: PodcastPurpose | null, heardAboutFrom?: string | null, createdAt: string, marketingData?: any | null, autoZoomPreference: boolean, autoCenterPreference: boolean, waveformPreference: WaveformPreference, bitratePreference: number, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null } } };

export type AssumeUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type AssumeUserQuery = { __typename?: 'Query', assumeUser: { __typename?: 'AssumeUser', user: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, email: string, session: string, address?: string | null, phone?: string | null, company?: string | null, role: string, isAuthenticated?: boolean | null, isTester: boolean, activeProjectId: string, callPermalink: string, emailOptIn: boolean, experienceLevel?: ExperienceLevel | null, podcastPurpose?: PodcastPurpose | null, heardAboutFrom?: string | null, createdAt: string, marketingData?: any | null, autoZoomPreference: boolean, autoCenterPreference: boolean, waveformPreference: WaveformPreference, bitratePreference: number, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null } } } };

export type JobQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type JobQuery = { __typename?: 'Query', job: { __typename?: 'Job', status: string, schema: any, createdAt: string } };

export type AllJobsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  hasFailed?: InputMaybe<Scalars['Boolean']['input']>;
  isRunning?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
}>;


export type AllJobsQuery = { __typename?: 'Query', allJobs?: Array<{ __typename?: 'Job', createdAt: string, id: string, hash: string, schema: any, userId: string, status: string }> | null };

export type JobLogsQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type JobLogsQuery = { __typename?: 'Query', jobLogs?: Array<{ __typename?: 'Log', id: string, payload?: any | null, createdAt?: string | null }> | null };

export type RerunJobMutationVariables = Exact<{
  jobId: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RerunJobMutation = { __typename?: 'Mutation', rerunJob: { __typename?: 'JobSpec', id: string } };

export type UsersQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UsersQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: string, firstName: string, lastName?: string | null, email: string, address?: string | null, isTester: boolean, activeProjectId: string }> | null };

export type ProjectsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type ProjectsQuery = { __typename?: 'Query', projects?: Array<{ __typename?: 'Project', id: string, description?: string | null, name?: string | null }> | null };

export type RegenerateRssMutationVariables = Exact<{
  showId: Scalars['ID']['input'];
}>;


export type RegenerateRssMutation = { __typename?: 'Mutation', regenerateRss: { __typename?: 'RegenerateRssResponse', success: boolean } };

export type RecoverDeletedFileMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type RecoverDeletedFileMutation = { __typename?: 'Mutation', recoverDeletedFile: { __typename?: 'RecoverDeletedFileResponse', success: boolean } };

export type RegenerateAllRssFeedsMutationVariables = Exact<{ [key: string]: never; }>;


export type RegenerateAllRssFeedsMutation = { __typename?: 'Mutation', regenerateAllRssFeeds: { __typename?: 'RegenerateAllRssFeedsResponse', updated: Array<{ __typename?: 'UpdatedRssFeed', projectId: string }>, failed: Array<{ __typename?: 'FailedRssFeed', projectId: string, error?: string | null }> } };

export type AlituHostedShowsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AlituHostedShowsQuery = { __typename?: 'Query', alituHostedShows?: { __typename?: 'HostedShowsResponse', total: number, shows?: Array<{ __typename?: 'HostedShow', id: string, name?: string | null, userId: string, rssFeedUrl: string, hostingSuspended?: string | null } | null> | null } | null };

export type HostingLimitOffendersQueryVariables = Exact<{ [key: string]: never; }>;


export type HostingLimitOffendersQuery = { __typename?: 'Query', hostingLimitOffenders?: Array<{ __typename?: 'HostingLimitOffender', userId: number, hostingLimit: number, prevMonth1?: number | null, prevMonth2?: number | null, prevMonth3?: number | null } | null> | null };

export type SuspendHostingMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  suspensionType?: InputMaybe<Scalars['String']['input']>;
}>;


export type SuspendHostingMutation = { __typename?: 'Mutation', suspendHosting: { __typename?: 'SuspendHostingResponse', success: boolean } };

export type GetUserFilesForAdminQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetUserFilesForAdminQuery = { __typename?: 'Query', getUserFilesForAdmin: Array<{ __typename?: 'AdminFile', id: string, name: string, bucket: string, createdAt: string, deletedAt?: string | null, audioJobId?: string | null, jobStatus?: string | null } | null> };

export type UpdateContentMutationVariables = Exact<{
  section: Scalars['String']['input'];
  content: Scalars['JSON']['input'];
}>;


export type UpdateContentMutation = { __typename?: 'Mutation', updateContent: { __typename?: 'UpdateContentResponse', success: boolean } };

export type SignupPageContentQueryVariables = Exact<{ [key: string]: never; }>;


export type SignupPageContentQuery = { __typename?: 'Query', signupPageContent?: { __typename?: 'SignupPageContent', mainTitle?: string | null, sidebarContent?: string | null } | null };

export type AddSubscriptionToUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
}>;


export type AddSubscriptionToUserMutation = { __typename?: 'Mutation', addSubscriptionToUser?: boolean | null };

export type DeleteAllUserDataMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type DeleteAllUserDataMutation = { __typename?: 'Mutation', deleteAllUserData: boolean };

export type EpisodeMetadataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EpisodeMetadataQuery = { __typename?: 'Query', episode: { __typename?: 'Episode', id: string, metaData: { __typename: 'EpisodeMetaData', name: string, summary?: string | null, description?: string | null, episodeNumber?: number | null, seasonNumber?: number | null, hostNames?: string | null, isExplicit?: boolean | null, type?: EpisodeType | null } } };

export type UpdateEpisodeMetadataMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  metaData?: InputMaybe<EpisodeMetaDataInput>;
  version?: InputMaybe<Scalars['Int']['input']>;
  clearFileField?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateEpisodeMetadataMutation = { __typename?: 'Mutation', episode: { __typename?: 'Episode', id: string, version?: number | null, metaData: { __typename: 'EpisodeMetaData', name: string, summary?: string | null, description?: string | null, episodeNumber?: number | null, seasonNumber?: number | null, hostNames?: string | null, isExplicit?: boolean | null, type?: EpisodeType | null } } };

export type DeleteRecordingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRecordingMutation = { __typename?: 'Mutation', deleteRecording?: boolean | null };

export type PauseRecordingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  paused: Scalars['Boolean']['input'];
}>;


export type PauseRecordingMutation = { __typename?: 'Mutation', pauseRecording?: boolean | null };

export type CallQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CallQuery = { __typename?: 'Query', call?: { __typename?: 'Call', job?: { __typename?: 'Job', status: string, schema: any } | null } | null };

export type CreateChunkUploadUrlMutationVariables = Exact<{
  callId: Scalars['ID']['input'];
  instanceId: Scalars['String']['input'];
  timestamp: Scalars['Date']['input'];
}>;


export type CreateChunkUploadUrlMutation = { __typename?: 'Mutation', createChunkUploadUrl: { __typename?: 'UploadUrlResponse', url: string } };

export type ConcatenateChunksMutationVariables = Exact<{
  callId: Scalars['ID']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type ConcatenateChunksMutation = { __typename?: 'Mutation', concatenateChunks: any };

export type CreateRecordingMutationVariables = Exact<{
  callId: Scalars['ID']['input'];
  duration: Scalars['Float']['input'];
  instanceId?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateRecordingMutation = { __typename?: 'Mutation', createRecording: { __typename?: 'CreateRecordingResponse', fileId?: string | null } };

export type CreateRecordingUploadUrlMutationVariables = Exact<{
  callId: Scalars['ID']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type CreateRecordingUploadUrlMutation = { __typename?: 'Mutation', createRecordingUploadUrl: { __typename?: 'UploadUrlResponse', url: string } };

export type AddCallTrackMutationVariables = Exact<{
  callId: Scalars['ID']['input'];
  instanceId: Scalars['String']['input'];
  startTime: Scalars['Date']['input'];
}>;


export type AddCallTrackMutation = { __typename?: 'Mutation', addCallTrack: any };

export type ProjectFilesQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  tags?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectFilesQuery = { __typename?: 'Query', projectFiles: { __typename?: 'FilteredProjectFiles', total: number, files?: Array<{ __typename?: 'File', id: string, name: string, type: string, tags: Array<string>, bucket: string, createdAt: string, codecInformation: { __typename?: 'CodecInformation', format?: { __typename?: 'CodecFormat', duration: string } | null }, users?: Array<{ __typename?: 'UserFile', userFile: any }> | null, audioJob?: { __typename?: 'Job', id: string, status: string, schema: any, createdAt: string, hash: string, userId: string } | null }> | null } };

export type ProjectFilesAndFoldersQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectFilesAndFoldersQuery = { __typename?: 'Query', projectFiles: { __typename?: 'ProjectFilesAndFolders', total: number, files?: Array<{ __typename?: 'FileListItem', id: string, fileId?: string | null, folderId?: string | null, name: string, bucket?: string | null, tags: Array<string>, bookmarked?: boolean | null, createdAt: string, userId: string, fileCount: number, audioJob?: { __typename?: 'FileListItemAudioJob', status?: string | null, hasMosaic?: boolean | null } | null, codecInformation?: { __typename?: 'CodecInformation', format?: { __typename?: 'CodecFormat', duration: string } | null } | null }> | null } };

export type GetFoldersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFoldersQuery = { __typename?: 'Query', getFolders?: Array<{ __typename?: 'Folder', id: string, name: string } | null> | null };

export type CreateFolderMutationVariables = Exact<{
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type CreateFolderMutation = { __typename?: 'Mutation', createFolder?: { __typename?: 'Folder', id: string, name: string } | null };

export type UpdateFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type UpdateFolderMutation = { __typename?: 'Mutation', updateFolder?: boolean | null };

export type DeleteFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type DeleteFolderMutation = { __typename?: 'Mutation', deleteFolder?: boolean | null };

export type AddFileToFolderMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type AddFileToFolderMutation = { __typename?: 'Mutation', addFileToFolder?: boolean | null };

export type RemoveFileFromFolderMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type RemoveFileFromFolderMutation = { __typename?: 'Mutation', removeFileFromFolder?: boolean | null };

export type GenerateTranscriptionMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type GenerateTranscriptionMutation = { __typename?: 'Mutation', generateTranscription: string };

export type CreateExportClipToLibraryJobMutationVariables = Exact<{
  episodeId: Scalars['ID']['input'];
  uniqueId: Scalars['ID']['input'];
  exportedFilename: Scalars['String']['input'];
  clipTimings?: InputMaybe<ClipTimingsInput>;
  addToEpisode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateExportClipToLibraryJobMutation = { __typename?: 'Mutation', createExportClipToLibraryJob: { __typename?: 'JobSpec', id: string } };

export type SplitEpisodeClipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  uniqueId: Scalars['ID']['input'];
  splitTime: Scalars['Float']['input'];
  firstFileName: Scalars['String']['input'];
  secondFileName: Scalars['String']['input'];
  version: Scalars['Int']['input'];
}>;


export type SplitEpisodeClipMutation = { __typename?: 'Mutation', splitEpisodeClip: { __typename?: 'Episode', id: string, version?: number | null, timeline: Array<{ __typename?: 'EpisodeFile', id: string, uniqueId: string, type: EpisodeFileType, name: string, bucket?: string | null, duration?: number | null, trimmedDuration?: number | null, overlapDuration?: number | null, tags: Array<string>, hasMosaic: boolean, audioTimeline?: Array<{ __typename?: 'AudioItem', type: TimelineItemType, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'BackgroundItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string, volume: number, fadeInDuration: number, fadeOutDuration: number } | { __typename?: 'BleepItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'MuteItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'RemovedAudioItem', type: TimelineItemType, id: string, start: number, sourceStart: number, duration: number, magicFilter?: MagicFilter | null, resource: string } | { __typename?: 'SilenceItem', type: TimelineItemType, id: string, start: number, end: number }> | null, fade: { __typename?: 'EpisodeFileFade', isFadingIn?: boolean | null, isFadingOut?: boolean | null, fadeVolume?: number | null }, job?: { __typename?: 'Job', id: string, schema: any, status: string, createdAt: string, hash: string, userId: string } | null, additionalFiles?: Array<{ __typename?: 'AdditionalFile', id: string, name: string, duration?: number | null }> | null }> } };

export type GetRecordingRulesQueryVariables = Exact<{
  callPermalink: Scalars['ID']['input'];
}>;


export type GetRecordingRulesQuery = { __typename?: 'Query', getRecordingRules: string };

export type UpdateRecordingRulesMutationVariables = Exact<{
  callPermalink: Scalars['ID']['input'];
  type: Scalars['String']['input'];
}>;


export type UpdateRecordingRulesMutation = { __typename?: 'Mutation', updateRecordingRules: any };

export type CreateCallMutationVariables = Exact<{
  twilioId: Scalars['String']['input'];
  isSolo?: InputMaybe<Scalars['Boolean']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  recordOnConnect: Scalars['Boolean']['input'];
  recordingType: RecordingType;
}>;


export type CreateCallMutation = { __typename?: 'Mutation', createCall: { __typename?: 'JoinCallResponse', id: string, token: string, room: string } };

export type JoinCallMutationVariables = Exact<{
  callPermalink: Scalars['ID']['input'];
  twilioId: Scalars['String']['input'];
}>;


export type JoinCallMutation = { __typename?: 'Mutation', joinCall: { __typename?: 'JoinCallResponse', id: string, token: string, room: string } };

export type CallExistsQueryVariables = Exact<{
  callPermalink: Scalars['ID']['input'];
}>;


export type CallExistsQuery = { __typename?: 'Query', callExists: { __typename?: 'CallExistsResponse', callExists: boolean, isVideoFeatureEnabled: boolean, isVideoRecordingFeatureEnabled: boolean, recordingType?: RecordingType | null } };

export type UpdateCallLockMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  locked: Scalars['Boolean']['input'];
}>;


export type UpdateCallLockMutation = { __typename?: 'Mutation', updateCallLock?: boolean | null };

export type GetCallCreatorQueryVariables = Exact<{
  callPermalink: Scalars['ID']['input'];
}>;


export type GetCallCreatorQuery = { __typename?: 'Query', getCallCreator?: { __typename?: 'Call', creatorTwilioId: string } | null };

export type AddCallDurationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  duration: Scalars['Float']['input'];
}>;


export type AddCallDurationMutation = { __typename?: 'Mutation', addCallDuration?: boolean | null };

export type CreateMusicEditorJobMutationVariables = Exact<{
  fileName?: InputMaybe<Scalars['String']['input']>;
  voice: Scalars['JSON']['input'];
  music: Scalars['JSON']['input'];
  introDuration?: InputMaybe<Scalars['Float']['input']>;
  outroDuration?: InputMaybe<Scalars['Float']['input']>;
  musicVolume?: InputMaybe<Scalars['Float']['input']>;
}>;


export type CreateMusicEditorJobMutation = { __typename?: 'Mutation', createMusicEditorJob: any };

export type CreateMusicEditorEditJobMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
  timeline: Scalars['JSON']['input'];
}>;


export type CreateMusicEditorEditJobMutation = { __typename?: 'Mutation', createMusicEditorEditJob: string };

export type MetaDataFragment = { __typename: 'EpisodeMetaData', name: string, summary?: string | null, description?: string | null, episodeNumber?: number | null, seasonNumber?: number | null, hostNames?: string | null, isExplicit?: boolean | null, type?: EpisodeType | null };

export type EpisodeFileFragment = { __typename?: 'EpisodeFile', id: string, uniqueId: string, type: EpisodeFileType, name: string, bucket?: string | null, duration?: number | null, trimmedDuration?: number | null, overlapDuration?: number | null, tags: Array<string>, hasMosaic: boolean, audioTimeline?: Array<{ __typename?: 'AudioItem', type: TimelineItemType, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'BackgroundItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string, volume: number, fadeInDuration: number, fadeOutDuration: number } | { __typename?: 'BleepItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'MuteItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'RemovedAudioItem', type: TimelineItemType, id: string, start: number, sourceStart: number, duration: number, magicFilter?: MagicFilter | null, resource: string } | { __typename?: 'SilenceItem', type: TimelineItemType, id: string, start: number, end: number }> | null, fade: { __typename?: 'EpisodeFileFade', isFadingIn?: boolean | null, isFadingOut?: boolean | null, fadeVolume?: number | null }, job?: { __typename?: 'Job', id: string, schema: any, status: string, createdAt: string, hash: string, userId: string } | null, additionalFiles?: Array<{ __typename?: 'AdditionalFile', id: string, name: string, duration?: number | null }> | null };

export type AudioItemAllFieldsFragment = { __typename?: 'AudioItem', type: TimelineItemType, start: number, end: number, sourceStart: number, resource: string };

export type RemovedAudioItemAllFieldsFragment = { __typename?: 'RemovedAudioItem', type: TimelineItemType, id: string, start: number, sourceStart: number, duration: number, magicFilter?: MagicFilter | null, resource: string };

export type SilenceItemAllFieldsFragment = { __typename?: 'SilenceItem', type: TimelineItemType, id: string, start: number, end: number };

export type MuteItemAllFieldsFragment = { __typename?: 'MuteItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string };

export type BleepItemAllFieldsFragment = { __typename?: 'BleepItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string };

export type BackgroundItemAllFieldsFragment = { __typename?: 'BackgroundItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string, volume: number, fadeInDuration: number, fadeOutDuration: number };

export type EpisodeAllFieldsFragment = { __typename?: 'Episode', id: string, version?: number | null, isArchivedVersion?: boolean | null, createdAt: string, publishedAt?: string | null, host?: string | null, shouldSuggestTitle?: boolean | null, shouldSuggestDescription?: boolean | null, shouldIncludeTranscriptInRss?: boolean | null, artworkUrl?: string | null, hasArtwork?: boolean | null, updatedAt?: string | null, metaData: { __typename: 'EpisodeMetaData', name: string, summary?: string | null, description?: string | null, episodeNumber?: number | null, seasonNumber?: number | null, hostNames?: string | null, isExplicit?: boolean | null, type?: EpisodeType | null }, timeline: Array<{ __typename?: 'EpisodeFile', id: string, uniqueId: string, type: EpisodeFileType, name: string, bucket?: string | null, duration?: number | null, trimmedDuration?: number | null, overlapDuration?: number | null, tags: Array<string>, hasMosaic: boolean, audioTimeline?: Array<{ __typename?: 'AudioItem', type: TimelineItemType, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'BackgroundItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string, volume: number, fadeInDuration: number, fadeOutDuration: number } | { __typename?: 'BleepItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'MuteItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'RemovedAudioItem', type: TimelineItemType, id: string, start: number, sourceStart: number, duration: number, magicFilter?: MagicFilter | null, resource: string } | { __typename?: 'SilenceItem', type: TimelineItemType, id: string, start: number, end: number }> | null, fade: { __typename?: 'EpisodeFileFade', isFadingIn?: boolean | null, isFadingOut?: boolean | null, fadeVolume?: number | null }, job?: { __typename?: 'Job', id: string, schema: any, status: string, createdAt: string, hash: string, userId: string } | null, additionalFiles?: Array<{ __typename?: 'AdditionalFile', id: string, name: string, duration?: number | null }> | null }> };

export type EpisodeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EpisodeQuery = { __typename?: 'Query', episode: { __typename?: 'Episode', id: string, version?: number | null, isArchivedVersion?: boolean | null, createdAt: string, publishedAt?: string | null, host?: string | null, shouldSuggestTitle?: boolean | null, shouldSuggestDescription?: boolean | null, shouldIncludeTranscriptInRss?: boolean | null, artworkUrl?: string | null, hasArtwork?: boolean | null, updatedAt?: string | null, metaData: { __typename: 'EpisodeMetaData', name: string, summary?: string | null, description?: string | null, episodeNumber?: number | null, seasonNumber?: number | null, hostNames?: string | null, isExplicit?: boolean | null, type?: EpisodeType | null }, timeline: Array<{ __typename?: 'EpisodeFile', id: string, uniqueId: string, type: EpisodeFileType, name: string, bucket?: string | null, duration?: number | null, trimmedDuration?: number | null, overlapDuration?: number | null, tags: Array<string>, hasMosaic: boolean, audioTimeline?: Array<{ __typename?: 'AudioItem', type: TimelineItemType, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'BackgroundItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string, volume: number, fadeInDuration: number, fadeOutDuration: number } | { __typename?: 'BleepItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'MuteItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'RemovedAudioItem', type: TimelineItemType, id: string, start: number, sourceStart: number, duration: number, magicFilter?: MagicFilter | null, resource: string } | { __typename?: 'SilenceItem', type: TimelineItemType, id: string, start: number, end: number }> | null, fade: { __typename?: 'EpisodeFileFade', isFadingIn?: boolean | null, isFadingOut?: boolean | null, fadeVolume?: number | null }, job?: { __typename?: 'Job', id: string, schema: any, status: string, createdAt: string, hash: string, userId: string } | null, additionalFiles?: Array<{ __typename?: 'AdditionalFile', id: string, name: string, duration?: number | null }> | null }> } };

export type UpdateEpisodeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  metaData?: InputMaybe<EpisodeMetaDataInput>;
  timeline?: InputMaybe<Array<EpisodeFileInput> | EpisodeFileInput>;
  shouldSuggestTitle?: InputMaybe<Scalars['Boolean']['input']>;
  shouldSuggestDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearFileField?: InputMaybe<Scalars['Boolean']['input']>;
  shouldIncludeTranscriptInRss?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  artwork?: InputMaybe<ArtworkInput>;
}>;


export type UpdateEpisodeMutation = { __typename?: 'Mutation', episode: { __typename?: 'Episode', id: string, version?: number | null, isArchivedVersion?: boolean | null, createdAt: string, publishedAt?: string | null, host?: string | null, shouldSuggestTitle?: boolean | null, shouldSuggestDescription?: boolean | null, shouldIncludeTranscriptInRss?: boolean | null, artworkUrl?: string | null, hasArtwork?: boolean | null, updatedAt?: string | null, metaData: { __typename: 'EpisodeMetaData', name: string, summary?: string | null, description?: string | null, episodeNumber?: number | null, seasonNumber?: number | null, hostNames?: string | null, isExplicit?: boolean | null, type?: EpisodeType | null }, timeline: Array<{ __typename?: 'EpisodeFile', id: string, uniqueId: string, type: EpisodeFileType, name: string, bucket?: string | null, duration?: number | null, trimmedDuration?: number | null, overlapDuration?: number | null, tags: Array<string>, hasMosaic: boolean, audioTimeline?: Array<{ __typename?: 'AudioItem', type: TimelineItemType, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'BackgroundItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string, volume: number, fadeInDuration: number, fadeOutDuration: number } | { __typename?: 'BleepItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'MuteItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'RemovedAudioItem', type: TimelineItemType, id: string, start: number, sourceStart: number, duration: number, magicFilter?: MagicFilter | null, resource: string } | { __typename?: 'SilenceItem', type: TimelineItemType, id: string, start: number, end: number }> | null, fade: { __typename?: 'EpisodeFileFade', isFadingIn?: boolean | null, isFadingOut?: boolean | null, fadeVolume?: number | null }, job?: { __typename?: 'Job', id: string, schema: any, status: string, createdAt: string, hash: string, userId: string } | null, additionalFiles?: Array<{ __typename?: 'AdditionalFile', id: string, name: string, duration?: number | null }> | null }> } };

export type AddAuphonicMetadataMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type AddAuphonicMetadataMutation = { __typename?: 'Mutation', addAuphonicMetadata: string };

export type CreateExportJobMutationVariables = Exact<{
  episodeId: Scalars['ID']['input'];
}>;


export type CreateExportJobMutation = { __typename?: 'Mutation', createExportJob: { __typename?: 'JobSpec', id: string } };

export type EpisodesQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  jobStatus?: InputMaybe<Scalars['String']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EpisodesQuery = { __typename?: 'Query', host?: Host | null, filteredTotal: number, all: number, draft: number, processing: number, complete: number, episodes: Array<{ __typename?: 'Episode', id: string, version?: number | null, isArchivedVersion?: boolean | null, artworkUrl?: string | null, createdAt: string, updatedAt?: string | null, publishedAt?: string | null, schedulePublishAt?: string | null, host?: string | null, metaData: { __typename?: 'EpisodeMetaData', name: string, summary?: string | null, description?: string | null, episodeNumber?: number | null, seasonNumber?: number | null }, timeline: Array<{ __typename?: 'EpisodeFile', id: string, uniqueId: string }>, file?: { __typename?: 'File', id: string, audioJob?: { __typename?: 'Job', id: string, createdAt: string, status: string, schema: any } | null, videoJob?: { __typename?: 'Job', id: string, createdAt: string, status: string, schema: any } | null, transcriptionJob?: { __typename?: 'Job', id: string, createdAt: string, status: string, schema: any } | null, aiJob?: { __typename?: 'Job', id: string, createdAt: string, status: string, schema: any } | null, metaDataJob?: { __typename?: 'Job', id: string, createdAt: string, status: string, schema: any } | null } | null }> };

export type DuplicateEpisodeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type DuplicateEpisodeMutation = { __typename?: 'Mutation', duplicateEpisode: { __typename?: 'Episode', id: string } };

export type DeleteEpisodeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEpisodeMutation = { __typename?: 'Mutation', deleteEpisode: { __typename?: 'DeletedEpisodeResponse', deletedEpisodeId: string } };

export type EpisodesCountPerUserQueryVariables = Exact<{ [key: string]: never; }>;


export type EpisodesCountPerUserQuery = { __typename?: 'Query', episodesCountPerUser: number };

export type FetchProcessingFileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type FetchProcessingFileQuery = { __typename?: 'Query', file?: { __typename?: 'File', codecInformation: { __typename?: 'CodecInformation', format?: { __typename?: 'CodecFormat', duration: string } | null }, audioJob?: { __typename?: 'Job', status: string } | null } | null };

export type FetchFileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type FetchFileQuery = { __typename?: 'Query', file?: { __typename?: 'File', id: string, name: string, type: string, tags: Array<string>, bucket: string, codecInformation: { __typename?: 'CodecInformation', format?: { __typename?: 'CodecFormat', duration: string } | null }, users?: Array<{ __typename?: 'UserFile', userFile: any }> | null, audioJob?: { __typename?: 'Job', id: string, status: string } | null } | null };

export type UpdateFileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  newData?: InputMaybe<UpdateFile>;
  removeData?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type UpdateFileMutation = { __typename?: 'Mutation', updateFile: boolean };

export type UpdateUserFileMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  newData?: InputMaybe<UpdateUserFile>;
}>;


export type UpdateUserFileMutation = { __typename?: 'Mutation', updateUserFile: boolean };

export type RemoveFileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type RemoveFileMutation = { __typename?: 'Mutation', removeFile: boolean };

export type BulkDeleteFilesMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  fileIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type BulkDeleteFilesMutation = { __typename?: 'Mutation', bulkDeleteFiles?: any | null };

export type ValidatePasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type ValidatePasswordMutation = { __typename?: 'Mutation', validatePassword: { __typename?: 'ValidatePasswordResponse', success: boolean, reason?: string | null } };

export type RequestResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestResetPasswordMutation = { __typename?: 'Mutation', requestResetPassword: { __typename?: 'ResetPasswordResponse', success: boolean } };

export type ResetPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'ChangePasswordResponse', success: boolean, reason?: string | null } };

export type SwitchPlanTypeMutationVariables = Exact<{ [key: string]: never; }>;


export type SwitchPlanTypeMutation = { __typename?: 'Mutation', switchPlanType: { __typename?: 'Subscription', id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end?: number | null, trial_start?: number | null, hostingExpiresAt?: string | null, hostingSuspended?: string | null, hostingLimit: number, hasAlreadyPaused: boolean, metadata?: { __typename?: 'SubscriptionMetaData', countryCode?: string | null } | null, plans?: Array<{ __typename?: 'SubscriptionPlan', nickname: string, amount: number, interval: string, currency: string }> | null, pause_collection?: { __typename?: 'PauseCollection', resumes_at?: number | null } | null, discount?: { __typename?: 'Discount', id?: string | null, coupon?: { __typename?: 'Coupon', id?: string | null, percent_off?: number | null, amount_off?: number | null, duration?: string | null, duration_in_months?: number | null } | null } | null } };

export type RenewSubscriptionMutationVariables = Exact<{
  paymentMethod: Scalars['String']['input'];
}>;


export type RenewSubscriptionMutation = { __typename?: 'Mutation', renewSubscription: { __typename?: 'Subscription', id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end?: number | null, trial_start?: number | null, hostingExpiresAt?: string | null, hostingSuspended?: string | null, hostingLimit: number, hasAlreadyPaused: boolean, metadata?: { __typename?: 'SubscriptionMetaData', countryCode?: string | null } | null, plans?: Array<{ __typename?: 'SubscriptionPlan', nickname: string, amount: number, interval: string, currency: string }> | null, pause_collection?: { __typename?: 'PauseCollection', resumes_at?: number | null } | null, discount?: { __typename?: 'Discount', id?: string | null, coupon?: { __typename?: 'Coupon', id?: string | null, percent_off?: number | null, amount_off?: number | null, duration?: string | null, duration_in_months?: number | null } | null } | null } };

export type GetPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentMethodsQuery = { __typename?: 'Query', getPaymentMethods?: Array<any> | null };

export type AlituSchedulePublishMutationVariables = Exact<{
  episodeId: Scalars['ID']['input'];
  schedulePublishAt?: InputMaybe<Scalars['String']['input']>;
}>;


export type AlituSchedulePublishMutation = { __typename?: 'Mutation', alituSchedulePublish: { __typename?: 'AlituPublishResponse', success: boolean } };

export type AlituCancelSchedulePublishMutationVariables = Exact<{
  episodeId: Scalars['ID']['input'];
}>;


export type AlituCancelSchedulePublishMutation = { __typename?: 'Mutation', alituCancelSchedulePublish: { __typename?: 'AlituCancelSchedulePublishResponse', success: boolean } };

export type AlituUpdatePublishedDateMutationVariables = Exact<{
  episodeId: Scalars['ID']['input'];
  publishedAt: Scalars['String']['input'];
}>;


export type AlituUpdatePublishedDateMutation = { __typename?: 'Mutation', alituUpdatePublishedDate: { __typename?: 'AlituUpdatePublishedDate', success: boolean } };

export type GenerateTitlesAndSummariesMutationVariables = Exact<{
  episodeId: Scalars['ID']['input'];
}>;


export type GenerateTitlesAndSummariesMutation = { __typename?: 'Mutation', generateTitlesAndSummaries: { __typename?: 'GenerateTitlesAndSummariesResponse', jobId: string, episode: { __typename?: 'Episode', id: string, version?: number | null, isArchivedVersion?: boolean | null, createdAt: string, publishedAt?: string | null, host?: string | null, shouldSuggestTitle?: boolean | null, shouldSuggestDescription?: boolean | null, shouldIncludeTranscriptInRss?: boolean | null, artworkUrl?: string | null, hasArtwork?: boolean | null, updatedAt?: string | null, metaData: { __typename: 'EpisodeMetaData', name: string, summary?: string | null, description?: string | null, episodeNumber?: number | null, seasonNumber?: number | null, hostNames?: string | null, isExplicit?: boolean | null, type?: EpisodeType | null }, timeline: Array<{ __typename?: 'EpisodeFile', id: string, uniqueId: string, type: EpisodeFileType, name: string, bucket?: string | null, duration?: number | null, trimmedDuration?: number | null, overlapDuration?: number | null, tags: Array<string>, hasMosaic: boolean, audioTimeline?: Array<{ __typename?: 'AudioItem', type: TimelineItemType, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'BackgroundItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string, volume: number, fadeInDuration: number, fadeOutDuration: number } | { __typename?: 'BleepItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'MuteItem', type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string } | { __typename?: 'RemovedAudioItem', type: TimelineItemType, id: string, start: number, sourceStart: number, duration: number, magicFilter?: MagicFilter | null, resource: string } | { __typename?: 'SilenceItem', type: TimelineItemType, id: string, start: number, end: number }> | null, fade: { __typename?: 'EpisodeFileFade', isFadingIn?: boolean | null, isFadingOut?: boolean | null, fadeVolume?: number | null }, job?: { __typename?: 'Job', id: string, schema: any, status: string, createdAt: string, hash: string, userId: string } | null, additionalFiles?: Array<{ __typename?: 'AdditionalFile', id: string, name: string, duration?: number | null }> | null }> } } };

export type HostTokenQueryVariables = Exact<{
  hostTokenInput: HostInput;
}>;


export type HostTokenQuery = { __typename?: 'Query', hostToken?: { __typename?: 'HostTokenResponse', token?: string | null } | null };

export type PublishPageQueryVariables = Exact<{
  episodeId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type PublishPageQuery = { __typename?: 'Query', host?: Host | null, episode: { __typename?: 'Episode', id: string, version?: number | null, artworkUrl?: string | null, publishedAt?: string | null, schedulePublishAt?: string | null, host?: string | null, shouldSuggestTitle?: boolean | null, shouldSuggestDescription?: boolean | null, shouldIncludeTranscriptInRss?: boolean | null, metaData: { __typename: 'EpisodeMetaData', name: string, summary?: string | null, description?: string | null, episodeNumber?: number | null, seasonNumber?: number | null, hostNames?: string | null, isExplicit?: boolean | null, type?: EpisodeType | null }, file?: { __typename?: 'File', id: string, codecInformation: { __typename?: 'CodecInformation', format?: { __typename?: 'CodecFormat', duration: string } | null }, audioJob?: { __typename?: 'Job', id: string, status: string } | null, videoJob?: { __typename?: 'Job', id: string, status: string } | null, transcriptionJob?: { __typename?: 'Job', id: string, status: string } | null, aiJob?: { __typename?: 'Job', id: string, status: string } | null, metaDataJob?: { __typename?: 'Job', id: string, status: string, schema: any } | null } | null }, show: { __typename?: 'Podcast', id: string, subdomain?: string | null, redirectUrl?: string | null } };

export type AlituHostLoginMutationVariables = Exact<{ [key: string]: never; }>;


export type AlituHostLoginMutation = { __typename?: 'Mutation', alituHostLogin: { __typename?: 'ConnectAlituHostResponse', success: boolean, show: { __typename?: 'Podcast', id: string, name?: string | null, description?: string | null, language?: string | null, feedLimit?: number | null, isExplicit: boolean, type?: PodcastType | null, email?: string | null, hostName?: string | null, timeZone?: string | null, lockFeed: boolean, statsUrlPrefix?: string | null, hasAlituHosting: boolean, userId: string, showExpiresAt?: string | null, artworkUrl?: string | null, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference?: boolean | null, autoCenterPreference?: boolean | null, copyright?: string | null, subdomain?: string | null, showHostingExpiresAt?: string | null, rssFeedUrl?: string | null, redirectUrl?: string | null, host?: Host | null, thirdPartyRssFeed?: string | null, appleClaimToken?: string | null, submittedThroughAppleApi?: boolean | null, categories?: { __typename?: 'PodcastCategories', category?: string | null, subcategory?: string | null, thirdCategory?: string | null } | null, transitionDefaults?: { __typename?: 'TransitionDefaults', intro?: { __typename?: 'TransitionDefaultIntro', overlap?: number | null, fadeVolume?: number | null, isFadingOut?: boolean | null } | null, outro?: { __typename?: 'TransitionDefaultOutro', overlap?: number | null, fadeVolume?: number | null, isFadingIn?: boolean | null } | null } | null, processingSettings: { __typename?: 'ProcessingSettings', voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean }, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null }, links: { __typename?: 'PodcastLinks', apple?: string | null, spotify?: string | null, alituBadge?: boolean | null, facebookPage?: string | null, facebookGroup?: string | null, twitter?: string | null, instagram?: string | null, linkedin?: string | null, youtube?: string | null, website?: string | null, pandora?: string | null, iHeartRadio?: string | null, deezer?: string | null } } } };

export type CaptivateLoginMutationVariables = Exact<{
  username: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
}>;


export type CaptivateLoginMutation = { __typename?: 'Mutation', captivateLogin: { __typename?: 'Captivate', token?: any | null } };

export type TransistorLoginMutationVariables = Exact<{
  token: Scalars['ID']['input'];
}>;


export type TransistorLoginMutation = { __typename?: 'Mutation', transistorLogin: { __typename?: 'TransistorResponse', isTokenValid: boolean } };

export type BuzzsproutLoginMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  podcastId: Scalars['ID']['input'];
  token: Scalars['ID']['input'];
}>;


export type BuzzsproutLoginMutation = { __typename?: 'Mutation', buzzsproutLogin: { __typename?: 'SuccessResponse', success: boolean } };

export type CastosLoginMutationVariables = Exact<{
  token: Scalars['ID']['input'];
}>;


export type CastosLoginMutation = { __typename?: 'Mutation', castosLogin: { __typename?: 'CastosLoginResponse', isTokenValid: boolean } };

export type CaptivatePublishMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  episodeId: Scalars['ID']['input'];
  isDraft: Scalars['Boolean']['input'];
  captivateShow: CaptivateShow;
}>;


export type CaptivatePublishMutation = { __typename?: 'Mutation', captivatePublish: { __typename?: 'CaptivateUploadResponse', success: boolean } };

export type CaptivateShowsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type CaptivateShowsQuery = { __typename?: 'Query', shows?: Array<{ __typename?: 'CaptivateShows', id: string, title: string, timeZone: string, feedUrl?: string | null }> | null };

export type CreateVideoJobMutationVariables = Exact<{
  episodeId: Scalars['ID']['input'];
}>;


export type CreateVideoJobMutation = { __typename?: 'Mutation', createVideoJob: { __typename?: 'JobSpec', id: string } };

export type CastosPodcastsQueryVariables = Exact<{ [key: string]: never; }>;


export type CastosPodcastsQuery = { __typename?: 'Query', podcasts: Array<{ __typename?: 'CastosPodcast', id: string, title: string, feedUrl?: string | null }> };

export type CastosPublishMutationVariables = Exact<{
  episodeId: Scalars['ID']['input'];
  podcastId: Scalars['ID']['input'];
}>;


export type CastosPublishMutation = { __typename?: 'Mutation', publish: { __typename?: 'CastosPublishResponse', success: boolean } };

export type TransistorShowsQueryVariables = Exact<{ [key: string]: never; }>;


export type TransistorShowsQuery = { __typename?: 'Query', shows?: Array<{ __typename?: 'TransistorShow', id: string, title: string, description: string, feedUrl?: string | null }> | null };

export type TransistorPublishMutationVariables = Exact<{
  episodeId: Scalars['ID']['input'];
  showId: Scalars['ID']['input'];
  isDraft: Scalars['Boolean']['input'];
}>;


export type TransistorPublishMutation = { __typename?: 'Mutation', publish: { __typename?: 'TransistorPublishResponse', success: boolean } };

export type SpreakerShowsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type SpreakerShowsQuery = { __typename?: 'Query', shows: Array<{ __typename?: 'SpreakerShow', id: string, title: string, feedUrl?: string | null }> };

export type SpreakerPublishMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  episodeId: Scalars['ID']['input'];
  additional: SpreakerAdditionalInput;
}>;


export type SpreakerPublishMutation = { __typename?: 'Mutation', publish: { __typename?: 'SpreakerPublishResponse', success: boolean } };

export type LibsynShowsQueryVariables = Exact<{ [key: string]: never; }>;


export type LibsynShowsQuery = { __typename?: 'Query', shows: Array<{ __typename?: 'LibsynShow', id: string, title: string, feedUrl?: string | null }> };

export type LibsynPublishMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  additional: LibsynUploadAdditional;
  episodeId: Scalars['ID']['input'];
}>;


export type LibsynPublishMutation = { __typename?: 'Mutation', publish: { __typename?: 'LibsynPublishResponse', success: boolean } };

export type PodbeanPublishMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  additional: PodbeanAdditional;
  episodeId: Scalars['ID']['input'];
}>;


export type PodbeanPublishMutation = { __typename?: 'Mutation', publish: { __typename?: 'PodbeanPublishResponse', success: boolean } };

export type BuzzsproutPublishMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  additional: AdditionalInput;
  episodeId: Scalars['ID']['input'];
}>;


export type BuzzsproutPublishMutation = { __typename?: 'Mutation', publish: { __typename?: 'SuccessResponse', success: boolean } };

export type EpisodeJobStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EpisodeJobStatusQuery = { __typename?: 'Query', episodeJobStatus: { __typename?: 'Episode', id: string, file?: { __typename?: 'File', id: string, audioJob?: { __typename?: 'Job', id: string, status: string, schema: any } | null, videoJob?: { __typename?: 'Job', id: string, status: string } | null, transcriptionJob?: { __typename?: 'Job', id: string, status: string } | null, aiJob?: { __typename?: 'Job', id: string, status: string } | null, metaDataJob?: { __typename?: 'Job', id: string, status: string } | null } | null } };

export type PublishToAlituMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  episodeId: Scalars['ID']['input'];
}>;


export type PublishToAlituMutation = { __typename?: 'Mutation', alituPublish: { __typename?: 'AlituPublishResponse', success: boolean } };

export type UnpublishFromAlituMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  episodeId: Scalars['ID']['input'];
}>;


export type UnpublishFromAlituMutation = { __typename?: 'Mutation', alituUnpublish: { __typename?: 'AlituUnpublishResponse', success: boolean } };

export type TranscriptionQueryVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type TranscriptionQuery = { __typename?: 'Query', transcription?: { __typename?: 'Transcription', id: string, fileId?: string | null, speakerNames?: Array<string> | null, createdAt: string, status: string } | null };

export type UpdateTranscriptionMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
  speakerNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateTranscriptionMutation = { __typename?: 'Mutation', updateTranscription?: { __typename?: 'Transcription', id: string, fileId?: string | null, speakerNames?: Array<string> | null } | null };

export type CustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', currency?: string | null, address?: { __typename?: 'StripeAddress', country: string, postal_code?: string | null } | null } };

export type DefaultMusicFieldsFragment = { __typename?: 'File', id: string, name: string, type: string };

export type CheckSubdomainQueryVariables = Exact<{
  subdomain: Scalars['String']['input'];
}>;


export type CheckSubdomainQuery = { __typename?: 'Query', checkSubdomain?: { __typename?: 'SubdomainRecord', id?: string | null, name?: string | null } | null };

export type DeleteSubdomainMutationVariables = Exact<{
  subdomain: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteSubdomainMutation = { __typename?: 'Mutation', deleteSubdomain: { __typename?: 'DeleteSubdomainResponse', success: boolean } };

export type SettingsPageQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type SettingsPageQuery = { __typename?: 'Query', defaultIntroMusic?: { __typename?: 'File', id: string, name: string, type: string } | null, defaultOutroMusic?: { __typename?: 'File', id: string, name: string, type: string } | null };

export type DefaultMusicQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type DefaultMusicQuery = { __typename?: 'Query', defaultIntroMusic?: { __typename?: 'File', id: string, name: string, type: string } | null, defaultOutroMusic?: { __typename?: 'File', id: string, name: string, type: string } | null };

export type UpdatePodcastMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  podcast: PodcastInput;
  adobeArtwork?: InputMaybe<Scalars['Boolean']['input']>;
  shouldRegenerateRssFeed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatePodcastMutation = { __typename?: 'Mutation', updatePodcast: { __typename?: 'Podcast', id: string, name?: string | null, description?: string | null, language?: string | null, feedLimit?: number | null, isExplicit: boolean, type?: PodcastType | null, email?: string | null, hostName?: string | null, timeZone?: string | null, lockFeed: boolean, statsUrlPrefix?: string | null, copyright?: string | null, artworkUrl?: string | null, subdomain?: string | null, bitratePreference: number, waveformPreference: WaveformPreference, autoZoomPreference?: boolean | null, autoCenterPreference?: boolean | null, thirdPartyRssFeed?: string | null, categories?: { __typename?: 'PodcastCategories', category?: string | null, subcategory?: string | null, thirdCategory?: string | null } | null, links: { __typename?: 'PodcastLinks', apple?: string | null, spotify?: string | null, alituBadge?: boolean | null, facebookPage?: string | null, facebookGroup?: string | null, twitter?: string | null, instagram?: string | null, linkedin?: string | null, youtube?: string | null, website?: string | null, pandora?: string | null, iHeartRadio?: string | null, deezer?: string | null }, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null }, processingSettings: { __typename?: 'ProcessingSettings', voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean } } };

export type SetDefaultMusicMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  newData?: InputMaybe<UpdateFile>;
  removeData?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type SetDefaultMusicMutation = { __typename?: 'Mutation', updateFile: boolean };

export type ImportPodcastRssMutationVariables = Exact<{
  rssFeedUrl: Scalars['String']['input'];
}>;


export type ImportPodcastRssMutation = { __typename?: 'Mutation', importPodcastRss: { __typename?: 'ImportPodcastRssResponse', success: boolean, url: { __typename?: 'PodcastUrl', rss: string } } };

export type RedirectRssMutationVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type RedirectRssMutation = { __typename?: 'Mutation', redirectRss: { __typename?: 'RedirectRssResponse', success: boolean } };

export type FetchHostQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchHostQuery = { __typename?: 'Query', host?: Host | null };

export type DeleteHostTokenMutationVariables = Exact<{
  input: HostInput;
}>;


export type DeleteHostTokenMutation = { __typename?: 'Mutation', deleteHostToken: { __typename?: 'Podcast', id: string, name?: string | null, description?: string | null, language?: string | null, feedLimit?: number | null, isExplicit: boolean, type?: PodcastType | null, email?: string | null, hostName?: string | null, timeZone?: string | null, lockFeed: boolean, statsUrlPrefix?: string | null, hasAlituHosting: boolean, userId: string, showExpiresAt?: string | null, artworkUrl?: string | null, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference?: boolean | null, autoCenterPreference?: boolean | null, copyright?: string | null, subdomain?: string | null, showHostingExpiresAt?: string | null, rssFeedUrl?: string | null, redirectUrl?: string | null, host?: Host | null, thirdPartyRssFeed?: string | null, appleClaimToken?: string | null, submittedThroughAppleApi?: boolean | null, categories?: { __typename?: 'PodcastCategories', category?: string | null, subcategory?: string | null, thirdCategory?: string | null } | null, transitionDefaults?: { __typename?: 'TransitionDefaults', intro?: { __typename?: 'TransitionDefaultIntro', overlap?: number | null, fadeVolume?: number | null, isFadingOut?: boolean | null } | null, outro?: { __typename?: 'TransitionDefaultOutro', overlap?: number | null, fadeVolume?: number | null, isFadingIn?: boolean | null } | null } | null, processingSettings: { __typename?: 'ProcessingSettings', voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean }, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null }, links: { __typename?: 'PodcastLinks', apple?: string | null, spotify?: string | null, alituBadge?: boolean | null, facebookPage?: string | null, facebookGroup?: string | null, twitter?: string | null, instagram?: string | null, linkedin?: string | null, youtube?: string | null, website?: string | null, pandora?: string | null, iHeartRadio?: string | null, deezer?: string | null } } };

export type GetTranscriptionUsageAndLimitQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTranscriptionUsageAndLimitQuery = { __typename?: 'Query', getTranscriptionUsageAndLimit?: { __typename?: 'TranscriptionUsageAndLimitResponse', usage: number, limit: number } | null };

export type CreateUserMutationVariables = Exact<{
  token: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  name: Scalars['String']['input'];
  emailOptIn: Scalars['Boolean']['input'];
  marketingData?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'CreateUserResponse', user: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, email: string, session: string, address?: string | null, phone?: string | null, company?: string | null, role: string, isAuthenticated?: boolean | null, isTester: boolean, activeProjectId: string, callPermalink: string, emailOptIn: boolean, experienceLevel?: ExperienceLevel | null, podcastPurpose?: PodcastPurpose | null, heardAboutFrom?: string | null, createdAt: string, marketingData?: any | null, autoZoomPreference: boolean, autoCenterPreference: boolean, waveformPreference: WaveformPreference, bitratePreference: number, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null } }, show: { __typename?: 'Podcast', id: string, name?: string | null, description?: string | null, language?: string | null, feedLimit?: number | null, isExplicit: boolean, type?: PodcastType | null, email?: string | null, hostName?: string | null, timeZone?: string | null, lockFeed: boolean, statsUrlPrefix?: string | null, hasAlituHosting: boolean, userId: string, showExpiresAt?: string | null, artworkUrl?: string | null, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference?: boolean | null, autoCenterPreference?: boolean | null, copyright?: string | null, subdomain?: string | null, showHostingExpiresAt?: string | null, rssFeedUrl?: string | null, redirectUrl?: string | null, host?: Host | null, thirdPartyRssFeed?: string | null, appleClaimToken?: string | null, submittedThroughAppleApi?: boolean | null, categories?: { __typename?: 'PodcastCategories', category?: string | null, subcategory?: string | null, thirdCategory?: string | null } | null, transitionDefaults?: { __typename?: 'TransitionDefaults', intro?: { __typename?: 'TransitionDefaultIntro', overlap?: number | null, fadeVolume?: number | null, isFadingOut?: boolean | null } | null, outro?: { __typename?: 'TransitionDefaultOutro', overlap?: number | null, fadeVolume?: number | null, isFadingIn?: boolean | null } | null } | null, processingSettings: { __typename?: 'ProcessingSettings', voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean }, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null }, links: { __typename?: 'PodcastLinks', apple?: string | null, spotify?: string | null, alituBadge?: boolean | null, facebookPage?: string | null, facebookGroup?: string | null, twitter?: string | null, instagram?: string | null, linkedin?: string | null, youtube?: string | null, website?: string | null, pandora?: string | null, iHeartRadio?: string | null, deezer?: string | null } } } };

export type CreateCustomerMutationVariables = Exact<{
  company?: InputMaybe<Company>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<StripeAddressParam>;
  plan: Scalars['String']['input'];
  hostingPlan?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer: { __typename?: 'createCustomerResult', clientSecret: string, setupIntentId: string } };

export type CreateSubscriptionMutationVariables = Exact<{
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  plan: Scalars['String']['input'];
  hostingPlan?: InputMaybe<Scalars['String']['input']>;
  isEuropeanUnion: Scalars['Boolean']['input'];
  company?: InputMaybe<Company>;
  withTrial?: InputMaybe<Scalars['Boolean']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<StripeAddressParam>;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'Subscription', id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end?: number | null, trial_start?: number | null, hostingExpiresAt?: string | null, hostingSuspended?: string | null, hostingLimit: number, hasAlreadyPaused: boolean, metadata?: { __typename?: 'SubscriptionMetaData', countryCode?: string | null } | null, plans?: Array<{ __typename?: 'SubscriptionPlan', nickname: string, amount: number, interval: string, currency: string }> | null, pause_collection?: { __typename?: 'PauseCollection', resumes_at?: number | null } | null, discount?: { __typename?: 'Discount', id?: string | null, coupon?: { __typename?: 'Coupon', id?: string | null, percent_off?: number | null, amount_off?: number | null, duration?: string | null, duration_in_months?: number | null } | null } | null, latest_invoice?: { __typename?: 'Invoice', amount_due: number, currency: string, id: string, lines: { __typename?: 'InvoiceLines', data?: Array<{ __typename?: 'InvoiceLineData', amount: number, currency: string, description: string, quantity: number }> | null }, payment_intent?: { __typename?: 'PaymentIntent', client_secret: string } | null } | null } };

export type CreateSubscriptionFromSetupIntentMutationVariables = Exact<{
  setupIntentId: Scalars['String']['input'];
}>;


export type CreateSubscriptionFromSetupIntentMutation = { __typename?: 'Mutation', createSubscriptionFromSetupIntent: { __typename?: 'Subscription', id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end?: number | null, trial_start?: number | null, hostingExpiresAt?: string | null, hostingSuspended?: string | null, hostingLimit: number, hasAlreadyPaused: boolean, metadata?: { __typename?: 'SubscriptionMetaData', countryCode?: string | null } | null, plans?: Array<{ __typename?: 'SubscriptionPlan', nickname: string, amount: number, interval: string, currency: string }> | null, pause_collection?: { __typename?: 'PauseCollection', resumes_at?: number | null } | null, discount?: { __typename?: 'Discount', id?: string | null, coupon?: { __typename?: 'Coupon', id?: string | null, percent_off?: number | null, amount_off?: number | null, duration?: string | null, duration_in_months?: number | null } | null } | null } };

export type TaxPercentageQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  vatNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type TaxPercentageQuery = { __typename?: 'Query', tax: { __typename?: 'SubscriptionTax', percentage: number } };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries?: Array<{ __typename?: 'Countries', name: string, alpha2Code: string, regionalBlocs?: Array<{ __typename?: 'RegionalBlocs', name?: string | null } | null> | null }> | null };

export type PromoCodeQueryVariables = Exact<{
  promoCode: Scalars['String']['input'];
  planType: Scalars['String']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
}>;


export type PromoCodeQuery = { __typename?: 'Query', promoCode?: { __typename?: 'PromoCode', id: string, percent_off?: number | null, amount_off?: number | null, terms?: string | null, duration?: string | null, trial_days?: number | null } | null };

export type SubscriptionPriceQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  planType: Scalars['String']['input'];
  hostingPlan?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubscriptionPriceQuery = { __typename?: 'Query', subscriptionPrice: { __typename?: 'SubscriptionPrice', price: string, currency: string, symbol: string } };

export type UpdatePersonalisationMutationVariables = Exact<{
  experienceLevel?: InputMaybe<ExperienceLevel>;
  podcastPurpose?: InputMaybe<PodcastPurpose>;
  heardAboutFrom?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePersonalisationMutation = { __typename?: 'Mutation', updatePersonalisation: { __typename?: 'updatePersonalisationResponse', user: { __typename?: 'User', id: string, firstName: string, lastName?: string | null, email: string, session: string, address?: string | null, phone?: string | null, company?: string | null, role: string, isAuthenticated?: boolean | null, isTester: boolean, activeProjectId: string, callPermalink: string, emailOptIn: boolean, experienceLevel?: ExperienceLevel | null, podcastPurpose?: PodcastPurpose | null, heardAboutFrom?: string | null, createdAt: string, marketingData?: any | null, autoZoomPreference: boolean, autoCenterPreference: boolean, waveformPreference: WaveformPreference, bitratePreference: number, transcriptionPreferences: { __typename?: 'TranscriptionPreferences', language?: string | null } } } };

export type StatisticsPageQueryVariables = Exact<{
  showId: Scalars['ID']['input'];
}>;


export type StatisticsPageQuery = { __typename?: 'Query', show: { __typename?: 'Podcast', artworkUrl?: string | null, links: { __typename?: 'PodcastLinks', spotify?: string | null } } };

export type GetEpisodeStatsQueryVariables = Exact<{
  episodeId: Scalars['ID']['input'];
}>;


export type GetEpisodeStatsQuery = { __typename?: 'Query', getEpisodeStats: { __typename?: 'HostingStatsResponse', downloadsToday?: number | null, downloadsYesterday?: number | null, downloadsLastWeek?: number | null, downloadsLastMonth?: number | null, downloadsLastQuarter?: number | null, downloadsAllTime?: number | null } };

export type GetPodcastStatsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetPodcastStatsQuery = { __typename?: 'Query', getPodcastStats: { __typename?: 'HostingStatsResponse', downloadsToday?: number | null, downloadsYesterday?: number | null, downloadsLastWeek?: number | null, downloadsLastMonth?: number | null, downloadsLastQuarter?: number | null, downloadsAllTime?: number | null } };

export type GetPodcastAveragesStatsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  period: Scalars['String']['input'];
}>;


export type GetPodcastAveragesStatsQuery = { __typename?: 'Query', getPodcastAveragesStats: { __typename?: 'HostingAveragesStatsResponse', dailyAverage?: number | null, weeklyAverage?: number | null, monthlyAverage?: number | null } };

export type GetEpisodeDownloadsOverviewStatsQueryVariables = Exact<{
  episodeId: Scalars['ID']['input'];
}>;


export type GetEpisodeDownloadsOverviewStatsQuery = { __typename?: 'Query', getEpisodeDownloadsOverviewStats: { __typename?: 'HostingEpisodeStatsOverviewResponse', downloadsToday?: number | null, downloadsYesterday?: number | null, downloadsLastWeek?: number | null, downloadsLastMonth?: number | null, downloadsLastQuarter?: number | null, downloadsForever?: number | null } };

export type GetOsStatsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  period: Scalars['String']['input'];
}>;


export type GetOsStatsQuery = { __typename?: 'Query', getOSStats: { __typename?: 'HostingOSStatsResponse', androidDownloads?: number | null, windowsDownloads?: number | null, macosDownloads?: number | null, iosDownloads?: number | null, others?: number | null } };

export type GetDevicesStatsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  period: Scalars['String']['input'];
}>;


export type GetDevicesStatsQuery = { __typename?: 'Query', getDevicesStats: { __typename?: 'HostingDevicesResponse', mobileDownloads?: number | null, allDownloads?: number | null } };

export type GetCountriesStatsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  period: Scalars['String']['input'];
}>;


export type GetCountriesStatsQuery = { __typename?: 'Query', getCountriesStats: { __typename?: 'HostingCountriesResponse', countriesStats?: any | null } };

export type GetShowDetailsStatsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  order: Scalars['String']['input'];
}>;


export type GetShowDetailsStatsQuery = { __typename?: 'Query', getShowDetailsStats: { __typename?: 'ShowDetailsStatsResult', total: number, episodeStats: Array<{ __typename?: 'EpisodeStats', episodeId: string, name: string, episodeNumber?: string | null, deletedAt?: any | null, today: number, yesterday: number, week: number, month: number, quarter: number, forever: number }> } };

export type GetAppsStatsQueryVariables = Exact<{
  start?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAppsStatsQuery = { __typename?: 'Query', getAppsStats: Array<{ __typename?: 'AppStat', appName: string, downloads: number, percentage: number }> };

export type UniversalFilesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
}>;


export type UniversalFilesQuery = { __typename?: 'Query', universalFiles: { __typename?: 'UniversalFilesResponse', total: number, categories: Array<{ __typename?: 'UniversalFilesCategory', name: string, previewFile?: any | null, files: Array<{ __typename?: 'UniversalFile', id: string, name: string, duration?: string | null, users?: any | null, isAddedToLibrary: boolean }> }> } };

export type LinkFileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type LinkFileMutation = { __typename?: 'Mutation', linkFile: any };

export type UnlinkFileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type UnlinkFileMutation = { __typename?: 'Mutation', unlinkFile: boolean };

export const ApiKeyFragmentDoc = gql`
    fragment ApiKey on ApiKey {
  id
  name
  createdAt
}
    `;
export const CreatedApiKeyFragmentDoc = gql`
    fragment CreatedApiKey on ApiKey {
  id
  apiKeyValue
  name
  createdAt
}
    `;
export const ShowFragmentFragmentDoc = gql`
    fragment ShowFragment on Podcast {
  id
  name
  description
  categories {
    category
    subcategory
    thirdCategory
  }
  language
  feedLimit
  isExplicit
  type
  email
  hostName
  timeZone
  lockFeed
  statsUrlPrefix
  hasAlituHosting
  userId
  transitionDefaults {
    intro {
      overlap
      fadeVolume
      isFadingOut
    }
    outro {
      overlap
      fadeVolume
      isFadingIn
    }
  }
  processingSettings {
    voiceAutoEq
    bgNoiseRemoval
    removeBreathings
  }
  showExpiresAt
  artworkUrl
  waveformPreference
  bitratePreference
  transcriptionPreferences {
    language
  }
  autoZoomPreference
  autoCenterPreference
  copyright
  subdomain
  links {
    apple
    spotify
    alituBadge
    facebookPage
    facebookGroup
    twitter
    instagram
    linkedin
    youtube
    website
    pandora
    iHeartRadio
    deezer
  }
  showHostingExpiresAt
  rssFeedUrl
  redirectUrl
  host
  thirdPartyRssFeed
  appleClaimToken
  submittedThroughAppleApi
}
    `;
export const SubscriptionFragmentFragmentDoc = gql`
    fragment SubscriptionFragment on Subscription {
  id
  status
  cancel_at_period_end
  current_period_end
  currency
  trial_end
  trial_start
  metadata {
    countryCode
  }
  plans {
    nickname
    amount
    interval
    currency
  }
  hostingExpiresAt
  pause_collection {
    resumes_at
  }
  hostingSuspended
  hostingLimit
  hasAlreadyPaused
}
    `;
export const SubscriptionDiscountFragmentFragmentDoc = gql`
    fragment SubscriptionDiscountFragment on Subscription {
  discount {
    id
    coupon {
      id
      percent_off
      amount_off
      duration
      duration_in_months
    }
  }
}
    `;
export const SubscriptionInvoiceFragmentFragmentDoc = gql`
    fragment SubscriptionInvoiceFragment on Subscription {
  latest_invoice {
    amount_due
    currency
    id
    lines {
      data {
        amount
        currency
        description
        quantity
      }
    }
    payment_intent {
      client_secret
    }
  }
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  id
  firstName
  lastName
  email
  session
  address
  phone
  company
  role
  isAuthenticated
  isTester
  activeProjectId
  callPermalink
  emailOptIn
  experienceLevel
  podcastPurpose
  heardAboutFrom
  createdAt
  marketingData
  autoZoomPreference
  autoCenterPreference
  transcriptionPreferences {
    language
  }
  waveformPreference
  bitratePreference
}
    `;
export const MetaDataFragmentDoc = gql`
    fragment MetaData on EpisodeMetaData {
  name
  summary
  description
  episodeNumber
  seasonNumber
  hostNames
  isExplicit
  type
  __typename
}
    `;
export const AudioItemAllFieldsFragmentDoc = gql`
    fragment AudioItemAllFields on AudioItem {
  type
  start
  end
  sourceStart
  resource
}
    `;
export const RemovedAudioItemAllFieldsFragmentDoc = gql`
    fragment RemovedAudioItemAllFields on RemovedAudioItem {
  type
  id
  start
  sourceStart
  duration
  magicFilter
  resource
}
    `;
export const SilenceItemAllFieldsFragmentDoc = gql`
    fragment SilenceItemAllFields on SilenceItem {
  type
  id
  start
  end
}
    `;
export const MuteItemAllFieldsFragmentDoc = gql`
    fragment MuteItemAllFields on MuteItem {
  type
  id
  start
  end
  sourceStart
  resource
}
    `;
export const BleepItemAllFieldsFragmentDoc = gql`
    fragment BleepItemAllFields on BleepItem {
  type
  id
  start
  end
  sourceStart
  resource
}
    `;
export const BackgroundItemAllFieldsFragmentDoc = gql`
    fragment BackgroundItemAllFields on BackgroundItem {
  type
  id
  start
  end
  sourceStart
  resource
  volume
  fadeInDuration
  fadeOutDuration
}
    `;
export const EpisodeFileFragmentDoc = gql`
    fragment EpisodeFile on EpisodeFile {
  id
  uniqueId
  type
  name
  bucket
  duration
  trimmedDuration
  overlapDuration
  audioTimeline {
    ...AudioItemAllFields
    ...RemovedAudioItemAllFields
    ...SilenceItemAllFields
    ...MuteItemAllFields
    ...BleepItemAllFields
    ...BackgroundItemAllFields
  }
  tags
  fade {
    isFadingIn
    isFadingOut
    fadeVolume
  }
  job {
    id
    schema
    status
    createdAt
    hash
    userId
  }
  additionalFiles {
    id
    name
    duration
  }
  hasMosaic
}
    ${AudioItemAllFieldsFragmentDoc}
${RemovedAudioItemAllFieldsFragmentDoc}
${SilenceItemAllFieldsFragmentDoc}
${MuteItemAllFieldsFragmentDoc}
${BleepItemAllFieldsFragmentDoc}
${BackgroundItemAllFieldsFragmentDoc}`;
export const EpisodeAllFieldsFragmentDoc = gql`
    fragment EpisodeAllFields on Episode {
  id
  metaData {
    ...MetaData
  }
  timeline {
    ...EpisodeFile
  }
  version
  isArchivedVersion
  createdAt
  publishedAt
  host
  shouldSuggestTitle
  shouldSuggestDescription
  shouldIncludeTranscriptInRss
  artworkUrl
  hasArtwork
  updatedAt
}
    ${MetaDataFragmentDoc}
${EpisodeFileFragmentDoc}`;
export const DefaultMusicFieldsFragmentDoc = gql`
    fragment DefaultMusicFields on File {
  id
  name
  type
}
    `;
export const GetApiKeysDocument = gql`
    query getApiKeys {
  getApiKeys {
    ...ApiKey
  }
}
    ${ApiKeyFragmentDoc}`;

/**
 * __useGetApiKeysQuery__
 *
 * To run a query within a React component, call `useGetApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
      }
export function useGetApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
        }
export function useGetApiKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
        }
export type GetApiKeysQueryHookResult = ReturnType<typeof useGetApiKeysQuery>;
export type GetApiKeysLazyQueryHookResult = ReturnType<typeof useGetApiKeysLazyQuery>;
export type GetApiKeysSuspenseQueryHookResult = ReturnType<typeof useGetApiKeysSuspenseQuery>;
export type GetApiKeysQueryResult = Apollo.QueryResult<GetApiKeysQuery, GetApiKeysQueryVariables>;
export const CreateApiKeyDocument = gql`
    mutation createApiKey($name: String!) {
  createApiKey(name: $name) {
    ...CreatedApiKey
  }
}
    ${CreatedApiKeyFragmentDoc}`;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationResult = Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const UpdateApiKeyDocument = gql`
    mutation updateApiKey($id: ID!, $input: ApiKeyUpdateInput!) {
  updateApiKey(id: $id, input: $input) {
    ...ApiKey
  }
}
    ${ApiKeyFragmentDoc}`;
export type UpdateApiKeyMutationFn = Apollo.MutationFunction<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;

/**
 * __useUpdateApiKeyMutation__
 *
 * To run a mutation, you first call `useUpdateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApiKeyMutation, { data, loading, error }] = useUpdateApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>(UpdateApiKeyDocument, options);
      }
export type UpdateApiKeyMutationHookResult = ReturnType<typeof useUpdateApiKeyMutation>;
export type UpdateApiKeyMutationResult = Apollo.MutationResult<UpdateApiKeyMutation>;
export type UpdateApiKeyMutationOptions = Apollo.BaseMutationOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;
export const DeleteAPiKeyDocument = gql`
    mutation deleteAPiKey($id: ID!) {
  deleteApiKey(id: $id) {
    ...ApiKey
  }
}
    ${ApiKeyFragmentDoc}`;
export type DeleteAPiKeyMutationFn = Apollo.MutationFunction<DeleteAPiKeyMutation, DeleteAPiKeyMutationVariables>;

/**
 * __useDeleteAPiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteAPiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAPiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAPiKeyMutation, { data, loading, error }] = useDeleteAPiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAPiKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAPiKeyMutation, DeleteAPiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAPiKeyMutation, DeleteAPiKeyMutationVariables>(DeleteAPiKeyDocument, options);
      }
export type DeleteAPiKeyMutationHookResult = ReturnType<typeof useDeleteAPiKeyMutation>;
export type DeleteAPiKeyMutationResult = Apollo.MutationResult<DeleteAPiKeyMutation>;
export type DeleteAPiKeyMutationOptions = Apollo.BaseMutationOptions<DeleteAPiKeyMutation, DeleteAPiKeyMutationVariables>;
export const CreateMetaDataJobDocument = gql`
    mutation createMetaDataJob($episodeId: ID!, $metaData: EpisodeMetaDataInput!) {
  createMetaDataJob(episodeId: $episodeId, metaData: $metaData) {
    id
  }
}
    `;
export type CreateMetaDataJobMutationFn = Apollo.MutationFunction<CreateMetaDataJobMutation, CreateMetaDataJobMutationVariables>;

/**
 * __useCreateMetaDataJobMutation__
 *
 * To run a mutation, you first call `useCreateMetaDataJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetaDataJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetaDataJobMutation, { data, loading, error }] = useCreateMetaDataJobMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      metaData: // value for 'metaData'
 *   },
 * });
 */
export function useCreateMetaDataJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateMetaDataJobMutation, CreateMetaDataJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMetaDataJobMutation, CreateMetaDataJobMutationVariables>(CreateMetaDataJobDocument, options);
      }
export type CreateMetaDataJobMutationHookResult = ReturnType<typeof useCreateMetaDataJobMutation>;
export type CreateMetaDataJobMutationResult = Apollo.MutationResult<CreateMetaDataJobMutation>;
export type CreateMetaDataJobMutationOptions = Apollo.BaseMutationOptions<CreateMetaDataJobMutation, CreateMetaDataJobMutationVariables>;
export const ShowDocument = gql`
    query show($id: ID!) {
  show(id: $id) {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;

/**
 * __useShowQuery__
 *
 * To run a query within a React component, call `useShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShowQuery(baseOptions: Apollo.QueryHookOptions<ShowQuery, ShowQueryVariables> & ({ variables: ShowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShowQuery, ShowQueryVariables>(ShowDocument, options);
      }
export function useShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShowQuery, ShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShowQuery, ShowQueryVariables>(ShowDocument, options);
        }
export function useShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShowQuery, ShowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShowQuery, ShowQueryVariables>(ShowDocument, options);
        }
export type ShowQueryHookResult = ReturnType<typeof useShowQuery>;
export type ShowLazyQueryHookResult = ReturnType<typeof useShowLazyQuery>;
export type ShowSuspenseQueryHookResult = ReturnType<typeof useShowSuspenseQuery>;
export type ShowQueryResult = Apollo.QueryResult<ShowQuery, ShowQueryVariables>;
export const UpdateTransitionDefaultsDocument = gql`
    mutation updateTransitionDefaults($data: TransitionDefaultsInput!) {
  updateTransitionDefaults(data: $data) {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;
export type UpdateTransitionDefaultsMutationFn = Apollo.MutationFunction<UpdateTransitionDefaultsMutation, UpdateTransitionDefaultsMutationVariables>;

/**
 * __useUpdateTransitionDefaultsMutation__
 *
 * To run a mutation, you first call `useUpdateTransitionDefaultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransitionDefaultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransitionDefaultsMutation, { data, loading, error }] = useUpdateTransitionDefaultsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTransitionDefaultsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransitionDefaultsMutation, UpdateTransitionDefaultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransitionDefaultsMutation, UpdateTransitionDefaultsMutationVariables>(UpdateTransitionDefaultsDocument, options);
      }
export type UpdateTransitionDefaultsMutationHookResult = ReturnType<typeof useUpdateTransitionDefaultsMutation>;
export type UpdateTransitionDefaultsMutationResult = Apollo.MutationResult<UpdateTransitionDefaultsMutation>;
export type UpdateTransitionDefaultsMutationOptions = Apollo.BaseMutationOptions<UpdateTransitionDefaultsMutation, UpdateTransitionDefaultsMutationVariables>;
export const RenewAlituHostingDocument = gql`
    mutation renewAlituHosting($showId: ID!) {
  renewAlituHosting(showId: $showId) {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;
export type RenewAlituHostingMutationFn = Apollo.MutationFunction<RenewAlituHostingMutation, RenewAlituHostingMutationVariables>;

/**
 * __useRenewAlituHostingMutation__
 *
 * To run a mutation, you first call `useRenewAlituHostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewAlituHostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewAlituHostingMutation, { data, loading, error }] = useRenewAlituHostingMutation({
 *   variables: {
 *      showId: // value for 'showId'
 *   },
 * });
 */
export function useRenewAlituHostingMutation(baseOptions?: Apollo.MutationHookOptions<RenewAlituHostingMutation, RenewAlituHostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewAlituHostingMutation, RenewAlituHostingMutationVariables>(RenewAlituHostingDocument, options);
      }
export type RenewAlituHostingMutationHookResult = ReturnType<typeof useRenewAlituHostingMutation>;
export type RenewAlituHostingMutationResult = Apollo.MutationResult<RenewAlituHostingMutation>;
export type RenewAlituHostingMutationOptions = Apollo.BaseMutationOptions<RenewAlituHostingMutation, RenewAlituHostingMutationVariables>;
export const GetSubscriptionDocument = gql`
    query getSubscription {
  subscription {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;

/**
 * __useGetSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
      }
export function useGetSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
export function useGetSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
export type GetSubscriptionQueryHookResult = ReturnType<typeof useGetSubscriptionQuery>;
export type GetSubscriptionLazyQueryHookResult = ReturnType<typeof useGetSubscriptionLazyQuery>;
export type GetSubscriptionSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionSuspenseQuery>;
export type GetSubscriptionQueryResult = Apollo.QueryResult<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export const UserDocument = gql`
    query user {
  user {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UploadUrlsDocument = gql`
    mutation uploadUrls($numberOfFiles: Int!) {
  uploadUrls(numberOfFiles: $numberOfFiles) {
    id
    url
  }
}
    `;
export type UploadUrlsMutationFn = Apollo.MutationFunction<UploadUrlsMutation, UploadUrlsMutationVariables>;

/**
 * __useUploadUrlsMutation__
 *
 * To run a mutation, you first call `useUploadUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadUrlsMutation, { data, loading, error }] = useUploadUrlsMutation({
 *   variables: {
 *      numberOfFiles: // value for 'numberOfFiles'
 *   },
 * });
 */
export function useUploadUrlsMutation(baseOptions?: Apollo.MutationHookOptions<UploadUrlsMutation, UploadUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadUrlsMutation, UploadUrlsMutationVariables>(UploadUrlsDocument, options);
      }
export type UploadUrlsMutationHookResult = ReturnType<typeof useUploadUrlsMutation>;
export type UploadUrlsMutationResult = Apollo.MutationResult<UploadUrlsMutation>;
export type UploadUrlsMutationOptions = Apollo.BaseMutationOptions<UploadUrlsMutation, UploadUrlsMutationVariables>;
export const CreateFileDocument = gql`
    mutation createFile($keys: [ID!]!, $filename: String!, $type: String!, $tags: [String], $skipAuphonic: Boolean, $isUniversal: Boolean, $duration: Float!) {
  createFile(
    keys: $keys
    filename: $filename
    type: $type
    tags: $tags
    skipAuphonic: $skipAuphonic
    isUniversal: $isUniversal
    duration: $duration
  ) {
    fileId
    jobId
  }
}
    `;
export type CreateFileMutationFn = Apollo.MutationFunction<CreateFileMutation, CreateFileMutationVariables>;

/**
 * __useCreateFileMutation__
 *
 * To run a mutation, you first call `useCreateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileMutation, { data, loading, error }] = useCreateFileMutation({
 *   variables: {
 *      keys: // value for 'keys'
 *      filename: // value for 'filename'
 *      type: // value for 'type'
 *      tags: // value for 'tags'
 *      skipAuphonic: // value for 'skipAuphonic'
 *      isUniversal: // value for 'isUniversal'
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useCreateFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateFileMutation, CreateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFileMutation, CreateFileMutationVariables>(CreateFileDocument, options);
      }
export type CreateFileMutationHookResult = ReturnType<typeof useCreateFileMutation>;
export type CreateFileMutationResult = Apollo.MutationResult<CreateFileMutation>;
export type CreateFileMutationOptions = Apollo.BaseMutationOptions<CreateFileMutation, CreateFileMutationVariables>;
export const PermissionsDocument = gql`
    query permissions {
  permissions {
    tier
    episodeLimit
  }
}
    `;

/**
 * __usePermissionsQuery__
 *
 * To run a query within a React component, call `usePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
      }
export function usePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
        }
export function usePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
        }
export type PermissionsQueryHookResult = ReturnType<typeof usePermissionsQuery>;
export type PermissionsLazyQueryHookResult = ReturnType<typeof usePermissionsLazyQuery>;
export type PermissionsSuspenseQueryHookResult = ReturnType<typeof usePermissionsSuspenseQuery>;
export type PermissionsQueryResult = Apollo.QueryResult<PermissionsQuery, PermissionsQueryVariables>;
export const ShowsDocument = gql`
    query shows {
  shows {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;

/**
 * __useShowsQuery__
 *
 * To run a query within a React component, call `useShowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useShowsQuery(baseOptions?: Apollo.QueryHookOptions<ShowsQuery, ShowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShowsQuery, ShowsQueryVariables>(ShowsDocument, options);
      }
export function useShowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShowsQuery, ShowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShowsQuery, ShowsQueryVariables>(ShowsDocument, options);
        }
export function useShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShowsQuery, ShowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShowsQuery, ShowsQueryVariables>(ShowsDocument, options);
        }
export type ShowsQueryHookResult = ReturnType<typeof useShowsQuery>;
export type ShowsLazyQueryHookResult = ReturnType<typeof useShowsLazyQuery>;
export type ShowsSuspenseQueryHookResult = ReturnType<typeof useShowsSuspenseQuery>;
export type ShowsQueryResult = Apollo.QueryResult<ShowsQuery, ShowsQueryVariables>;
export const AddShowDocument = gql`
    mutation addShow($name: String!) {
  addShow(name: $name)
}
    `;
export type AddShowMutationFn = Apollo.MutationFunction<AddShowMutation, AddShowMutationVariables>;

/**
 * __useAddShowMutation__
 *
 * To run a mutation, you first call `useAddShowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddShowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addShowMutation, { data, loading, error }] = useAddShowMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddShowMutation(baseOptions?: Apollo.MutationHookOptions<AddShowMutation, AddShowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddShowMutation, AddShowMutationVariables>(AddShowDocument, options);
      }
export type AddShowMutationHookResult = ReturnType<typeof useAddShowMutation>;
export type AddShowMutationResult = Apollo.MutationResult<AddShowMutation>;
export type AddShowMutationOptions = Apollo.BaseMutationOptions<AddShowMutation, AddShowMutationVariables>;
export const RemoveShowDocument = gql`
    mutation removeShow($id: ID!) {
  removeShow(id: $id) {
    success
  }
}
    `;
export type RemoveShowMutationFn = Apollo.MutationFunction<RemoveShowMutation, RemoveShowMutationVariables>;

/**
 * __useRemoveShowMutation__
 *
 * To run a mutation, you first call `useRemoveShowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveShowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeShowMutation, { data, loading, error }] = useRemoveShowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveShowMutation(baseOptions?: Apollo.MutationHookOptions<RemoveShowMutation, RemoveShowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveShowMutation, RemoveShowMutationVariables>(RemoveShowDocument, options);
      }
export type RemoveShowMutationHookResult = ReturnType<typeof useRemoveShowMutation>;
export type RemoveShowMutationResult = Apollo.MutationResult<RemoveShowMutation>;
export type RemoveShowMutationOptions = Apollo.BaseMutationOptions<RemoveShowMutation, RemoveShowMutationVariables>;
export const RenewShowDocument = gql`
    mutation renewShow($id: ID!) {
  renewShow(id: $id) {
    success
  }
}
    `;
export type RenewShowMutationFn = Apollo.MutationFunction<RenewShowMutation, RenewShowMutationVariables>;

/**
 * __useRenewShowMutation__
 *
 * To run a mutation, you first call `useRenewShowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewShowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewShowMutation, { data, loading, error }] = useRenewShowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRenewShowMutation(baseOptions?: Apollo.MutationHookOptions<RenewShowMutation, RenewShowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewShowMutation, RenewShowMutationVariables>(RenewShowDocument, options);
      }
export type RenewShowMutationHookResult = ReturnType<typeof useRenewShowMutation>;
export type RenewShowMutationResult = Apollo.MutationResult<RenewShowMutation>;
export type RenewShowMutationOptions = Apollo.BaseMutationOptions<RenewShowMutation, RenewShowMutationVariables>;
export const CreateEpisodeDocument = gql`
    mutation createEpisode($metaData: EpisodeMetaDataInput!) {
  episode: createEpisode(metaData: $metaData) {
    id
  }
}
    `;
export type CreateEpisodeMutationFn = Apollo.MutationFunction<CreateEpisodeMutation, CreateEpisodeMutationVariables>;

/**
 * __useCreateEpisodeMutation__
 *
 * To run a mutation, you first call `useCreateEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEpisodeMutation, { data, loading, error }] = useCreateEpisodeMutation({
 *   variables: {
 *      metaData: // value for 'metaData'
 *   },
 * });
 */
export function useCreateEpisodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEpisodeMutation, CreateEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEpisodeMutation, CreateEpisodeMutationVariables>(CreateEpisodeDocument, options);
      }
export type CreateEpisodeMutationHookResult = ReturnType<typeof useCreateEpisodeMutation>;
export type CreateEpisodeMutationResult = Apollo.MutationResult<CreateEpisodeMutation>;
export type CreateEpisodeMutationOptions = Apollo.BaseMutationOptions<CreateEpisodeMutation, CreateEpisodeMutationVariables>;
export const PopulateShowDetailsFromRssDocument = gql`
    mutation populateShowDetailsFromRss($rssFeedUrl: String!) {
  populateShowDetailsFromRss(rssFeedUrl: $rssFeedUrl) {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;
export type PopulateShowDetailsFromRssMutationFn = Apollo.MutationFunction<PopulateShowDetailsFromRssMutation, PopulateShowDetailsFromRssMutationVariables>;

/**
 * __usePopulateShowDetailsFromRssMutation__
 *
 * To run a mutation, you first call `usePopulateShowDetailsFromRssMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePopulateShowDetailsFromRssMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [populateShowDetailsFromRssMutation, { data, loading, error }] = usePopulateShowDetailsFromRssMutation({
 *   variables: {
 *      rssFeedUrl: // value for 'rssFeedUrl'
 *   },
 * });
 */
export function usePopulateShowDetailsFromRssMutation(baseOptions?: Apollo.MutationHookOptions<PopulateShowDetailsFromRssMutation, PopulateShowDetailsFromRssMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PopulateShowDetailsFromRssMutation, PopulateShowDetailsFromRssMutationVariables>(PopulateShowDetailsFromRssDocument, options);
      }
export type PopulateShowDetailsFromRssMutationHookResult = ReturnType<typeof usePopulateShowDetailsFromRssMutation>;
export type PopulateShowDetailsFromRssMutationResult = Apollo.MutationResult<PopulateShowDetailsFromRssMutation>;
export type PopulateShowDetailsFromRssMutationOptions = Apollo.BaseMutationOptions<PopulateShowDetailsFromRssMutation, PopulateShowDetailsFromRssMutationVariables>;
export const GetRssAndPopulateBuzzsproutShowDetailsDocument = gql`
    mutation getRssAndPopulateBuzzsproutShowDetails {
  getRssAndPopulateBuzzsproutShowDetails {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;
export type GetRssAndPopulateBuzzsproutShowDetailsMutationFn = Apollo.MutationFunction<GetRssAndPopulateBuzzsproutShowDetailsMutation, GetRssAndPopulateBuzzsproutShowDetailsMutationVariables>;

/**
 * __useGetRssAndPopulateBuzzsproutShowDetailsMutation__
 *
 * To run a mutation, you first call `useGetRssAndPopulateBuzzsproutShowDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetRssAndPopulateBuzzsproutShowDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getRssAndPopulateBuzzsproutShowDetailsMutation, { data, loading, error }] = useGetRssAndPopulateBuzzsproutShowDetailsMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetRssAndPopulateBuzzsproutShowDetailsMutation(baseOptions?: Apollo.MutationHookOptions<GetRssAndPopulateBuzzsproutShowDetailsMutation, GetRssAndPopulateBuzzsproutShowDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetRssAndPopulateBuzzsproutShowDetailsMutation, GetRssAndPopulateBuzzsproutShowDetailsMutationVariables>(GetRssAndPopulateBuzzsproutShowDetailsDocument, options);
      }
export type GetRssAndPopulateBuzzsproutShowDetailsMutationHookResult = ReturnType<typeof useGetRssAndPopulateBuzzsproutShowDetailsMutation>;
export type GetRssAndPopulateBuzzsproutShowDetailsMutationResult = Apollo.MutationResult<GetRssAndPopulateBuzzsproutShowDetailsMutation>;
export type GetRssAndPopulateBuzzsproutShowDetailsMutationOptions = Apollo.BaseMutationOptions<GetRssAndPopulateBuzzsproutShowDetailsMutation, GetRssAndPopulateBuzzsproutShowDetailsMutationVariables>;
export const GetRssAndPopulatePodbeanShowDetailsDocument = gql`
    mutation getRssAndPopulatePodbeanShowDetails {
  getRssAndPopulatePodbeanShowDetails {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;
export type GetRssAndPopulatePodbeanShowDetailsMutationFn = Apollo.MutationFunction<GetRssAndPopulatePodbeanShowDetailsMutation, GetRssAndPopulatePodbeanShowDetailsMutationVariables>;

/**
 * __useGetRssAndPopulatePodbeanShowDetailsMutation__
 *
 * To run a mutation, you first call `useGetRssAndPopulatePodbeanShowDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetRssAndPopulatePodbeanShowDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getRssAndPopulatePodbeanShowDetailsMutation, { data, loading, error }] = useGetRssAndPopulatePodbeanShowDetailsMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetRssAndPopulatePodbeanShowDetailsMutation(baseOptions?: Apollo.MutationHookOptions<GetRssAndPopulatePodbeanShowDetailsMutation, GetRssAndPopulatePodbeanShowDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetRssAndPopulatePodbeanShowDetailsMutation, GetRssAndPopulatePodbeanShowDetailsMutationVariables>(GetRssAndPopulatePodbeanShowDetailsDocument, options);
      }
export type GetRssAndPopulatePodbeanShowDetailsMutationHookResult = ReturnType<typeof useGetRssAndPopulatePodbeanShowDetailsMutation>;
export type GetRssAndPopulatePodbeanShowDetailsMutationResult = Apollo.MutationResult<GetRssAndPopulatePodbeanShowDetailsMutation>;
export type GetRssAndPopulatePodbeanShowDetailsMutationOptions = Apollo.BaseMutationOptions<GetRssAndPopulatePodbeanShowDetailsMutation, GetRssAndPopulatePodbeanShowDetailsMutationVariables>;
export const SubmitShowToAppleDocument = gql`
    mutation submitShowToApple {
  submitShowToApple {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;
export type SubmitShowToAppleMutationFn = Apollo.MutationFunction<SubmitShowToAppleMutation, SubmitShowToAppleMutationVariables>;

/**
 * __useSubmitShowToAppleMutation__
 *
 * To run a mutation, you first call `useSubmitShowToAppleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitShowToAppleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitShowToAppleMutation, { data, loading, error }] = useSubmitShowToAppleMutation({
 *   variables: {
 *   },
 * });
 */
export function useSubmitShowToAppleMutation(baseOptions?: Apollo.MutationHookOptions<SubmitShowToAppleMutation, SubmitShowToAppleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitShowToAppleMutation, SubmitShowToAppleMutationVariables>(SubmitShowToAppleDocument, options);
      }
export type SubmitShowToAppleMutationHookResult = ReturnType<typeof useSubmitShowToAppleMutation>;
export type SubmitShowToAppleMutationResult = Apollo.MutationResult<SubmitShowToAppleMutation>;
export type SubmitShowToAppleMutationOptions = Apollo.BaseMutationOptions<SubmitShowToAppleMutation, SubmitShowToAppleMutationVariables>;
export const PopulateAppleClaimTokenDocument = gql`
    mutation populateAppleClaimToken($token: String!) {
  populateAppleClaimToken(token: $token) {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;
export type PopulateAppleClaimTokenMutationFn = Apollo.MutationFunction<PopulateAppleClaimTokenMutation, PopulateAppleClaimTokenMutationVariables>;

/**
 * __usePopulateAppleClaimTokenMutation__
 *
 * To run a mutation, you first call `usePopulateAppleClaimTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePopulateAppleClaimTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [populateAppleClaimTokenMutation, { data, loading, error }] = usePopulateAppleClaimTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePopulateAppleClaimTokenMutation(baseOptions?: Apollo.MutationHookOptions<PopulateAppleClaimTokenMutation, PopulateAppleClaimTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PopulateAppleClaimTokenMutation, PopulateAppleClaimTokenMutationVariables>(PopulateAppleClaimTokenDocument, options);
      }
export type PopulateAppleClaimTokenMutationHookResult = ReturnType<typeof usePopulateAppleClaimTokenMutation>;
export type PopulateAppleClaimTokenMutationResult = Apollo.MutationResult<PopulateAppleClaimTokenMutation>;
export type PopulateAppleClaimTokenMutationOptions = Apollo.BaseMutationOptions<PopulateAppleClaimTokenMutation, PopulateAppleClaimTokenMutationVariables>;
export const CheckAppleShowStatusDocument = gql`
    query checkAppleShowStatus($appleShowId: String!) {
  checkAppleShowStatus(appleShowId: $appleShowId) {
    exists
  }
}
    `;

/**
 * __useCheckAppleShowStatusQuery__
 *
 * To run a query within a React component, call `useCheckAppleShowStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAppleShowStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAppleShowStatusQuery({
 *   variables: {
 *      appleShowId: // value for 'appleShowId'
 *   },
 * });
 */
export function useCheckAppleShowStatusQuery(baseOptions: Apollo.QueryHookOptions<CheckAppleShowStatusQuery, CheckAppleShowStatusQueryVariables> & ({ variables: CheckAppleShowStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckAppleShowStatusQuery, CheckAppleShowStatusQueryVariables>(CheckAppleShowStatusDocument, options);
      }
export function useCheckAppleShowStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckAppleShowStatusQuery, CheckAppleShowStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckAppleShowStatusQuery, CheckAppleShowStatusQueryVariables>(CheckAppleShowStatusDocument, options);
        }
export function useCheckAppleShowStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckAppleShowStatusQuery, CheckAppleShowStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckAppleShowStatusQuery, CheckAppleShowStatusQueryVariables>(CheckAppleShowStatusDocument, options);
        }
export type CheckAppleShowStatusQueryHookResult = ReturnType<typeof useCheckAppleShowStatusQuery>;
export type CheckAppleShowStatusLazyQueryHookResult = ReturnType<typeof useCheckAppleShowStatusLazyQuery>;
export type CheckAppleShowStatusSuspenseQueryHookResult = ReturnType<typeof useCheckAppleShowStatusSuspenseQuery>;
export type CheckAppleShowStatusQueryResult = Apollo.QueryResult<CheckAppleShowStatusQuery, CheckAppleShowStatusQueryVariables>;
export const AlituEpisodesCountPerShowDocument = gql`
    query alituEpisodesCountPerShow {
  alituEpisodesCountPerShow
}
    `;

/**
 * __useAlituEpisodesCountPerShowQuery__
 *
 * To run a query within a React component, call `useAlituEpisodesCountPerShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlituEpisodesCountPerShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlituEpisodesCountPerShowQuery({
 *   variables: {
 *   },
 * });
 */
export function useAlituEpisodesCountPerShowQuery(baseOptions?: Apollo.QueryHookOptions<AlituEpisodesCountPerShowQuery, AlituEpisodesCountPerShowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlituEpisodesCountPerShowQuery, AlituEpisodesCountPerShowQueryVariables>(AlituEpisodesCountPerShowDocument, options);
      }
export function useAlituEpisodesCountPerShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlituEpisodesCountPerShowQuery, AlituEpisodesCountPerShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlituEpisodesCountPerShowQuery, AlituEpisodesCountPerShowQueryVariables>(AlituEpisodesCountPerShowDocument, options);
        }
export function useAlituEpisodesCountPerShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlituEpisodesCountPerShowQuery, AlituEpisodesCountPerShowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlituEpisodesCountPerShowQuery, AlituEpisodesCountPerShowQueryVariables>(AlituEpisodesCountPerShowDocument, options);
        }
export type AlituEpisodesCountPerShowQueryHookResult = ReturnType<typeof useAlituEpisodesCountPerShowQuery>;
export type AlituEpisodesCountPerShowLazyQueryHookResult = ReturnType<typeof useAlituEpisodesCountPerShowLazyQuery>;
export type AlituEpisodesCountPerShowSuspenseQueryHookResult = ReturnType<typeof useAlituEpisodesCountPerShowSuspenseQuery>;
export type AlituEpisodesCountPerShowQueryResult = Apollo.QueryResult<AlituEpisodesCountPerShowQuery, AlituEpisodesCountPerShowQueryVariables>;
export const AddHostingDocument = gql`
    mutation addHosting($hostingPlan: String!) {
  addHosting(hostingPlan: $hostingPlan) {
    subscription {
      ...SubscriptionFragment
      ...SubscriptionDiscountFragment
    }
    show {
      ...ShowFragment
    }
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}
${ShowFragmentFragmentDoc}`;
export type AddHostingMutationFn = Apollo.MutationFunction<AddHostingMutation, AddHostingMutationVariables>;

/**
 * __useAddHostingMutation__
 *
 * To run a mutation, you first call `useAddHostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddHostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addHostingMutation, { data, loading, error }] = useAddHostingMutation({
 *   variables: {
 *      hostingPlan: // value for 'hostingPlan'
 *   },
 * });
 */
export function useAddHostingMutation(baseOptions?: Apollo.MutationHookOptions<AddHostingMutation, AddHostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddHostingMutation, AddHostingMutationVariables>(AddHostingDocument, options);
      }
export type AddHostingMutationHookResult = ReturnType<typeof useAddHostingMutation>;
export type AddHostingMutationResult = Apollo.MutationResult<AddHostingMutation>;
export type AddHostingMutationOptions = Apollo.BaseMutationOptions<AddHostingMutation, AddHostingMutationVariables>;
export const DeleteSubscriptionDocument = gql`
    mutation deleteSubscription($isPausing: Boolean) {
  deleteSubscription(isPausing: $isPausing) {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type DeleteSubscriptionMutationFn = Apollo.MutationFunction<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>;

/**
 * __useDeleteSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubscriptionMutation, { data, loading, error }] = useDeleteSubscriptionMutation({
 *   variables: {
 *      isPausing: // value for 'isPausing'
 *   },
 * });
 */
export function useDeleteSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>(DeleteSubscriptionDocument, options);
      }
export type DeleteSubscriptionMutationHookResult = ReturnType<typeof useDeleteSubscriptionMutation>;
export type DeleteSubscriptionMutationResult = Apollo.MutationResult<DeleteSubscriptionMutation>;
export type DeleteSubscriptionMutationOptions = Apollo.BaseMutationOptions<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>;
export const PauseSubscriptionDocument = gql`
    mutation pauseSubscription($typeformFormId: String!, $typeformResponseId: String!) {
  pauseSubscription(
    typeformFormId: $typeformFormId
    typeformResponseId: $typeformResponseId
  ) {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type PauseSubscriptionMutationFn = Apollo.MutationFunction<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>;

/**
 * __usePauseSubscriptionMutation__
 *
 * To run a mutation, you first call `usePauseSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseSubscriptionMutation, { data, loading, error }] = usePauseSubscriptionMutation({
 *   variables: {
 *      typeformFormId: // value for 'typeformFormId'
 *      typeformResponseId: // value for 'typeformResponseId'
 *   },
 * });
 */
export function usePauseSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>(PauseSubscriptionDocument, options);
      }
export type PauseSubscriptionMutationHookResult = ReturnType<typeof usePauseSubscriptionMutation>;
export type PauseSubscriptionMutationResult = Apollo.MutationResult<PauseSubscriptionMutation>;
export type PauseSubscriptionMutationOptions = Apollo.BaseMutationOptions<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>;
export const CancelHostingSubscriptionDocument = gql`
    mutation cancelHostingSubscription {
  cancelHostingSubscription {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type CancelHostingSubscriptionMutationFn = Apollo.MutationFunction<CancelHostingSubscriptionMutation, CancelHostingSubscriptionMutationVariables>;

/**
 * __useCancelHostingSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelHostingSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelHostingSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelHostingSubscriptionMutation, { data, loading, error }] = useCancelHostingSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelHostingSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelHostingSubscriptionMutation, CancelHostingSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelHostingSubscriptionMutation, CancelHostingSubscriptionMutationVariables>(CancelHostingSubscriptionDocument, options);
      }
export type CancelHostingSubscriptionMutationHookResult = ReturnType<typeof useCancelHostingSubscriptionMutation>;
export type CancelHostingSubscriptionMutationResult = Apollo.MutationResult<CancelHostingSubscriptionMutation>;
export type CancelHostingSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelHostingSubscriptionMutation, CancelHostingSubscriptionMutationVariables>;
export const UnpauseSubscriptionDocument = gql`
    mutation unpauseSubscription {
  unpauseSubscription {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type UnpauseSubscriptionMutationFn = Apollo.MutationFunction<UnpauseSubscriptionMutation, UnpauseSubscriptionMutationVariables>;

/**
 * __useUnpauseSubscriptionMutation__
 *
 * To run a mutation, you first call `useUnpauseSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpauseSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpauseSubscriptionMutation, { data, loading, error }] = useUnpauseSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnpauseSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UnpauseSubscriptionMutation, UnpauseSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpauseSubscriptionMutation, UnpauseSubscriptionMutationVariables>(UnpauseSubscriptionDocument, options);
      }
export type UnpauseSubscriptionMutationHookResult = ReturnType<typeof useUnpauseSubscriptionMutation>;
export type UnpauseSubscriptionMutationResult = Apollo.MutationResult<UnpauseSubscriptionMutation>;
export type UnpauseSubscriptionMutationOptions = Apollo.BaseMutationOptions<UnpauseSubscriptionMutation, UnpauseSubscriptionMutationVariables>;
export const UpgradeFromTrialDocument = gql`
    mutation upgradeFromTrial {
  upgradeFromTrial {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type UpgradeFromTrialMutationFn = Apollo.MutationFunction<UpgradeFromTrialMutation, UpgradeFromTrialMutationVariables>;

/**
 * __useUpgradeFromTrialMutation__
 *
 * To run a mutation, you first call `useUpgradeFromTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeFromTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeFromTrialMutation, { data, loading, error }] = useUpgradeFromTrialMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpgradeFromTrialMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeFromTrialMutation, UpgradeFromTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeFromTrialMutation, UpgradeFromTrialMutationVariables>(UpgradeFromTrialDocument, options);
      }
export type UpgradeFromTrialMutationHookResult = ReturnType<typeof useUpgradeFromTrialMutation>;
export type UpgradeFromTrialMutationResult = Apollo.MutationResult<UpgradeFromTrialMutation>;
export type UpgradeFromTrialMutationOptions = Apollo.BaseMutationOptions<UpgradeFromTrialMutation, UpgradeFromTrialMutationVariables>;
export const UpcomingInvoiceDocument = gql`
    query upcomingInvoice {
  upcomingInvoice {
    amount
    currency
  }
}
    `;

/**
 * __useUpcomingInvoiceQuery__
 *
 * To run a query within a React component, call `useUpcomingInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingInvoiceQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpcomingInvoiceQuery(baseOptions?: Apollo.QueryHookOptions<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>(UpcomingInvoiceDocument, options);
      }
export function useUpcomingInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>(UpcomingInvoiceDocument, options);
        }
export function useUpcomingInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>(UpcomingInvoiceDocument, options);
        }
export type UpcomingInvoiceQueryHookResult = ReturnType<typeof useUpcomingInvoiceQuery>;
export type UpcomingInvoiceLazyQueryHookResult = ReturnType<typeof useUpcomingInvoiceLazyQuery>;
export type UpcomingInvoiceSuspenseQueryHookResult = ReturnType<typeof useUpcomingInvoiceSuspenseQuery>;
export type UpcomingInvoiceQueryResult = Apollo.QueryResult<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>;
export const LoginDocument = gql`
    mutation login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    user {
      ...UserFragment
    }
    show {
      ...ShowFragment
    }
    subscription {
      ...SubscriptionFragment
      ...SubscriptionDiscountFragment
    }
  }
}
    ${UserFragmentFragmentDoc}
${ShowFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($userId: ID!, $firstName: String, $lastName: String, $email: String, $password: String, $isTester: Boolean, $bitratePreference: Int, $waveformPreference: String, $autoZoomPreference: Boolean, $autoCenterPreference: Boolean, $transcriptionLanguage: String, $activeProjectId: ID) {
  updateUser(
    userId: $userId
    input: {firstName: $firstName, lastName: $lastName, email: $email, password: $password, isTester: $isTester, bitratePreference: $bitratePreference, waveformPreference: $waveformPreference, autoZoomPreference: $autoZoomPreference, autoCenterPreference: $autoCenterPreference, transcriptionLanguage: $transcriptionLanguage, activeProjectId: $activeProjectId}
  ) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      isTester: // value for 'isTester'
 *      bitratePreference: // value for 'bitratePreference'
 *      waveformPreference: // value for 'waveformPreference'
 *      autoZoomPreference: // value for 'autoZoomPreference'
 *      autoCenterPreference: // value for 'autoCenterPreference'
 *      transcriptionLanguage: // value for 'transcriptionLanguage'
 *      activeProjectId: // value for 'activeProjectId'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const AssumeUserDocument = gql`
    query assumeUser($userId: ID!) {
  assumeUser(userId: $userId) {
    user {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useAssumeUserQuery__
 *
 * To run a query within a React component, call `useAssumeUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssumeUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssumeUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAssumeUserQuery(baseOptions: Apollo.QueryHookOptions<AssumeUserQuery, AssumeUserQueryVariables> & ({ variables: AssumeUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssumeUserQuery, AssumeUserQueryVariables>(AssumeUserDocument, options);
      }
export function useAssumeUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssumeUserQuery, AssumeUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssumeUserQuery, AssumeUserQueryVariables>(AssumeUserDocument, options);
        }
export function useAssumeUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssumeUserQuery, AssumeUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssumeUserQuery, AssumeUserQueryVariables>(AssumeUserDocument, options);
        }
export type AssumeUserQueryHookResult = ReturnType<typeof useAssumeUserQuery>;
export type AssumeUserLazyQueryHookResult = ReturnType<typeof useAssumeUserLazyQuery>;
export type AssumeUserSuspenseQueryHookResult = ReturnType<typeof useAssumeUserSuspenseQuery>;
export type AssumeUserQueryResult = Apollo.QueryResult<AssumeUserQuery, AssumeUserQueryVariables>;
export const JobDocument = gql`
    query job($jobId: ID!, $projectId: ID!) {
  job(id: $jobId, projectId: $projectId) {
    status
    schema
    createdAt
  }
}
    `;

/**
 * __useJobQuery__
 *
 * To run a query within a React component, call `useJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useJobQuery(baseOptions: Apollo.QueryHookOptions<JobQuery, JobQueryVariables> & ({ variables: JobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobQuery, JobQueryVariables>(JobDocument, options);
      }
export function useJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobQuery, JobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobQuery, JobQueryVariables>(JobDocument, options);
        }
export function useJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobQuery, JobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobQuery, JobQueryVariables>(JobDocument, options);
        }
export type JobQueryHookResult = ReturnType<typeof useJobQuery>;
export type JobLazyQueryHookResult = ReturnType<typeof useJobLazyQuery>;
export type JobSuspenseQueryHookResult = ReturnType<typeof useJobSuspenseQuery>;
export type JobQueryResult = Apollo.QueryResult<JobQuery, JobQueryVariables>;
export const AllJobsDocument = gql`
    query allJobs($limit: Int!, $hasFailed: Boolean, $isRunning: Boolean, $projectId: ID!) {
  allJobs(
    limit: $limit
    hasFailed: $hasFailed
    isRunning: $isRunning
    projectId: $projectId
  ) {
    createdAt
    id
    hash
    schema
    userId
    status
  }
}
    `;

/**
 * __useAllJobsQuery__
 *
 * To run a query within a React component, call `useAllJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllJobsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      hasFailed: // value for 'hasFailed'
 *      isRunning: // value for 'isRunning'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useAllJobsQuery(baseOptions: Apollo.QueryHookOptions<AllJobsQuery, AllJobsQueryVariables> & ({ variables: AllJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllJobsQuery, AllJobsQueryVariables>(AllJobsDocument, options);
      }
export function useAllJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllJobsQuery, AllJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllJobsQuery, AllJobsQueryVariables>(AllJobsDocument, options);
        }
export function useAllJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllJobsQuery, AllJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllJobsQuery, AllJobsQueryVariables>(AllJobsDocument, options);
        }
export type AllJobsQueryHookResult = ReturnType<typeof useAllJobsQuery>;
export type AllJobsLazyQueryHookResult = ReturnType<typeof useAllJobsLazyQuery>;
export type AllJobsSuspenseQueryHookResult = ReturnType<typeof useAllJobsSuspenseQuery>;
export type AllJobsQueryResult = Apollo.QueryResult<AllJobsQuery, AllJobsQueryVariables>;
export const JobLogsDocument = gql`
    query jobLogs($jobId: ID!, $projectId: ID!) {
  jobLogs(jobId: $jobId, projectId: $projectId) {
    id
    payload
    createdAt
  }
}
    `;

/**
 * __useJobLogsQuery__
 *
 * To run a query within a React component, call `useJobLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobLogsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useJobLogsQuery(baseOptions: Apollo.QueryHookOptions<JobLogsQuery, JobLogsQueryVariables> & ({ variables: JobLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobLogsQuery, JobLogsQueryVariables>(JobLogsDocument, options);
      }
export function useJobLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobLogsQuery, JobLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobLogsQuery, JobLogsQueryVariables>(JobLogsDocument, options);
        }
export function useJobLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobLogsQuery, JobLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobLogsQuery, JobLogsQueryVariables>(JobLogsDocument, options);
        }
export type JobLogsQueryHookResult = ReturnType<typeof useJobLogsQuery>;
export type JobLogsLazyQueryHookResult = ReturnType<typeof useJobLogsLazyQuery>;
export type JobLogsSuspenseQueryHookResult = ReturnType<typeof useJobLogsSuspenseQuery>;
export type JobLogsQueryResult = Apollo.QueryResult<JobLogsQuery, JobLogsQueryVariables>;
export const RerunJobDocument = gql`
    mutation rerunJob($jobId: ID!, $priority: Boolean) {
  rerunJob(jobId: $jobId, priority: $priority) {
    id
  }
}
    `;
export type RerunJobMutationFn = Apollo.MutationFunction<RerunJobMutation, RerunJobMutationVariables>;

/**
 * __useRerunJobMutation__
 *
 * To run a mutation, you first call `useRerunJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRerunJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rerunJobMutation, { data, loading, error }] = useRerunJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function useRerunJobMutation(baseOptions?: Apollo.MutationHookOptions<RerunJobMutation, RerunJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RerunJobMutation, RerunJobMutationVariables>(RerunJobDocument, options);
      }
export type RerunJobMutationHookResult = ReturnType<typeof useRerunJobMutation>;
export type RerunJobMutationResult = Apollo.MutationResult<RerunJobMutation>;
export type RerunJobMutationOptions = Apollo.BaseMutationOptions<RerunJobMutation, RerunJobMutationVariables>;
export const UsersDocument = gql`
    query users($email: String, $id: ID) {
  users(email: $email, id: $id) {
    id
    firstName
    lastName
    email
    address
    isTester
    activeProjectId
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      email: // value for 'email'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export function useUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const ProjectsDocument = gql`
    query projects($userId: Int!) {
  projects(userId: $userId) {
    id
    description
    name
  }
}
    `;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProjectsQuery(baseOptions: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables> & ({ variables: ProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
      }
export function useProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
export function useProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<typeof useProjectsLazyQuery>;
export type ProjectsSuspenseQueryHookResult = ReturnType<typeof useProjectsSuspenseQuery>;
export type ProjectsQueryResult = Apollo.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export const RegenerateRssDocument = gql`
    mutation regenerateRss($showId: ID!) {
  regenerateRss(showId: $showId) {
    success
  }
}
    `;
export type RegenerateRssMutationFn = Apollo.MutationFunction<RegenerateRssMutation, RegenerateRssMutationVariables>;

/**
 * __useRegenerateRssMutation__
 *
 * To run a mutation, you first call `useRegenerateRssMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateRssMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateRssMutation, { data, loading, error }] = useRegenerateRssMutation({
 *   variables: {
 *      showId: // value for 'showId'
 *   },
 * });
 */
export function useRegenerateRssMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateRssMutation, RegenerateRssMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateRssMutation, RegenerateRssMutationVariables>(RegenerateRssDocument, options);
      }
export type RegenerateRssMutationHookResult = ReturnType<typeof useRegenerateRssMutation>;
export type RegenerateRssMutationResult = Apollo.MutationResult<RegenerateRssMutation>;
export type RegenerateRssMutationOptions = Apollo.BaseMutationOptions<RegenerateRssMutation, RegenerateRssMutationVariables>;
export const RecoverDeletedFileDocument = gql`
    mutation recoverDeletedFile($fileId: ID!) {
  recoverDeletedFile(fileId: $fileId) {
    success
  }
}
    `;
export type RecoverDeletedFileMutationFn = Apollo.MutationFunction<RecoverDeletedFileMutation, RecoverDeletedFileMutationVariables>;

/**
 * __useRecoverDeletedFileMutation__
 *
 * To run a mutation, you first call `useRecoverDeletedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecoverDeletedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recoverDeletedFileMutation, { data, loading, error }] = useRecoverDeletedFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useRecoverDeletedFileMutation(baseOptions?: Apollo.MutationHookOptions<RecoverDeletedFileMutation, RecoverDeletedFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecoverDeletedFileMutation, RecoverDeletedFileMutationVariables>(RecoverDeletedFileDocument, options);
      }
export type RecoverDeletedFileMutationHookResult = ReturnType<typeof useRecoverDeletedFileMutation>;
export type RecoverDeletedFileMutationResult = Apollo.MutationResult<RecoverDeletedFileMutation>;
export type RecoverDeletedFileMutationOptions = Apollo.BaseMutationOptions<RecoverDeletedFileMutation, RecoverDeletedFileMutationVariables>;
export const RegenerateAllRssFeedsDocument = gql`
    mutation regenerateAllRssFeeds {
  regenerateAllRssFeeds {
    updated {
      projectId
    }
    failed {
      projectId
      error
    }
  }
}
    `;
export type RegenerateAllRssFeedsMutationFn = Apollo.MutationFunction<RegenerateAllRssFeedsMutation, RegenerateAllRssFeedsMutationVariables>;

/**
 * __useRegenerateAllRssFeedsMutation__
 *
 * To run a mutation, you first call `useRegenerateAllRssFeedsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateAllRssFeedsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateAllRssFeedsMutation, { data, loading, error }] = useRegenerateAllRssFeedsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRegenerateAllRssFeedsMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateAllRssFeedsMutation, RegenerateAllRssFeedsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateAllRssFeedsMutation, RegenerateAllRssFeedsMutationVariables>(RegenerateAllRssFeedsDocument, options);
      }
export type RegenerateAllRssFeedsMutationHookResult = ReturnType<typeof useRegenerateAllRssFeedsMutation>;
export type RegenerateAllRssFeedsMutationResult = Apollo.MutationResult<RegenerateAllRssFeedsMutation>;
export type RegenerateAllRssFeedsMutationOptions = Apollo.BaseMutationOptions<RegenerateAllRssFeedsMutation, RegenerateAllRssFeedsMutationVariables>;
export const AlituHostedShowsDocument = gql`
    query alituHostedShows($limit: Int!, $offset: Int!, $name: String, $userId: ID) {
  alituHostedShows(limit: $limit, offset: $offset, name: $name, userId: $userId) {
    shows {
      id
      name
      userId
      rssFeedUrl
      hostingSuspended
    }
    total
  }
}
    `;

/**
 * __useAlituHostedShowsQuery__
 *
 * To run a query within a React component, call `useAlituHostedShowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlituHostedShowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlituHostedShowsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      name: // value for 'name'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAlituHostedShowsQuery(baseOptions: Apollo.QueryHookOptions<AlituHostedShowsQuery, AlituHostedShowsQueryVariables> & ({ variables: AlituHostedShowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlituHostedShowsQuery, AlituHostedShowsQueryVariables>(AlituHostedShowsDocument, options);
      }
export function useAlituHostedShowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlituHostedShowsQuery, AlituHostedShowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlituHostedShowsQuery, AlituHostedShowsQueryVariables>(AlituHostedShowsDocument, options);
        }
export function useAlituHostedShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlituHostedShowsQuery, AlituHostedShowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlituHostedShowsQuery, AlituHostedShowsQueryVariables>(AlituHostedShowsDocument, options);
        }
export type AlituHostedShowsQueryHookResult = ReturnType<typeof useAlituHostedShowsQuery>;
export type AlituHostedShowsLazyQueryHookResult = ReturnType<typeof useAlituHostedShowsLazyQuery>;
export type AlituHostedShowsSuspenseQueryHookResult = ReturnType<typeof useAlituHostedShowsSuspenseQuery>;
export type AlituHostedShowsQueryResult = Apollo.QueryResult<AlituHostedShowsQuery, AlituHostedShowsQueryVariables>;
export const HostingLimitOffendersDocument = gql`
    query hostingLimitOffenders {
  hostingLimitOffenders {
    userId
    hostingLimit
    prevMonth1
    prevMonth2
    prevMonth3
  }
}
    `;

/**
 * __useHostingLimitOffendersQuery__
 *
 * To run a query within a React component, call `useHostingLimitOffendersQuery` and pass it any options that fit your needs.
 * When your component renders, `useHostingLimitOffendersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHostingLimitOffendersQuery({
 *   variables: {
 *   },
 * });
 */
export function useHostingLimitOffendersQuery(baseOptions?: Apollo.QueryHookOptions<HostingLimitOffendersQuery, HostingLimitOffendersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HostingLimitOffendersQuery, HostingLimitOffendersQueryVariables>(HostingLimitOffendersDocument, options);
      }
export function useHostingLimitOffendersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HostingLimitOffendersQuery, HostingLimitOffendersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HostingLimitOffendersQuery, HostingLimitOffendersQueryVariables>(HostingLimitOffendersDocument, options);
        }
export function useHostingLimitOffendersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HostingLimitOffendersQuery, HostingLimitOffendersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HostingLimitOffendersQuery, HostingLimitOffendersQueryVariables>(HostingLimitOffendersDocument, options);
        }
export type HostingLimitOffendersQueryHookResult = ReturnType<typeof useHostingLimitOffendersQuery>;
export type HostingLimitOffendersLazyQueryHookResult = ReturnType<typeof useHostingLimitOffendersLazyQuery>;
export type HostingLimitOffendersSuspenseQueryHookResult = ReturnType<typeof useHostingLimitOffendersSuspenseQuery>;
export type HostingLimitOffendersQueryResult = Apollo.QueryResult<HostingLimitOffendersQuery, HostingLimitOffendersQueryVariables>;
export const SuspendHostingDocument = gql`
    mutation suspendHosting($userId: ID!, $suspensionType: String) {
  suspendHosting(userId: $userId, suspensionType: $suspensionType) {
    success
  }
}
    `;
export type SuspendHostingMutationFn = Apollo.MutationFunction<SuspendHostingMutation, SuspendHostingMutationVariables>;

/**
 * __useSuspendHostingMutation__
 *
 * To run a mutation, you first call `useSuspendHostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendHostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendHostingMutation, { data, loading, error }] = useSuspendHostingMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      suspensionType: // value for 'suspensionType'
 *   },
 * });
 */
export function useSuspendHostingMutation(baseOptions?: Apollo.MutationHookOptions<SuspendHostingMutation, SuspendHostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendHostingMutation, SuspendHostingMutationVariables>(SuspendHostingDocument, options);
      }
export type SuspendHostingMutationHookResult = ReturnType<typeof useSuspendHostingMutation>;
export type SuspendHostingMutationResult = Apollo.MutationResult<SuspendHostingMutation>;
export type SuspendHostingMutationOptions = Apollo.BaseMutationOptions<SuspendHostingMutation, SuspendHostingMutationVariables>;
export const GetUserFilesForAdminDocument = gql`
    query getUserFilesForAdmin($userId: ID!, $name: String, $id: ID) {
  getUserFilesForAdmin(userId: $userId, name: $name, id: $id) {
    id
    name
    bucket
    createdAt
    deletedAt
    audioJobId
    jobStatus
  }
}
    `;

/**
 * __useGetUserFilesForAdminQuery__
 *
 * To run a query within a React component, call `useGetUserFilesForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFilesForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFilesForAdminQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserFilesForAdminQuery(baseOptions: Apollo.QueryHookOptions<GetUserFilesForAdminQuery, GetUserFilesForAdminQueryVariables> & ({ variables: GetUserFilesForAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFilesForAdminQuery, GetUserFilesForAdminQueryVariables>(GetUserFilesForAdminDocument, options);
      }
export function useGetUserFilesForAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFilesForAdminQuery, GetUserFilesForAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFilesForAdminQuery, GetUserFilesForAdminQueryVariables>(GetUserFilesForAdminDocument, options);
        }
export function useGetUserFilesForAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserFilesForAdminQuery, GetUserFilesForAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserFilesForAdminQuery, GetUserFilesForAdminQueryVariables>(GetUserFilesForAdminDocument, options);
        }
export type GetUserFilesForAdminQueryHookResult = ReturnType<typeof useGetUserFilesForAdminQuery>;
export type GetUserFilesForAdminLazyQueryHookResult = ReturnType<typeof useGetUserFilesForAdminLazyQuery>;
export type GetUserFilesForAdminSuspenseQueryHookResult = ReturnType<typeof useGetUserFilesForAdminSuspenseQuery>;
export type GetUserFilesForAdminQueryResult = Apollo.QueryResult<GetUserFilesForAdminQuery, GetUserFilesForAdminQueryVariables>;
export const UpdateContentDocument = gql`
    mutation updateContent($section: String!, $content: JSON!) {
  updateContent(section: $section, content: $content) {
    success
  }
}
    `;
export type UpdateContentMutationFn = Apollo.MutationFunction<UpdateContentMutation, UpdateContentMutationVariables>;

/**
 * __useUpdateContentMutation__
 *
 * To run a mutation, you first call `useUpdateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentMutation, { data, loading, error }] = useUpdateContentMutation({
 *   variables: {
 *      section: // value for 'section'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdateContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentMutation, UpdateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentMutation, UpdateContentMutationVariables>(UpdateContentDocument, options);
      }
export type UpdateContentMutationHookResult = ReturnType<typeof useUpdateContentMutation>;
export type UpdateContentMutationResult = Apollo.MutationResult<UpdateContentMutation>;
export type UpdateContentMutationOptions = Apollo.BaseMutationOptions<UpdateContentMutation, UpdateContentMutationVariables>;
export const SignupPageContentDocument = gql`
    query signupPageContent {
  signupPageContent {
    mainTitle
    sidebarContent
  }
}
    `;

/**
 * __useSignupPageContentQuery__
 *
 * To run a query within a React component, call `useSignupPageContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignupPageContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignupPageContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignupPageContentQuery(baseOptions?: Apollo.QueryHookOptions<SignupPageContentQuery, SignupPageContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignupPageContentQuery, SignupPageContentQueryVariables>(SignupPageContentDocument, options);
      }
export function useSignupPageContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignupPageContentQuery, SignupPageContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignupPageContentQuery, SignupPageContentQueryVariables>(SignupPageContentDocument, options);
        }
export function useSignupPageContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignupPageContentQuery, SignupPageContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SignupPageContentQuery, SignupPageContentQueryVariables>(SignupPageContentDocument, options);
        }
export type SignupPageContentQueryHookResult = ReturnType<typeof useSignupPageContentQuery>;
export type SignupPageContentLazyQueryHookResult = ReturnType<typeof useSignupPageContentLazyQuery>;
export type SignupPageContentSuspenseQueryHookResult = ReturnType<typeof useSignupPageContentSuspenseQuery>;
export type SignupPageContentQueryResult = Apollo.QueryResult<SignupPageContentQuery, SignupPageContentQueryVariables>;
export const AddSubscriptionToUserDocument = gql`
    mutation addSubscriptionToUser($userId: ID!, $subscriptionId: ID!, $customerId: ID!) {
  addSubscriptionToUser(
    userId: $userId
    subscriptionId: $subscriptionId
    customerId: $customerId
  )
}
    `;
export type AddSubscriptionToUserMutationFn = Apollo.MutationFunction<AddSubscriptionToUserMutation, AddSubscriptionToUserMutationVariables>;

/**
 * __useAddSubscriptionToUserMutation__
 *
 * To run a mutation, you first call `useAddSubscriptionToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSubscriptionToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSubscriptionToUserMutation, { data, loading, error }] = useAddSubscriptionToUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      subscriptionId: // value for 'subscriptionId'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useAddSubscriptionToUserMutation(baseOptions?: Apollo.MutationHookOptions<AddSubscriptionToUserMutation, AddSubscriptionToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSubscriptionToUserMutation, AddSubscriptionToUserMutationVariables>(AddSubscriptionToUserDocument, options);
      }
export type AddSubscriptionToUserMutationHookResult = ReturnType<typeof useAddSubscriptionToUserMutation>;
export type AddSubscriptionToUserMutationResult = Apollo.MutationResult<AddSubscriptionToUserMutation>;
export type AddSubscriptionToUserMutationOptions = Apollo.BaseMutationOptions<AddSubscriptionToUserMutation, AddSubscriptionToUserMutationVariables>;
export const DeleteAllUserDataDocument = gql`
    mutation deleteAllUserData($userId: ID!) {
  deleteAllUserData(userId: $userId)
}
    `;
export type DeleteAllUserDataMutationFn = Apollo.MutationFunction<DeleteAllUserDataMutation, DeleteAllUserDataMutationVariables>;

/**
 * __useDeleteAllUserDataMutation__
 *
 * To run a mutation, you first call `useDeleteAllUserDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllUserDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllUserDataMutation, { data, loading, error }] = useDeleteAllUserDataMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteAllUserDataMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAllUserDataMutation, DeleteAllUserDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAllUserDataMutation, DeleteAllUserDataMutationVariables>(DeleteAllUserDataDocument, options);
      }
export type DeleteAllUserDataMutationHookResult = ReturnType<typeof useDeleteAllUserDataMutation>;
export type DeleteAllUserDataMutationResult = Apollo.MutationResult<DeleteAllUserDataMutation>;
export type DeleteAllUserDataMutationOptions = Apollo.BaseMutationOptions<DeleteAllUserDataMutation, DeleteAllUserDataMutationVariables>;
export const EpisodeMetadataDocument = gql`
    query episodeMetadata($id: ID!) {
  episode(id: $id) {
    id
    metaData {
      ...MetaData
    }
  }
}
    ${MetaDataFragmentDoc}`;

/**
 * __useEpisodeMetadataQuery__
 *
 * To run a query within a React component, call `useEpisodeMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpisodeMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpisodeMetadataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEpisodeMetadataQuery(baseOptions: Apollo.QueryHookOptions<EpisodeMetadataQuery, EpisodeMetadataQueryVariables> & ({ variables: EpisodeMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpisodeMetadataQuery, EpisodeMetadataQueryVariables>(EpisodeMetadataDocument, options);
      }
export function useEpisodeMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpisodeMetadataQuery, EpisodeMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpisodeMetadataQuery, EpisodeMetadataQueryVariables>(EpisodeMetadataDocument, options);
        }
export function useEpisodeMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodeMetadataQuery, EpisodeMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EpisodeMetadataQuery, EpisodeMetadataQueryVariables>(EpisodeMetadataDocument, options);
        }
export type EpisodeMetadataQueryHookResult = ReturnType<typeof useEpisodeMetadataQuery>;
export type EpisodeMetadataLazyQueryHookResult = ReturnType<typeof useEpisodeMetadataLazyQuery>;
export type EpisodeMetadataSuspenseQueryHookResult = ReturnType<typeof useEpisodeMetadataSuspenseQuery>;
export type EpisodeMetadataQueryResult = Apollo.QueryResult<EpisodeMetadataQuery, EpisodeMetadataQueryVariables>;
export const UpdateEpisodeMetadataDocument = gql`
    mutation updateEpisodeMetadata($id: ID!, $metaData: EpisodeMetaDataInput, $version: Int, $clearFileField: Boolean) {
  episode: updateEpisode(
    id: $id
    metaData: $metaData
    version: $version
    clearFileField: $clearFileField
  ) {
    id
    metaData {
      name
      summary
      description
      episodeNumber
      seasonNumber
      hostNames
      isExplicit
      type
      __typename
    }
    version
  }
}
    `;
export type UpdateEpisodeMetadataMutationFn = Apollo.MutationFunction<UpdateEpisodeMetadataMutation, UpdateEpisodeMetadataMutationVariables>;

/**
 * __useUpdateEpisodeMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateEpisodeMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEpisodeMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEpisodeMetadataMutation, { data, loading, error }] = useUpdateEpisodeMetadataMutation({
 *   variables: {
 *      id: // value for 'id'
 *      metaData: // value for 'metaData'
 *      version: // value for 'version'
 *      clearFileField: // value for 'clearFileField'
 *   },
 * });
 */
export function useUpdateEpisodeMetadataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEpisodeMetadataMutation, UpdateEpisodeMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEpisodeMetadataMutation, UpdateEpisodeMetadataMutationVariables>(UpdateEpisodeMetadataDocument, options);
      }
export type UpdateEpisodeMetadataMutationHookResult = ReturnType<typeof useUpdateEpisodeMetadataMutation>;
export type UpdateEpisodeMetadataMutationResult = Apollo.MutationResult<UpdateEpisodeMetadataMutation>;
export type UpdateEpisodeMetadataMutationOptions = Apollo.BaseMutationOptions<UpdateEpisodeMetadataMutation, UpdateEpisodeMetadataMutationVariables>;
export const DeleteRecordingDocument = gql`
    mutation deleteRecording($id: ID!) {
  deleteRecording(id: $id)
}
    `;
export type DeleteRecordingMutationFn = Apollo.MutationFunction<DeleteRecordingMutation, DeleteRecordingMutationVariables>;

/**
 * __useDeleteRecordingMutation__
 *
 * To run a mutation, you first call `useDeleteRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecordingMutation, { data, loading, error }] = useDeleteRecordingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRecordingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecordingMutation, DeleteRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecordingMutation, DeleteRecordingMutationVariables>(DeleteRecordingDocument, options);
      }
export type DeleteRecordingMutationHookResult = ReturnType<typeof useDeleteRecordingMutation>;
export type DeleteRecordingMutationResult = Apollo.MutationResult<DeleteRecordingMutation>;
export type DeleteRecordingMutationOptions = Apollo.BaseMutationOptions<DeleteRecordingMutation, DeleteRecordingMutationVariables>;
export const PauseRecordingDocument = gql`
    mutation pauseRecording($id: ID!, $paused: Boolean!) {
  pauseRecording(id: $id, paused: $paused)
}
    `;
export type PauseRecordingMutationFn = Apollo.MutationFunction<PauseRecordingMutation, PauseRecordingMutationVariables>;

/**
 * __usePauseRecordingMutation__
 *
 * To run a mutation, you first call `usePauseRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseRecordingMutation, { data, loading, error }] = usePauseRecordingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      paused: // value for 'paused'
 *   },
 * });
 */
export function usePauseRecordingMutation(baseOptions?: Apollo.MutationHookOptions<PauseRecordingMutation, PauseRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseRecordingMutation, PauseRecordingMutationVariables>(PauseRecordingDocument, options);
      }
export type PauseRecordingMutationHookResult = ReturnType<typeof usePauseRecordingMutation>;
export type PauseRecordingMutationResult = Apollo.MutationResult<PauseRecordingMutation>;
export type PauseRecordingMutationOptions = Apollo.BaseMutationOptions<PauseRecordingMutation, PauseRecordingMutationVariables>;
export const CallDocument = gql`
    query call($id: ID!) {
  call(id: $id) {
    job {
      status
      schema
    }
  }
}
    `;

/**
 * __useCallQuery__
 *
 * To run a query within a React component, call `useCallQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCallQuery(baseOptions: Apollo.QueryHookOptions<CallQuery, CallQueryVariables> & ({ variables: CallQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallQuery, CallQueryVariables>(CallDocument, options);
      }
export function useCallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallQuery, CallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallQuery, CallQueryVariables>(CallDocument, options);
        }
export function useCallSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CallQuery, CallQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CallQuery, CallQueryVariables>(CallDocument, options);
        }
export type CallQueryHookResult = ReturnType<typeof useCallQuery>;
export type CallLazyQueryHookResult = ReturnType<typeof useCallLazyQuery>;
export type CallSuspenseQueryHookResult = ReturnType<typeof useCallSuspenseQuery>;
export type CallQueryResult = Apollo.QueryResult<CallQuery, CallQueryVariables>;
export const CreateChunkUploadUrlDocument = gql`
    mutation createChunkUploadUrl($callId: ID!, $instanceId: String!, $timestamp: Date!) {
  createChunkUploadUrl(
    callId: $callId
    instanceId: $instanceId
    timestamp: $timestamp
  ) {
    url
  }
}
    `;
export type CreateChunkUploadUrlMutationFn = Apollo.MutationFunction<CreateChunkUploadUrlMutation, CreateChunkUploadUrlMutationVariables>;

/**
 * __useCreateChunkUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateChunkUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChunkUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChunkUploadUrlMutation, { data, loading, error }] = useCreateChunkUploadUrlMutation({
 *   variables: {
 *      callId: // value for 'callId'
 *      instanceId: // value for 'instanceId'
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useCreateChunkUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateChunkUploadUrlMutation, CreateChunkUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChunkUploadUrlMutation, CreateChunkUploadUrlMutationVariables>(CreateChunkUploadUrlDocument, options);
      }
export type CreateChunkUploadUrlMutationHookResult = ReturnType<typeof useCreateChunkUploadUrlMutation>;
export type CreateChunkUploadUrlMutationResult = Apollo.MutationResult<CreateChunkUploadUrlMutation>;
export type CreateChunkUploadUrlMutationOptions = Apollo.BaseMutationOptions<CreateChunkUploadUrlMutation, CreateChunkUploadUrlMutationVariables>;
export const ConcatenateChunksDocument = gql`
    mutation concatenateChunks($callId: ID!, $instanceId: String!) {
  concatenateChunks(callId: $callId, instanceId: $instanceId)
}
    `;
export type ConcatenateChunksMutationFn = Apollo.MutationFunction<ConcatenateChunksMutation, ConcatenateChunksMutationVariables>;

/**
 * __useConcatenateChunksMutation__
 *
 * To run a mutation, you first call `useConcatenateChunksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConcatenateChunksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [concatenateChunksMutation, { data, loading, error }] = useConcatenateChunksMutation({
 *   variables: {
 *      callId: // value for 'callId'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useConcatenateChunksMutation(baseOptions?: Apollo.MutationHookOptions<ConcatenateChunksMutation, ConcatenateChunksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConcatenateChunksMutation, ConcatenateChunksMutationVariables>(ConcatenateChunksDocument, options);
      }
export type ConcatenateChunksMutationHookResult = ReturnType<typeof useConcatenateChunksMutation>;
export type ConcatenateChunksMutationResult = Apollo.MutationResult<ConcatenateChunksMutation>;
export type ConcatenateChunksMutationOptions = Apollo.BaseMutationOptions<ConcatenateChunksMutation, ConcatenateChunksMutationVariables>;
export const CreateRecordingDocument = gql`
    mutation createRecording($callId: ID!, $duration: Float!, $instanceId: String, $fileName: String) {
  createRecording(
    callId: $callId
    duration: $duration
    instanceId: $instanceId
    fileName: $fileName
  ) {
    fileId
  }
}
    `;
export type CreateRecordingMutationFn = Apollo.MutationFunction<CreateRecordingMutation, CreateRecordingMutationVariables>;

/**
 * __useCreateRecordingMutation__
 *
 * To run a mutation, you first call `useCreateRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecordingMutation, { data, loading, error }] = useCreateRecordingMutation({
 *   variables: {
 *      callId: // value for 'callId'
 *      duration: // value for 'duration'
 *      instanceId: // value for 'instanceId'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useCreateRecordingMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecordingMutation, CreateRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecordingMutation, CreateRecordingMutationVariables>(CreateRecordingDocument, options);
      }
export type CreateRecordingMutationHookResult = ReturnType<typeof useCreateRecordingMutation>;
export type CreateRecordingMutationResult = Apollo.MutationResult<CreateRecordingMutation>;
export type CreateRecordingMutationOptions = Apollo.BaseMutationOptions<CreateRecordingMutation, CreateRecordingMutationVariables>;
export const CreateRecordingUploadUrlDocument = gql`
    mutation createRecordingUploadUrl($callId: ID!, $instanceId: String!) {
  createRecordingUploadUrl(callId: $callId, instanceId: $instanceId) {
    url
  }
}
    `;
export type CreateRecordingUploadUrlMutationFn = Apollo.MutationFunction<CreateRecordingUploadUrlMutation, CreateRecordingUploadUrlMutationVariables>;

/**
 * __useCreateRecordingUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateRecordingUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecordingUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecordingUploadUrlMutation, { data, loading, error }] = useCreateRecordingUploadUrlMutation({
 *   variables: {
 *      callId: // value for 'callId'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useCreateRecordingUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecordingUploadUrlMutation, CreateRecordingUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecordingUploadUrlMutation, CreateRecordingUploadUrlMutationVariables>(CreateRecordingUploadUrlDocument, options);
      }
export type CreateRecordingUploadUrlMutationHookResult = ReturnType<typeof useCreateRecordingUploadUrlMutation>;
export type CreateRecordingUploadUrlMutationResult = Apollo.MutationResult<CreateRecordingUploadUrlMutation>;
export type CreateRecordingUploadUrlMutationOptions = Apollo.BaseMutationOptions<CreateRecordingUploadUrlMutation, CreateRecordingUploadUrlMutationVariables>;
export const AddCallTrackDocument = gql`
    mutation addCallTrack($callId: ID!, $instanceId: String!, $startTime: Date!) {
  addCallTrack(callId: $callId, instanceId: $instanceId, startTime: $startTime)
}
    `;
export type AddCallTrackMutationFn = Apollo.MutationFunction<AddCallTrackMutation, AddCallTrackMutationVariables>;

/**
 * __useAddCallTrackMutation__
 *
 * To run a mutation, you first call `useAddCallTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCallTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCallTrackMutation, { data, loading, error }] = useAddCallTrackMutation({
 *   variables: {
 *      callId: // value for 'callId'
 *      instanceId: // value for 'instanceId'
 *      startTime: // value for 'startTime'
 *   },
 * });
 */
export function useAddCallTrackMutation(baseOptions?: Apollo.MutationHookOptions<AddCallTrackMutation, AddCallTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCallTrackMutation, AddCallTrackMutationVariables>(AddCallTrackDocument, options);
      }
export type AddCallTrackMutationHookResult = ReturnType<typeof useAddCallTrackMutation>;
export type AddCallTrackMutationResult = Apollo.MutationResult<AddCallTrackMutation>;
export type AddCallTrackMutationOptions = Apollo.BaseMutationOptions<AddCallTrackMutation, AddCallTrackMutationVariables>;
export const ProjectFilesDocument = gql`
    query projectFiles($name: String, $offset: Int!, $limit: Int!, $tags: String) {
  projectFiles: getProjectFiles(
    name: $name
    offset: $offset
    limit: $limit
    tags: $tags
  ) {
    total
    files {
      id
      name
      type
      tags
      bucket
      codecInformation {
        format {
          duration
        }
      }
      users {
        userFile
      }
      audioJob {
        id
        status
        schema
        createdAt
        hash
        userId
      }
      createdAt
    }
  }
}
    `;

/**
 * __useProjectFilesQuery__
 *
 * To run a query within a React component, call `useProjectFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFilesQuery({
 *   variables: {
 *      name: // value for 'name'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useProjectFilesQuery(baseOptions: Apollo.QueryHookOptions<ProjectFilesQuery, ProjectFilesQueryVariables> & ({ variables: ProjectFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectFilesQuery, ProjectFilesQueryVariables>(ProjectFilesDocument, options);
      }
export function useProjectFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectFilesQuery, ProjectFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectFilesQuery, ProjectFilesQueryVariables>(ProjectFilesDocument, options);
        }
export function useProjectFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectFilesQuery, ProjectFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectFilesQuery, ProjectFilesQueryVariables>(ProjectFilesDocument, options);
        }
export type ProjectFilesQueryHookResult = ReturnType<typeof useProjectFilesQuery>;
export type ProjectFilesLazyQueryHookResult = ReturnType<typeof useProjectFilesLazyQuery>;
export type ProjectFilesSuspenseQueryHookResult = ReturnType<typeof useProjectFilesSuspenseQuery>;
export type ProjectFilesQueryResult = Apollo.QueryResult<ProjectFilesQuery, ProjectFilesQueryVariables>;
export const ProjectFilesAndFoldersDocument = gql`
    query projectFilesAndFolders($name: String, $folderId: ID, $tags: String, $offset: Int!, $limit: Int) {
  projectFiles: getProjectFilesAndFolders(
    name: $name
    folderId: $folderId
    tags: $tags
    offset: $offset
    limit: $limit
  ) {
    total
    files {
      id
      fileId
      folderId
      name
      audioJob {
        status
        hasMosaic
      }
      bucket
      codecInformation {
        format {
          duration
        }
      }
      tags
      bookmarked
      createdAt
      userId
      fileCount
    }
  }
}
    `;

/**
 * __useProjectFilesAndFoldersQuery__
 *
 * To run a query within a React component, call `useProjectFilesAndFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFilesAndFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFilesAndFoldersQuery({
 *   variables: {
 *      name: // value for 'name'
 *      folderId: // value for 'folderId'
 *      tags: // value for 'tags'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProjectFilesAndFoldersQuery(baseOptions: Apollo.QueryHookOptions<ProjectFilesAndFoldersQuery, ProjectFilesAndFoldersQueryVariables> & ({ variables: ProjectFilesAndFoldersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectFilesAndFoldersQuery, ProjectFilesAndFoldersQueryVariables>(ProjectFilesAndFoldersDocument, options);
      }
export function useProjectFilesAndFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectFilesAndFoldersQuery, ProjectFilesAndFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectFilesAndFoldersQuery, ProjectFilesAndFoldersQueryVariables>(ProjectFilesAndFoldersDocument, options);
        }
export function useProjectFilesAndFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectFilesAndFoldersQuery, ProjectFilesAndFoldersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectFilesAndFoldersQuery, ProjectFilesAndFoldersQueryVariables>(ProjectFilesAndFoldersDocument, options);
        }
export type ProjectFilesAndFoldersQueryHookResult = ReturnType<typeof useProjectFilesAndFoldersQuery>;
export type ProjectFilesAndFoldersLazyQueryHookResult = ReturnType<typeof useProjectFilesAndFoldersLazyQuery>;
export type ProjectFilesAndFoldersSuspenseQueryHookResult = ReturnType<typeof useProjectFilesAndFoldersSuspenseQuery>;
export type ProjectFilesAndFoldersQueryResult = Apollo.QueryResult<ProjectFilesAndFoldersQuery, ProjectFilesAndFoldersQueryVariables>;
export const GetFoldersDocument = gql`
    query getFolders {
  getFolders {
    id
    name
  }
}
    `;

/**
 * __useGetFoldersQuery__
 *
 * To run a query within a React component, call `useGetFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFoldersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFoldersQuery(baseOptions?: Apollo.QueryHookOptions<GetFoldersQuery, GetFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFoldersQuery, GetFoldersQueryVariables>(GetFoldersDocument, options);
      }
export function useGetFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFoldersQuery, GetFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFoldersQuery, GetFoldersQueryVariables>(GetFoldersDocument, options);
        }
export function useGetFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFoldersQuery, GetFoldersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFoldersQuery, GetFoldersQueryVariables>(GetFoldersDocument, options);
        }
export type GetFoldersQueryHookResult = ReturnType<typeof useGetFoldersQuery>;
export type GetFoldersLazyQueryHookResult = ReturnType<typeof useGetFoldersLazyQuery>;
export type GetFoldersSuspenseQueryHookResult = ReturnType<typeof useGetFoldersSuspenseQuery>;
export type GetFoldersQueryResult = Apollo.QueryResult<GetFoldersQuery, GetFoldersQueryVariables>;
export const CreateFolderDocument = gql`
    mutation createFolder($name: String!, $projectId: ID!) {
  createFolder(name: $name, projectId: $projectId) {
    id
    name
  }
}
    `;
export type CreateFolderMutationFn = Apollo.MutationFunction<CreateFolderMutation, CreateFolderMutationVariables>;

/**
 * __useCreateFolderMutation__
 *
 * To run a mutation, you first call `useCreateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFolderMutation, { data, loading, error }] = useCreateFolderMutation({
 *   variables: {
 *      name: // value for 'name'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateFolderMutation, CreateFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFolderMutation, CreateFolderMutationVariables>(CreateFolderDocument, options);
      }
export type CreateFolderMutationHookResult = ReturnType<typeof useCreateFolderMutation>;
export type CreateFolderMutationResult = Apollo.MutationResult<CreateFolderMutation>;
export type CreateFolderMutationOptions = Apollo.BaseMutationOptions<CreateFolderMutation, CreateFolderMutationVariables>;
export const UpdateFolderDocument = gql`
    mutation updateFolder($id: ID!, $name: String!, $projectId: ID!) {
  updateFolder(id: $id, name: $name, projectId: $projectId)
}
    `;
export type UpdateFolderMutationFn = Apollo.MutationFunction<UpdateFolderMutation, UpdateFolderMutationVariables>;

/**
 * __useUpdateFolderMutation__
 *
 * To run a mutation, you first call `useUpdateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFolderMutation, { data, loading, error }] = useUpdateFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUpdateFolderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFolderMutation, UpdateFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFolderMutation, UpdateFolderMutationVariables>(UpdateFolderDocument, options);
      }
export type UpdateFolderMutationHookResult = ReturnType<typeof useUpdateFolderMutation>;
export type UpdateFolderMutationResult = Apollo.MutationResult<UpdateFolderMutation>;
export type UpdateFolderMutationOptions = Apollo.BaseMutationOptions<UpdateFolderMutation, UpdateFolderMutationVariables>;
export const DeleteFolderDocument = gql`
    mutation deleteFolder($id: ID!, $projectId: ID!) {
  deleteFolder(id: $id, projectId: $projectId)
}
    `;
export type DeleteFolderMutationFn = Apollo.MutationFunction<DeleteFolderMutation, DeleteFolderMutationVariables>;

/**
 * __useDeleteFolderMutation__
 *
 * To run a mutation, you first call `useDeleteFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFolderMutation, { data, loading, error }] = useDeleteFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteFolderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFolderMutation, DeleteFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFolderMutation, DeleteFolderMutationVariables>(DeleteFolderDocument, options);
      }
export type DeleteFolderMutationHookResult = ReturnType<typeof useDeleteFolderMutation>;
export type DeleteFolderMutationResult = Apollo.MutationResult<DeleteFolderMutation>;
export type DeleteFolderMutationOptions = Apollo.BaseMutationOptions<DeleteFolderMutation, DeleteFolderMutationVariables>;
export const AddFileToFolderDocument = gql`
    mutation addFileToFolder($fileId: ID!, $folderId: ID!, $projectId: ID!) {
  addFileToFolder(fileId: $fileId, folderId: $folderId, projectId: $projectId)
}
    `;
export type AddFileToFolderMutationFn = Apollo.MutationFunction<AddFileToFolderMutation, AddFileToFolderMutationVariables>;

/**
 * __useAddFileToFolderMutation__
 *
 * To run a mutation, you first call `useAddFileToFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFileToFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFileToFolderMutation, { data, loading, error }] = useAddFileToFolderMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      folderId: // value for 'folderId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useAddFileToFolderMutation(baseOptions?: Apollo.MutationHookOptions<AddFileToFolderMutation, AddFileToFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFileToFolderMutation, AddFileToFolderMutationVariables>(AddFileToFolderDocument, options);
      }
export type AddFileToFolderMutationHookResult = ReturnType<typeof useAddFileToFolderMutation>;
export type AddFileToFolderMutationResult = Apollo.MutationResult<AddFileToFolderMutation>;
export type AddFileToFolderMutationOptions = Apollo.BaseMutationOptions<AddFileToFolderMutation, AddFileToFolderMutationVariables>;
export const RemoveFileFromFolderDocument = gql`
    mutation removeFileFromFolder($fileId: ID!, $folderId: ID!, $projectId: ID!) {
  removeFileFromFolder(
    fileId: $fileId
    folderId: $folderId
    projectId: $projectId
  )
}
    `;
export type RemoveFileFromFolderMutationFn = Apollo.MutationFunction<RemoveFileFromFolderMutation, RemoveFileFromFolderMutationVariables>;

/**
 * __useRemoveFileFromFolderMutation__
 *
 * To run a mutation, you first call `useRemoveFileFromFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFileFromFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFileFromFolderMutation, { data, loading, error }] = useRemoveFileFromFolderMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      folderId: // value for 'folderId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRemoveFileFromFolderMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFileFromFolderMutation, RemoveFileFromFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFileFromFolderMutation, RemoveFileFromFolderMutationVariables>(RemoveFileFromFolderDocument, options);
      }
export type RemoveFileFromFolderMutationHookResult = ReturnType<typeof useRemoveFileFromFolderMutation>;
export type RemoveFileFromFolderMutationResult = Apollo.MutationResult<RemoveFileFromFolderMutation>;
export type RemoveFileFromFolderMutationOptions = Apollo.BaseMutationOptions<RemoveFileFromFolderMutation, RemoveFileFromFolderMutationVariables>;
export const GenerateTranscriptionDocument = gql`
    mutation generateTranscription($fileId: ID!) {
  generateTranscription(fileId: $fileId)
}
    `;
export type GenerateTranscriptionMutationFn = Apollo.MutationFunction<GenerateTranscriptionMutation, GenerateTranscriptionMutationVariables>;

/**
 * __useGenerateTranscriptionMutation__
 *
 * To run a mutation, you first call `useGenerateTranscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTranscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTranscriptionMutation, { data, loading, error }] = useGenerateTranscriptionMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGenerateTranscriptionMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTranscriptionMutation, GenerateTranscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTranscriptionMutation, GenerateTranscriptionMutationVariables>(GenerateTranscriptionDocument, options);
      }
export type GenerateTranscriptionMutationHookResult = ReturnType<typeof useGenerateTranscriptionMutation>;
export type GenerateTranscriptionMutationResult = Apollo.MutationResult<GenerateTranscriptionMutation>;
export type GenerateTranscriptionMutationOptions = Apollo.BaseMutationOptions<GenerateTranscriptionMutation, GenerateTranscriptionMutationVariables>;
export const CreateExportClipToLibraryJobDocument = gql`
    mutation createExportClipToLibraryJob($episodeId: ID!, $uniqueId: ID!, $exportedFilename: String!, $clipTimings: ClipTimingsInput, $addToEpisode: Boolean = false) {
  createExportClipToLibraryJob(
    episodeId: $episodeId
    uniqueId: $uniqueId
    exportedFilename: $exportedFilename
    clipTimings: $clipTimings
    addToEpisode: $addToEpisode
  ) {
    id
  }
}
    `;
export type CreateExportClipToLibraryJobMutationFn = Apollo.MutationFunction<CreateExportClipToLibraryJobMutation, CreateExportClipToLibraryJobMutationVariables>;

/**
 * __useCreateExportClipToLibraryJobMutation__
 *
 * To run a mutation, you first call `useCreateExportClipToLibraryJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExportClipToLibraryJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExportClipToLibraryJobMutation, { data, loading, error }] = useCreateExportClipToLibraryJobMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      uniqueId: // value for 'uniqueId'
 *      exportedFilename: // value for 'exportedFilename'
 *      clipTimings: // value for 'clipTimings'
 *      addToEpisode: // value for 'addToEpisode'
 *   },
 * });
 */
export function useCreateExportClipToLibraryJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateExportClipToLibraryJobMutation, CreateExportClipToLibraryJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExportClipToLibraryJobMutation, CreateExportClipToLibraryJobMutationVariables>(CreateExportClipToLibraryJobDocument, options);
      }
export type CreateExportClipToLibraryJobMutationHookResult = ReturnType<typeof useCreateExportClipToLibraryJobMutation>;
export type CreateExportClipToLibraryJobMutationResult = Apollo.MutationResult<CreateExportClipToLibraryJobMutation>;
export type CreateExportClipToLibraryJobMutationOptions = Apollo.BaseMutationOptions<CreateExportClipToLibraryJobMutation, CreateExportClipToLibraryJobMutationVariables>;
export const SplitEpisodeClipDocument = gql`
    mutation splitEpisodeClip($id: ID!, $uniqueId: ID!, $splitTime: Float!, $firstFileName: String!, $secondFileName: String!, $version: Int!) {
  splitEpisodeClip(
    id: $id
    uniqueId: $uniqueId
    splitTime: $splitTime
    firstFileName: $firstFileName
    secondFileName: $secondFileName
    version: $version
  ) {
    id
    version
    timeline {
      ...EpisodeFile
    }
  }
}
    ${EpisodeFileFragmentDoc}`;
export type SplitEpisodeClipMutationFn = Apollo.MutationFunction<SplitEpisodeClipMutation, SplitEpisodeClipMutationVariables>;

/**
 * __useSplitEpisodeClipMutation__
 *
 * To run a mutation, you first call `useSplitEpisodeClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSplitEpisodeClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [splitEpisodeClipMutation, { data, loading, error }] = useSplitEpisodeClipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      uniqueId: // value for 'uniqueId'
 *      splitTime: // value for 'splitTime'
 *      firstFileName: // value for 'firstFileName'
 *      secondFileName: // value for 'secondFileName'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useSplitEpisodeClipMutation(baseOptions?: Apollo.MutationHookOptions<SplitEpisodeClipMutation, SplitEpisodeClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SplitEpisodeClipMutation, SplitEpisodeClipMutationVariables>(SplitEpisodeClipDocument, options);
      }
export type SplitEpisodeClipMutationHookResult = ReturnType<typeof useSplitEpisodeClipMutation>;
export type SplitEpisodeClipMutationResult = Apollo.MutationResult<SplitEpisodeClipMutation>;
export type SplitEpisodeClipMutationOptions = Apollo.BaseMutationOptions<SplitEpisodeClipMutation, SplitEpisodeClipMutationVariables>;
export const GetRecordingRulesDocument = gql`
    query getRecordingRules($callPermalink: ID!) {
  getRecordingRules(callPermalink: $callPermalink)
}
    `;

/**
 * __useGetRecordingRulesQuery__
 *
 * To run a query within a React component, call `useGetRecordingRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecordingRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecordingRulesQuery({
 *   variables: {
 *      callPermalink: // value for 'callPermalink'
 *   },
 * });
 */
export function useGetRecordingRulesQuery(baseOptions: Apollo.QueryHookOptions<GetRecordingRulesQuery, GetRecordingRulesQueryVariables> & ({ variables: GetRecordingRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecordingRulesQuery, GetRecordingRulesQueryVariables>(GetRecordingRulesDocument, options);
      }
export function useGetRecordingRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecordingRulesQuery, GetRecordingRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecordingRulesQuery, GetRecordingRulesQueryVariables>(GetRecordingRulesDocument, options);
        }
export function useGetRecordingRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecordingRulesQuery, GetRecordingRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecordingRulesQuery, GetRecordingRulesQueryVariables>(GetRecordingRulesDocument, options);
        }
export type GetRecordingRulesQueryHookResult = ReturnType<typeof useGetRecordingRulesQuery>;
export type GetRecordingRulesLazyQueryHookResult = ReturnType<typeof useGetRecordingRulesLazyQuery>;
export type GetRecordingRulesSuspenseQueryHookResult = ReturnType<typeof useGetRecordingRulesSuspenseQuery>;
export type GetRecordingRulesQueryResult = Apollo.QueryResult<GetRecordingRulesQuery, GetRecordingRulesQueryVariables>;
export const UpdateRecordingRulesDocument = gql`
    mutation updateRecordingRules($callPermalink: ID!, $type: String!) {
  updateRecordingRules(callPermalink: $callPermalink, type: $type)
}
    `;
export type UpdateRecordingRulesMutationFn = Apollo.MutationFunction<UpdateRecordingRulesMutation, UpdateRecordingRulesMutationVariables>;

/**
 * __useUpdateRecordingRulesMutation__
 *
 * To run a mutation, you first call `useUpdateRecordingRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecordingRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecordingRulesMutation, { data, loading, error }] = useUpdateRecordingRulesMutation({
 *   variables: {
 *      callPermalink: // value for 'callPermalink'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateRecordingRulesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecordingRulesMutation, UpdateRecordingRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecordingRulesMutation, UpdateRecordingRulesMutationVariables>(UpdateRecordingRulesDocument, options);
      }
export type UpdateRecordingRulesMutationHookResult = ReturnType<typeof useUpdateRecordingRulesMutation>;
export type UpdateRecordingRulesMutationResult = Apollo.MutationResult<UpdateRecordingRulesMutation>;
export type UpdateRecordingRulesMutationOptions = Apollo.BaseMutationOptions<UpdateRecordingRulesMutation, UpdateRecordingRulesMutationVariables>;
export const CreateCallDocument = gql`
    mutation createCall($twilioId: String!, $isSolo: Boolean, $fileName: String, $recordOnConnect: Boolean!, $recordingType: RecordingType!) {
  createCall(
    twilioId: $twilioId
    isSolo: $isSolo
    fileName: $fileName
    recordOnConnect: $recordOnConnect
    recordingType: $recordingType
  ) {
    id
    token
    room
  }
}
    `;
export type CreateCallMutationFn = Apollo.MutationFunction<CreateCallMutation, CreateCallMutationVariables>;

/**
 * __useCreateCallMutation__
 *
 * To run a mutation, you first call `useCreateCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCallMutation, { data, loading, error }] = useCreateCallMutation({
 *   variables: {
 *      twilioId: // value for 'twilioId'
 *      isSolo: // value for 'isSolo'
 *      fileName: // value for 'fileName'
 *      recordOnConnect: // value for 'recordOnConnect'
 *      recordingType: // value for 'recordingType'
 *   },
 * });
 */
export function useCreateCallMutation(baseOptions?: Apollo.MutationHookOptions<CreateCallMutation, CreateCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCallMutation, CreateCallMutationVariables>(CreateCallDocument, options);
      }
export type CreateCallMutationHookResult = ReturnType<typeof useCreateCallMutation>;
export type CreateCallMutationResult = Apollo.MutationResult<CreateCallMutation>;
export type CreateCallMutationOptions = Apollo.BaseMutationOptions<CreateCallMutation, CreateCallMutationVariables>;
export const JoinCallDocument = gql`
    mutation joinCall($callPermalink: ID!, $twilioId: String!) {
  joinCall(callPermalink: $callPermalink, twilioId: $twilioId) {
    id
    token
    room
  }
}
    `;
export type JoinCallMutationFn = Apollo.MutationFunction<JoinCallMutation, JoinCallMutationVariables>;

/**
 * __useJoinCallMutation__
 *
 * To run a mutation, you first call `useJoinCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinCallMutation, { data, loading, error }] = useJoinCallMutation({
 *   variables: {
 *      callPermalink: // value for 'callPermalink'
 *      twilioId: // value for 'twilioId'
 *   },
 * });
 */
export function useJoinCallMutation(baseOptions?: Apollo.MutationHookOptions<JoinCallMutation, JoinCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinCallMutation, JoinCallMutationVariables>(JoinCallDocument, options);
      }
export type JoinCallMutationHookResult = ReturnType<typeof useJoinCallMutation>;
export type JoinCallMutationResult = Apollo.MutationResult<JoinCallMutation>;
export type JoinCallMutationOptions = Apollo.BaseMutationOptions<JoinCallMutation, JoinCallMutationVariables>;
export const CallExistsDocument = gql`
    query callExists($callPermalink: ID!) {
  callExists(callPermalink: $callPermalink) {
    callExists
    isVideoFeatureEnabled
    isVideoRecordingFeatureEnabled
    recordingType
  }
}
    `;

/**
 * __useCallExistsQuery__
 *
 * To run a query within a React component, call `useCallExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallExistsQuery({
 *   variables: {
 *      callPermalink: // value for 'callPermalink'
 *   },
 * });
 */
export function useCallExistsQuery(baseOptions: Apollo.QueryHookOptions<CallExistsQuery, CallExistsQueryVariables> & ({ variables: CallExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallExistsQuery, CallExistsQueryVariables>(CallExistsDocument, options);
      }
export function useCallExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallExistsQuery, CallExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallExistsQuery, CallExistsQueryVariables>(CallExistsDocument, options);
        }
export function useCallExistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CallExistsQuery, CallExistsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CallExistsQuery, CallExistsQueryVariables>(CallExistsDocument, options);
        }
export type CallExistsQueryHookResult = ReturnType<typeof useCallExistsQuery>;
export type CallExistsLazyQueryHookResult = ReturnType<typeof useCallExistsLazyQuery>;
export type CallExistsSuspenseQueryHookResult = ReturnType<typeof useCallExistsSuspenseQuery>;
export type CallExistsQueryResult = Apollo.QueryResult<CallExistsQuery, CallExistsQueryVariables>;
export const UpdateCallLockDocument = gql`
    mutation updateCallLock($id: ID!, $locked: Boolean!) {
  updateCallLock(id: $id, locked: $locked)
}
    `;
export type UpdateCallLockMutationFn = Apollo.MutationFunction<UpdateCallLockMutation, UpdateCallLockMutationVariables>;

/**
 * __useUpdateCallLockMutation__
 *
 * To run a mutation, you first call `useUpdateCallLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCallLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCallLockMutation, { data, loading, error }] = useUpdateCallLockMutation({
 *   variables: {
 *      id: // value for 'id'
 *      locked: // value for 'locked'
 *   },
 * });
 */
export function useUpdateCallLockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCallLockMutation, UpdateCallLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCallLockMutation, UpdateCallLockMutationVariables>(UpdateCallLockDocument, options);
      }
export type UpdateCallLockMutationHookResult = ReturnType<typeof useUpdateCallLockMutation>;
export type UpdateCallLockMutationResult = Apollo.MutationResult<UpdateCallLockMutation>;
export type UpdateCallLockMutationOptions = Apollo.BaseMutationOptions<UpdateCallLockMutation, UpdateCallLockMutationVariables>;
export const GetCallCreatorDocument = gql`
    query getCallCreator($callPermalink: ID!) {
  getCallCreator(callPermalink: $callPermalink) {
    creatorTwilioId
  }
}
    `;

/**
 * __useGetCallCreatorQuery__
 *
 * To run a query within a React component, call `useGetCallCreatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallCreatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallCreatorQuery({
 *   variables: {
 *      callPermalink: // value for 'callPermalink'
 *   },
 * });
 */
export function useGetCallCreatorQuery(baseOptions: Apollo.QueryHookOptions<GetCallCreatorQuery, GetCallCreatorQueryVariables> & ({ variables: GetCallCreatorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCallCreatorQuery, GetCallCreatorQueryVariables>(GetCallCreatorDocument, options);
      }
export function useGetCallCreatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCallCreatorQuery, GetCallCreatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCallCreatorQuery, GetCallCreatorQueryVariables>(GetCallCreatorDocument, options);
        }
export function useGetCallCreatorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallCreatorQuery, GetCallCreatorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCallCreatorQuery, GetCallCreatorQueryVariables>(GetCallCreatorDocument, options);
        }
export type GetCallCreatorQueryHookResult = ReturnType<typeof useGetCallCreatorQuery>;
export type GetCallCreatorLazyQueryHookResult = ReturnType<typeof useGetCallCreatorLazyQuery>;
export type GetCallCreatorSuspenseQueryHookResult = ReturnType<typeof useGetCallCreatorSuspenseQuery>;
export type GetCallCreatorQueryResult = Apollo.QueryResult<GetCallCreatorQuery, GetCallCreatorQueryVariables>;
export const AddCallDurationDocument = gql`
    mutation addCallDuration($id: ID!, $duration: Float!) {
  addCallDuration(id: $id, duration: $duration)
}
    `;
export type AddCallDurationMutationFn = Apollo.MutationFunction<AddCallDurationMutation, AddCallDurationMutationVariables>;

/**
 * __useAddCallDurationMutation__
 *
 * To run a mutation, you first call `useAddCallDurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCallDurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCallDurationMutation, { data, loading, error }] = useAddCallDurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useAddCallDurationMutation(baseOptions?: Apollo.MutationHookOptions<AddCallDurationMutation, AddCallDurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCallDurationMutation, AddCallDurationMutationVariables>(AddCallDurationDocument, options);
      }
export type AddCallDurationMutationHookResult = ReturnType<typeof useAddCallDurationMutation>;
export type AddCallDurationMutationResult = Apollo.MutationResult<AddCallDurationMutation>;
export type AddCallDurationMutationOptions = Apollo.BaseMutationOptions<AddCallDurationMutation, AddCallDurationMutationVariables>;
export const CreateMusicEditorJobDocument = gql`
    mutation createMusicEditorJob($fileName: String, $voice: JSON!, $music: JSON!, $introDuration: Float, $outroDuration: Float, $musicVolume: Float) {
  createMusicEditorJob(
    fileName: $fileName
    voice: $voice
    music: $music
    introDuration: $introDuration
    outroDuration: $outroDuration
    musicVolume: $musicVolume
  )
}
    `;
export type CreateMusicEditorJobMutationFn = Apollo.MutationFunction<CreateMusicEditorJobMutation, CreateMusicEditorJobMutationVariables>;

/**
 * __useCreateMusicEditorJobMutation__
 *
 * To run a mutation, you first call `useCreateMusicEditorJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMusicEditorJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMusicEditorJobMutation, { data, loading, error }] = useCreateMusicEditorJobMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      voice: // value for 'voice'
 *      music: // value for 'music'
 *      introDuration: // value for 'introDuration'
 *      outroDuration: // value for 'outroDuration'
 *      musicVolume: // value for 'musicVolume'
 *   },
 * });
 */
export function useCreateMusicEditorJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateMusicEditorJobMutation, CreateMusicEditorJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMusicEditorJobMutation, CreateMusicEditorJobMutationVariables>(CreateMusicEditorJobDocument, options);
      }
export type CreateMusicEditorJobMutationHookResult = ReturnType<typeof useCreateMusicEditorJobMutation>;
export type CreateMusicEditorJobMutationResult = Apollo.MutationResult<CreateMusicEditorJobMutation>;
export type CreateMusicEditorJobMutationOptions = Apollo.BaseMutationOptions<CreateMusicEditorJobMutation, CreateMusicEditorJobMutationVariables>;
export const CreateMusicEditorEditJobDocument = gql`
    mutation createMusicEditorEditJob($fileId: ID!, $timeline: JSON!) {
  createMusicEditorEditJob(fileId: $fileId, timeline: $timeline)
}
    `;
export type CreateMusicEditorEditJobMutationFn = Apollo.MutationFunction<CreateMusicEditorEditJobMutation, CreateMusicEditorEditJobMutationVariables>;

/**
 * __useCreateMusicEditorEditJobMutation__
 *
 * To run a mutation, you first call `useCreateMusicEditorEditJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMusicEditorEditJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMusicEditorEditJobMutation, { data, loading, error }] = useCreateMusicEditorEditJobMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      timeline: // value for 'timeline'
 *   },
 * });
 */
export function useCreateMusicEditorEditJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateMusicEditorEditJobMutation, CreateMusicEditorEditJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMusicEditorEditJobMutation, CreateMusicEditorEditJobMutationVariables>(CreateMusicEditorEditJobDocument, options);
      }
export type CreateMusicEditorEditJobMutationHookResult = ReturnType<typeof useCreateMusicEditorEditJobMutation>;
export type CreateMusicEditorEditJobMutationResult = Apollo.MutationResult<CreateMusicEditorEditJobMutation>;
export type CreateMusicEditorEditJobMutationOptions = Apollo.BaseMutationOptions<CreateMusicEditorEditJobMutation, CreateMusicEditorEditJobMutationVariables>;
export const EpisodeDocument = gql`
    query episode($id: ID!, $version: Int) {
  episode(id: $id, version: $version) {
    ...EpisodeAllFields
  }
}
    ${EpisodeAllFieldsFragmentDoc}`;

/**
 * __useEpisodeQuery__
 *
 * To run a query within a React component, call `useEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpisodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useEpisodeQuery(baseOptions: Apollo.QueryHookOptions<EpisodeQuery, EpisodeQueryVariables> & ({ variables: EpisodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpisodeQuery, EpisodeQueryVariables>(EpisodeDocument, options);
      }
export function useEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpisodeQuery, EpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpisodeQuery, EpisodeQueryVariables>(EpisodeDocument, options);
        }
export function useEpisodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodeQuery, EpisodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EpisodeQuery, EpisodeQueryVariables>(EpisodeDocument, options);
        }
export type EpisodeQueryHookResult = ReturnType<typeof useEpisodeQuery>;
export type EpisodeLazyQueryHookResult = ReturnType<typeof useEpisodeLazyQuery>;
export type EpisodeSuspenseQueryHookResult = ReturnType<typeof useEpisodeSuspenseQuery>;
export type EpisodeQueryResult = Apollo.QueryResult<EpisodeQuery, EpisodeQueryVariables>;
export const UpdateEpisodeDocument = gql`
    mutation updateEpisode($id: ID!, $metaData: EpisodeMetaDataInput, $timeline: [EpisodeFileInput!], $shouldSuggestTitle: Boolean, $shouldSuggestDescription: Boolean, $clearFileField: Boolean, $shouldIncludeTranscriptInRss: Boolean, $version: Int, $artwork: ArtworkInput) {
  episode: updateEpisode(
    id: $id
    metaData: $metaData
    timeline: $timeline
    shouldSuggestTitle: $shouldSuggestTitle
    shouldSuggestDescription: $shouldSuggestDescription
    clearFileField: $clearFileField
    shouldIncludeTranscriptInRss: $shouldIncludeTranscriptInRss
    version: $version
    artwork: $artwork
  ) {
    ...EpisodeAllFields
  }
}
    ${EpisodeAllFieldsFragmentDoc}`;
export type UpdateEpisodeMutationFn = Apollo.MutationFunction<UpdateEpisodeMutation, UpdateEpisodeMutationVariables>;

/**
 * __useUpdateEpisodeMutation__
 *
 * To run a mutation, you first call `useUpdateEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEpisodeMutation, { data, loading, error }] = useUpdateEpisodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      metaData: // value for 'metaData'
 *      timeline: // value for 'timeline'
 *      shouldSuggestTitle: // value for 'shouldSuggestTitle'
 *      shouldSuggestDescription: // value for 'shouldSuggestDescription'
 *      clearFileField: // value for 'clearFileField'
 *      shouldIncludeTranscriptInRss: // value for 'shouldIncludeTranscriptInRss'
 *      version: // value for 'version'
 *      artwork: // value for 'artwork'
 *   },
 * });
 */
export function useUpdateEpisodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEpisodeMutation, UpdateEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEpisodeMutation, UpdateEpisodeMutationVariables>(UpdateEpisodeDocument, options);
      }
export type UpdateEpisodeMutationHookResult = ReturnType<typeof useUpdateEpisodeMutation>;
export type UpdateEpisodeMutationResult = Apollo.MutationResult<UpdateEpisodeMutation>;
export type UpdateEpisodeMutationOptions = Apollo.BaseMutationOptions<UpdateEpisodeMutation, UpdateEpisodeMutationVariables>;
export const AddAuphonicMetadataDocument = gql`
    mutation addAuphonicMetadata($fileId: ID!) {
  addAuphonicMetadata(fileId: $fileId)
}
    `;
export type AddAuphonicMetadataMutationFn = Apollo.MutationFunction<AddAuphonicMetadataMutation, AddAuphonicMetadataMutationVariables>;

/**
 * __useAddAuphonicMetadataMutation__
 *
 * To run a mutation, you first call `useAddAuphonicMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAuphonicMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAuphonicMetadataMutation, { data, loading, error }] = useAddAuphonicMetadataMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useAddAuphonicMetadataMutation(baseOptions?: Apollo.MutationHookOptions<AddAuphonicMetadataMutation, AddAuphonicMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAuphonicMetadataMutation, AddAuphonicMetadataMutationVariables>(AddAuphonicMetadataDocument, options);
      }
export type AddAuphonicMetadataMutationHookResult = ReturnType<typeof useAddAuphonicMetadataMutation>;
export type AddAuphonicMetadataMutationResult = Apollo.MutationResult<AddAuphonicMetadataMutation>;
export type AddAuphonicMetadataMutationOptions = Apollo.BaseMutationOptions<AddAuphonicMetadataMutation, AddAuphonicMetadataMutationVariables>;
export const CreateExportJobDocument = gql`
    mutation createExportJob($episodeId: ID!) {
  createExportJob(episodeId: $episodeId) {
    id
  }
}
    `;
export type CreateExportJobMutationFn = Apollo.MutationFunction<CreateExportJobMutation, CreateExportJobMutationVariables>;

/**
 * __useCreateExportJobMutation__
 *
 * To run a mutation, you first call `useCreateExportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExportJobMutation, { data, loading, error }] = useCreateExportJobMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useCreateExportJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateExportJobMutation, CreateExportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExportJobMutation, CreateExportJobMutationVariables>(CreateExportJobDocument, options);
      }
export type CreateExportJobMutationHookResult = ReturnType<typeof useCreateExportJobMutation>;
export type CreateExportJobMutationResult = Apollo.MutationResult<CreateExportJobMutation>;
export type CreateExportJobMutationOptions = Apollo.BaseMutationOptions<CreateExportJobMutation, CreateExportJobMutationVariables>;
export const EpisodesDocument = gql`
    query episodes($name: String, $offset: Int!, $limit: Int, $order: String, $jobStatus: String, $isDraft: Boolean, $projectId: String) {
  episodes(
    name: $name
    offset: $offset
    limit: $limit
    order: $order
    jobStatus: $jobStatus
    isDraft: $isDraft
    projectId: $projectId
  ) {
    id
    metaData {
      name
      summary
      description
      episodeNumber
      seasonNumber
    }
    timeline {
      id
      uniqueId
    }
    version
    isArchivedVersion
    file {
      id
      audioJob {
        id
        createdAt
        status
        schema
      }
      videoJob {
        id
        createdAt
        status
        schema
      }
      transcriptionJob {
        id
        createdAt
        status
        schema
      }
      aiJob {
        id
        createdAt
        status
        schema
      }
      metaDataJob {
        id
        createdAt
        status
        schema
      }
    }
    artworkUrl
    createdAt
    updatedAt
    publishedAt
    schedulePublishAt
    host
  }
  filteredTotal: episodesCount(
    name: $name
    jobStatus: $jobStatus
    isDraft: $isDraft
    projectId: $projectId
  )
  all: episodesCount
  draft: episodesCount(isDraft: true)
  processing: episodesCount(jobStatus: "processing")
  complete: episodesCount(jobStatus: "complete")
  host
}
    `;

/**
 * __useEpisodesQuery__
 *
 * To run a query within a React component, call `useEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpisodesQuery({
 *   variables: {
 *      name: // value for 'name'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      jobStatus: // value for 'jobStatus'
 *      isDraft: // value for 'isDraft'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useEpisodesQuery(baseOptions: Apollo.QueryHookOptions<EpisodesQuery, EpisodesQueryVariables> & ({ variables: EpisodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpisodesQuery, EpisodesQueryVariables>(EpisodesDocument, options);
      }
export function useEpisodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpisodesQuery, EpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpisodesQuery, EpisodesQueryVariables>(EpisodesDocument, options);
        }
export function useEpisodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodesQuery, EpisodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EpisodesQuery, EpisodesQueryVariables>(EpisodesDocument, options);
        }
export type EpisodesQueryHookResult = ReturnType<typeof useEpisodesQuery>;
export type EpisodesLazyQueryHookResult = ReturnType<typeof useEpisodesLazyQuery>;
export type EpisodesSuspenseQueryHookResult = ReturnType<typeof useEpisodesSuspenseQuery>;
export type EpisodesQueryResult = Apollo.QueryResult<EpisodesQuery, EpisodesQueryVariables>;
export const DuplicateEpisodeDocument = gql`
    mutation duplicateEpisode($id: ID!, $name: String) {
  duplicateEpisode(id: $id, name: $name) {
    id
  }
}
    `;
export type DuplicateEpisodeMutationFn = Apollo.MutationFunction<DuplicateEpisodeMutation, DuplicateEpisodeMutationVariables>;

/**
 * __useDuplicateEpisodeMutation__
 *
 * To run a mutation, you first call `useDuplicateEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateEpisodeMutation, { data, loading, error }] = useDuplicateEpisodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDuplicateEpisodeMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateEpisodeMutation, DuplicateEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateEpisodeMutation, DuplicateEpisodeMutationVariables>(DuplicateEpisodeDocument, options);
      }
export type DuplicateEpisodeMutationHookResult = ReturnType<typeof useDuplicateEpisodeMutation>;
export type DuplicateEpisodeMutationResult = Apollo.MutationResult<DuplicateEpisodeMutation>;
export type DuplicateEpisodeMutationOptions = Apollo.BaseMutationOptions<DuplicateEpisodeMutation, DuplicateEpisodeMutationVariables>;
export const DeleteEpisodeDocument = gql`
    mutation deleteEpisode($id: ID!) {
  deleteEpisode(id: $id) {
    deletedEpisodeId
  }
}
    `;
export type DeleteEpisodeMutationFn = Apollo.MutationFunction<DeleteEpisodeMutation, DeleteEpisodeMutationVariables>;

/**
 * __useDeleteEpisodeMutation__
 *
 * To run a mutation, you first call `useDeleteEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEpisodeMutation, { data, loading, error }] = useDeleteEpisodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEpisodeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEpisodeMutation, DeleteEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEpisodeMutation, DeleteEpisodeMutationVariables>(DeleteEpisodeDocument, options);
      }
export type DeleteEpisodeMutationHookResult = ReturnType<typeof useDeleteEpisodeMutation>;
export type DeleteEpisodeMutationResult = Apollo.MutationResult<DeleteEpisodeMutation>;
export type DeleteEpisodeMutationOptions = Apollo.BaseMutationOptions<DeleteEpisodeMutation, DeleteEpisodeMutationVariables>;
export const EpisodesCountPerUserDocument = gql`
    query episodesCountPerUser {
  episodesCountPerUser
}
    `;

/**
 * __useEpisodesCountPerUserQuery__
 *
 * To run a query within a React component, call `useEpisodesCountPerUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpisodesCountPerUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpisodesCountPerUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useEpisodesCountPerUserQuery(baseOptions?: Apollo.QueryHookOptions<EpisodesCountPerUserQuery, EpisodesCountPerUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpisodesCountPerUserQuery, EpisodesCountPerUserQueryVariables>(EpisodesCountPerUserDocument, options);
      }
export function useEpisodesCountPerUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpisodesCountPerUserQuery, EpisodesCountPerUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpisodesCountPerUserQuery, EpisodesCountPerUserQueryVariables>(EpisodesCountPerUserDocument, options);
        }
export function useEpisodesCountPerUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodesCountPerUserQuery, EpisodesCountPerUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EpisodesCountPerUserQuery, EpisodesCountPerUserQueryVariables>(EpisodesCountPerUserDocument, options);
        }
export type EpisodesCountPerUserQueryHookResult = ReturnType<typeof useEpisodesCountPerUserQuery>;
export type EpisodesCountPerUserLazyQueryHookResult = ReturnType<typeof useEpisodesCountPerUserLazyQuery>;
export type EpisodesCountPerUserSuspenseQueryHookResult = ReturnType<typeof useEpisodesCountPerUserSuspenseQuery>;
export type EpisodesCountPerUserQueryResult = Apollo.QueryResult<EpisodesCountPerUserQuery, EpisodesCountPerUserQueryVariables>;
export const FetchProcessingFileDocument = gql`
    query fetchProcessingFile($id: ID!, $projectId: ID!) {
  file(id: $id, projectId: $projectId) {
    codecInformation {
      format {
        duration
      }
    }
    audioJob {
      status
    }
  }
}
    `;

/**
 * __useFetchProcessingFileQuery__
 *
 * To run a query within a React component, call `useFetchProcessingFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProcessingFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProcessingFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useFetchProcessingFileQuery(baseOptions: Apollo.QueryHookOptions<FetchProcessingFileQuery, FetchProcessingFileQueryVariables> & ({ variables: FetchProcessingFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProcessingFileQuery, FetchProcessingFileQueryVariables>(FetchProcessingFileDocument, options);
      }
export function useFetchProcessingFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProcessingFileQuery, FetchProcessingFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProcessingFileQuery, FetchProcessingFileQueryVariables>(FetchProcessingFileDocument, options);
        }
export function useFetchProcessingFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchProcessingFileQuery, FetchProcessingFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchProcessingFileQuery, FetchProcessingFileQueryVariables>(FetchProcessingFileDocument, options);
        }
export type FetchProcessingFileQueryHookResult = ReturnType<typeof useFetchProcessingFileQuery>;
export type FetchProcessingFileLazyQueryHookResult = ReturnType<typeof useFetchProcessingFileLazyQuery>;
export type FetchProcessingFileSuspenseQueryHookResult = ReturnType<typeof useFetchProcessingFileSuspenseQuery>;
export type FetchProcessingFileQueryResult = Apollo.QueryResult<FetchProcessingFileQuery, FetchProcessingFileQueryVariables>;
export const FetchFileDocument = gql`
    query fetchFile($id: ID!, $projectId: ID!) {
  file(id: $id, projectId: $projectId) {
    id
    name
    type
    tags
    bucket
    codecInformation {
      format {
        duration
      }
    }
    users {
      userFile
    }
    audioJob {
      id
      status
    }
  }
}
    `;

/**
 * __useFetchFileQuery__
 *
 * To run a query within a React component, call `useFetchFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useFetchFileQuery(baseOptions: Apollo.QueryHookOptions<FetchFileQuery, FetchFileQueryVariables> & ({ variables: FetchFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFileQuery, FetchFileQueryVariables>(FetchFileDocument, options);
      }
export function useFetchFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFileQuery, FetchFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFileQuery, FetchFileQueryVariables>(FetchFileDocument, options);
        }
export function useFetchFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchFileQuery, FetchFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchFileQuery, FetchFileQueryVariables>(FetchFileDocument, options);
        }
export type FetchFileQueryHookResult = ReturnType<typeof useFetchFileQuery>;
export type FetchFileLazyQueryHookResult = ReturnType<typeof useFetchFileLazyQuery>;
export type FetchFileSuspenseQueryHookResult = ReturnType<typeof useFetchFileSuspenseQuery>;
export type FetchFileQueryResult = Apollo.QueryResult<FetchFileQuery, FetchFileQueryVariables>;
export const UpdateFileDocument = gql`
    mutation updateFile($id: ID!, $projectId: ID!, $newData: UpdateFile, $removeData: JSON) {
  updateFile(
    id: $id
    projectId: $projectId
    newData: $newData
    removeData: $removeData
  )
}
    `;
export type UpdateFileMutationFn = Apollo.MutationFunction<UpdateFileMutation, UpdateFileMutationVariables>;

/**
 * __useUpdateFileMutation__
 *
 * To run a mutation, you first call `useUpdateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileMutation, { data, loading, error }] = useUpdateFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *      newData: // value for 'newData'
 *      removeData: // value for 'removeData'
 *   },
 * });
 */
export function useUpdateFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileMutation, UpdateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileMutation, UpdateFileMutationVariables>(UpdateFileDocument, options);
      }
export type UpdateFileMutationHookResult = ReturnType<typeof useUpdateFileMutation>;
export type UpdateFileMutationResult = Apollo.MutationResult<UpdateFileMutation>;
export type UpdateFileMutationOptions = Apollo.BaseMutationOptions<UpdateFileMutation, UpdateFileMutationVariables>;
export const UpdateUserFileDocument = gql`
    mutation updateUserFile($fileId: ID!, $userId: ID!, $newData: UpdateUserFile) {
  updateUserFile(fileId: $fileId, userId: $userId, newData: $newData)
}
    `;
export type UpdateUserFileMutationFn = Apollo.MutationFunction<UpdateUserFileMutation, UpdateUserFileMutationVariables>;

/**
 * __useUpdateUserFileMutation__
 *
 * To run a mutation, you first call `useUpdateUserFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserFileMutation, { data, loading, error }] = useUpdateUserFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      userId: // value for 'userId'
 *      newData: // value for 'newData'
 *   },
 * });
 */
export function useUpdateUserFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserFileMutation, UpdateUserFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserFileMutation, UpdateUserFileMutationVariables>(UpdateUserFileDocument, options);
      }
export type UpdateUserFileMutationHookResult = ReturnType<typeof useUpdateUserFileMutation>;
export type UpdateUserFileMutationResult = Apollo.MutationResult<UpdateUserFileMutation>;
export type UpdateUserFileMutationOptions = Apollo.BaseMutationOptions<UpdateUserFileMutation, UpdateUserFileMutationVariables>;
export const RemoveFileDocument = gql`
    mutation removeFile($id: ID!, $projectId: ID!) {
  removeFile(id: $id, projectId: $projectId)
}
    `;
export type RemoveFileMutationFn = Apollo.MutationFunction<RemoveFileMutation, RemoveFileMutationVariables>;

/**
 * __useRemoveFileMutation__
 *
 * To run a mutation, you first call `useRemoveFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFileMutation, { data, loading, error }] = useRemoveFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRemoveFileMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFileMutation, RemoveFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFileMutation, RemoveFileMutationVariables>(RemoveFileDocument, options);
      }
export type RemoveFileMutationHookResult = ReturnType<typeof useRemoveFileMutation>;
export type RemoveFileMutationResult = Apollo.MutationResult<RemoveFileMutation>;
export type RemoveFileMutationOptions = Apollo.BaseMutationOptions<RemoveFileMutation, RemoveFileMutationVariables>;
export const BulkDeleteFilesDocument = gql`
    mutation bulkDeleteFiles($userId: ID!, $projectId: ID!, $fileIds: [String!]) {
  bulkDeleteFiles(userId: $userId, projectId: $projectId, fileIds: $fileIds)
}
    `;
export type BulkDeleteFilesMutationFn = Apollo.MutationFunction<BulkDeleteFilesMutation, BulkDeleteFilesMutationVariables>;

/**
 * __useBulkDeleteFilesMutation__
 *
 * To run a mutation, you first call `useBulkDeleteFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteFilesMutation, { data, loading, error }] = useBulkDeleteFilesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      projectId: // value for 'projectId'
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useBulkDeleteFilesMutation(baseOptions?: Apollo.MutationHookOptions<BulkDeleteFilesMutation, BulkDeleteFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkDeleteFilesMutation, BulkDeleteFilesMutationVariables>(BulkDeleteFilesDocument, options);
      }
export type BulkDeleteFilesMutationHookResult = ReturnType<typeof useBulkDeleteFilesMutation>;
export type BulkDeleteFilesMutationResult = Apollo.MutationResult<BulkDeleteFilesMutation>;
export type BulkDeleteFilesMutationOptions = Apollo.BaseMutationOptions<BulkDeleteFilesMutation, BulkDeleteFilesMutationVariables>;
export const ValidatePasswordDocument = gql`
    mutation validatePassword($password: String!) {
  validatePassword(password: $password) {
    success
    reason
  }
}
    `;
export type ValidatePasswordMutationFn = Apollo.MutationFunction<ValidatePasswordMutation, ValidatePasswordMutationVariables>;

/**
 * __useValidatePasswordMutation__
 *
 * To run a mutation, you first call `useValidatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validatePasswordMutation, { data, loading, error }] = useValidatePasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useValidatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ValidatePasswordMutation, ValidatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidatePasswordMutation, ValidatePasswordMutationVariables>(ValidatePasswordDocument, options);
      }
export type ValidatePasswordMutationHookResult = ReturnType<typeof useValidatePasswordMutation>;
export type ValidatePasswordMutationResult = Apollo.MutationResult<ValidatePasswordMutation>;
export type ValidatePasswordMutationOptions = Apollo.BaseMutationOptions<ValidatePasswordMutation, ValidatePasswordMutationVariables>;
export const RequestResetPasswordDocument = gql`
    mutation requestResetPassword($email: String!) {
  requestResetPassword(email: $email) {
    success
  }
}
    `;
export type RequestResetPasswordMutationFn = Apollo.MutationFunction<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>;

/**
 * __useRequestResetPasswordMutation__
 *
 * To run a mutation, you first call `useRequestResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestResetPasswordMutation, { data, loading, error }] = useRequestResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>(RequestResetPasswordDocument, options);
      }
export type RequestResetPasswordMutationHookResult = ReturnType<typeof useRequestResetPasswordMutation>;
export type RequestResetPasswordMutationResult = Apollo.MutationResult<RequestResetPasswordMutation>;
export type RequestResetPasswordMutationOptions = Apollo.BaseMutationOptions<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($password: String!, $token: String!) {
  resetPassword(password: $password, token: $token) {
    success
    reason
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SwitchPlanTypeDocument = gql`
    mutation switchPlanType {
  switchPlanType {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type SwitchPlanTypeMutationFn = Apollo.MutationFunction<SwitchPlanTypeMutation, SwitchPlanTypeMutationVariables>;

/**
 * __useSwitchPlanTypeMutation__
 *
 * To run a mutation, you first call `useSwitchPlanTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchPlanTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchPlanTypeMutation, { data, loading, error }] = useSwitchPlanTypeMutation({
 *   variables: {
 *   },
 * });
 */
export function useSwitchPlanTypeMutation(baseOptions?: Apollo.MutationHookOptions<SwitchPlanTypeMutation, SwitchPlanTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchPlanTypeMutation, SwitchPlanTypeMutationVariables>(SwitchPlanTypeDocument, options);
      }
export type SwitchPlanTypeMutationHookResult = ReturnType<typeof useSwitchPlanTypeMutation>;
export type SwitchPlanTypeMutationResult = Apollo.MutationResult<SwitchPlanTypeMutation>;
export type SwitchPlanTypeMutationOptions = Apollo.BaseMutationOptions<SwitchPlanTypeMutation, SwitchPlanTypeMutationVariables>;
export const RenewSubscriptionDocument = gql`
    mutation renewSubscription($paymentMethod: String!) {
  renewSubscription(paymentMethod: $paymentMethod) {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type RenewSubscriptionMutationFn = Apollo.MutationFunction<RenewSubscriptionMutation, RenewSubscriptionMutationVariables>;

/**
 * __useRenewSubscriptionMutation__
 *
 * To run a mutation, you first call `useRenewSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewSubscriptionMutation, { data, loading, error }] = useRenewSubscriptionMutation({
 *   variables: {
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useRenewSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<RenewSubscriptionMutation, RenewSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewSubscriptionMutation, RenewSubscriptionMutationVariables>(RenewSubscriptionDocument, options);
      }
export type RenewSubscriptionMutationHookResult = ReturnType<typeof useRenewSubscriptionMutation>;
export type RenewSubscriptionMutationResult = Apollo.MutationResult<RenewSubscriptionMutation>;
export type RenewSubscriptionMutationOptions = Apollo.BaseMutationOptions<RenewSubscriptionMutation, RenewSubscriptionMutationVariables>;
export const GetPaymentMethodsDocument = gql`
    query getPaymentMethods {
  getPaymentMethods
}
    `;

/**
 * __useGetPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
      }
export function useGetPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
        }
export function useGetPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
        }
export type GetPaymentMethodsQueryHookResult = ReturnType<typeof useGetPaymentMethodsQuery>;
export type GetPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsLazyQuery>;
export type GetPaymentMethodsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentMethodsSuspenseQuery>;
export type GetPaymentMethodsQueryResult = Apollo.QueryResult<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>;
export const AlituSchedulePublishDocument = gql`
    mutation alituSchedulePublish($episodeId: ID!, $schedulePublishAt: String) {
  alituSchedulePublish(
    episodeId: $episodeId
    schedulePublishAt: $schedulePublishAt
  ) {
    success
  }
}
    `;
export type AlituSchedulePublishMutationFn = Apollo.MutationFunction<AlituSchedulePublishMutation, AlituSchedulePublishMutationVariables>;

/**
 * __useAlituSchedulePublishMutation__
 *
 * To run a mutation, you first call `useAlituSchedulePublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlituSchedulePublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alituSchedulePublishMutation, { data, loading, error }] = useAlituSchedulePublishMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      schedulePublishAt: // value for 'schedulePublishAt'
 *   },
 * });
 */
export function useAlituSchedulePublishMutation(baseOptions?: Apollo.MutationHookOptions<AlituSchedulePublishMutation, AlituSchedulePublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlituSchedulePublishMutation, AlituSchedulePublishMutationVariables>(AlituSchedulePublishDocument, options);
      }
export type AlituSchedulePublishMutationHookResult = ReturnType<typeof useAlituSchedulePublishMutation>;
export type AlituSchedulePublishMutationResult = Apollo.MutationResult<AlituSchedulePublishMutation>;
export type AlituSchedulePublishMutationOptions = Apollo.BaseMutationOptions<AlituSchedulePublishMutation, AlituSchedulePublishMutationVariables>;
export const AlituCancelSchedulePublishDocument = gql`
    mutation alituCancelSchedulePublish($episodeId: ID!) {
  alituCancelSchedulePublish(episodeId: $episodeId) {
    success
  }
}
    `;
export type AlituCancelSchedulePublishMutationFn = Apollo.MutationFunction<AlituCancelSchedulePublishMutation, AlituCancelSchedulePublishMutationVariables>;

/**
 * __useAlituCancelSchedulePublishMutation__
 *
 * To run a mutation, you first call `useAlituCancelSchedulePublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlituCancelSchedulePublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alituCancelSchedulePublishMutation, { data, loading, error }] = useAlituCancelSchedulePublishMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useAlituCancelSchedulePublishMutation(baseOptions?: Apollo.MutationHookOptions<AlituCancelSchedulePublishMutation, AlituCancelSchedulePublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlituCancelSchedulePublishMutation, AlituCancelSchedulePublishMutationVariables>(AlituCancelSchedulePublishDocument, options);
      }
export type AlituCancelSchedulePublishMutationHookResult = ReturnType<typeof useAlituCancelSchedulePublishMutation>;
export type AlituCancelSchedulePublishMutationResult = Apollo.MutationResult<AlituCancelSchedulePublishMutation>;
export type AlituCancelSchedulePublishMutationOptions = Apollo.BaseMutationOptions<AlituCancelSchedulePublishMutation, AlituCancelSchedulePublishMutationVariables>;
export const AlituUpdatePublishedDateDocument = gql`
    mutation alituUpdatePublishedDate($episodeId: ID!, $publishedAt: String!) {
  alituUpdatePublishedDate(episodeId: $episodeId, publishedAt: $publishedAt) {
    success
  }
}
    `;
export type AlituUpdatePublishedDateMutationFn = Apollo.MutationFunction<AlituUpdatePublishedDateMutation, AlituUpdatePublishedDateMutationVariables>;

/**
 * __useAlituUpdatePublishedDateMutation__
 *
 * To run a mutation, you first call `useAlituUpdatePublishedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlituUpdatePublishedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alituUpdatePublishedDateMutation, { data, loading, error }] = useAlituUpdatePublishedDateMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      publishedAt: // value for 'publishedAt'
 *   },
 * });
 */
export function useAlituUpdatePublishedDateMutation(baseOptions?: Apollo.MutationHookOptions<AlituUpdatePublishedDateMutation, AlituUpdatePublishedDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlituUpdatePublishedDateMutation, AlituUpdatePublishedDateMutationVariables>(AlituUpdatePublishedDateDocument, options);
      }
export type AlituUpdatePublishedDateMutationHookResult = ReturnType<typeof useAlituUpdatePublishedDateMutation>;
export type AlituUpdatePublishedDateMutationResult = Apollo.MutationResult<AlituUpdatePublishedDateMutation>;
export type AlituUpdatePublishedDateMutationOptions = Apollo.BaseMutationOptions<AlituUpdatePublishedDateMutation, AlituUpdatePublishedDateMutationVariables>;
export const GenerateTitlesAndSummariesDocument = gql`
    mutation generateTitlesAndSummaries($episodeId: ID!) {
  generateTitlesAndSummaries(episodeId: $episodeId) {
    jobId
    episode {
      ...EpisodeAllFields
    }
  }
}
    ${EpisodeAllFieldsFragmentDoc}`;
export type GenerateTitlesAndSummariesMutationFn = Apollo.MutationFunction<GenerateTitlesAndSummariesMutation, GenerateTitlesAndSummariesMutationVariables>;

/**
 * __useGenerateTitlesAndSummariesMutation__
 *
 * To run a mutation, you first call `useGenerateTitlesAndSummariesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTitlesAndSummariesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTitlesAndSummariesMutation, { data, loading, error }] = useGenerateTitlesAndSummariesMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useGenerateTitlesAndSummariesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTitlesAndSummariesMutation, GenerateTitlesAndSummariesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTitlesAndSummariesMutation, GenerateTitlesAndSummariesMutationVariables>(GenerateTitlesAndSummariesDocument, options);
      }
export type GenerateTitlesAndSummariesMutationHookResult = ReturnType<typeof useGenerateTitlesAndSummariesMutation>;
export type GenerateTitlesAndSummariesMutationResult = Apollo.MutationResult<GenerateTitlesAndSummariesMutation>;
export type GenerateTitlesAndSummariesMutationOptions = Apollo.BaseMutationOptions<GenerateTitlesAndSummariesMutation, GenerateTitlesAndSummariesMutationVariables>;
export const HostTokenDocument = gql`
    query hostToken($hostTokenInput: HostInput!) {
  hostToken(input: $hostTokenInput) {
    token
  }
}
    `;

/**
 * __useHostTokenQuery__
 *
 * To run a query within a React component, call `useHostTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useHostTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHostTokenQuery({
 *   variables: {
 *      hostTokenInput: // value for 'hostTokenInput'
 *   },
 * });
 */
export function useHostTokenQuery(baseOptions: Apollo.QueryHookOptions<HostTokenQuery, HostTokenQueryVariables> & ({ variables: HostTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HostTokenQuery, HostTokenQueryVariables>(HostTokenDocument, options);
      }
export function useHostTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HostTokenQuery, HostTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HostTokenQuery, HostTokenQueryVariables>(HostTokenDocument, options);
        }
export function useHostTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HostTokenQuery, HostTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HostTokenQuery, HostTokenQueryVariables>(HostTokenDocument, options);
        }
export type HostTokenQueryHookResult = ReturnType<typeof useHostTokenQuery>;
export type HostTokenLazyQueryHookResult = ReturnType<typeof useHostTokenLazyQuery>;
export type HostTokenSuspenseQueryHookResult = ReturnType<typeof useHostTokenSuspenseQuery>;
export type HostTokenQueryResult = Apollo.QueryResult<HostTokenQuery, HostTokenQueryVariables>;
export const PublishPageDocument = gql`
    query publishPage($episodeId: ID!, $projectId: ID!) {
  host
  episode(id: $episodeId) {
    id
    metaData {
      ...MetaData
    }
    file {
      id
      codecInformation {
        format {
          duration
        }
      }
      audioJob {
        id
        status
      }
      videoJob {
        id
        status
      }
      transcriptionJob {
        id
        status
      }
      aiJob {
        id
        status
      }
      metaDataJob {
        id
        status
        schema
      }
    }
    version
    artworkUrl
    publishedAt
    schedulePublishAt
    host
    shouldSuggestTitle
    shouldSuggestDescription
    shouldIncludeTranscriptInRss
  }
  show(id: $projectId) {
    id
    subdomain
    redirectUrl
  }
}
    ${MetaDataFragmentDoc}`;

/**
 * __usePublishPageQuery__
 *
 * To run a query within a React component, call `usePublishPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishPageQuery({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePublishPageQuery(baseOptions: Apollo.QueryHookOptions<PublishPageQuery, PublishPageQueryVariables> & ({ variables: PublishPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishPageQuery, PublishPageQueryVariables>(PublishPageDocument, options);
      }
export function usePublishPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishPageQuery, PublishPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishPageQuery, PublishPageQueryVariables>(PublishPageDocument, options);
        }
export function usePublishPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublishPageQuery, PublishPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublishPageQuery, PublishPageQueryVariables>(PublishPageDocument, options);
        }
export type PublishPageQueryHookResult = ReturnType<typeof usePublishPageQuery>;
export type PublishPageLazyQueryHookResult = ReturnType<typeof usePublishPageLazyQuery>;
export type PublishPageSuspenseQueryHookResult = ReturnType<typeof usePublishPageSuspenseQuery>;
export type PublishPageQueryResult = Apollo.QueryResult<PublishPageQuery, PublishPageQueryVariables>;
export const AlituHostLoginDocument = gql`
    mutation alituHostLogin {
  alituHostLogin: connectAlituHost {
    success
    show {
      ...ShowFragment
    }
  }
}
    ${ShowFragmentFragmentDoc}`;
export type AlituHostLoginMutationFn = Apollo.MutationFunction<AlituHostLoginMutation, AlituHostLoginMutationVariables>;

/**
 * __useAlituHostLoginMutation__
 *
 * To run a mutation, you first call `useAlituHostLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlituHostLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alituHostLoginMutation, { data, loading, error }] = useAlituHostLoginMutation({
 *   variables: {
 *   },
 * });
 */
export function useAlituHostLoginMutation(baseOptions?: Apollo.MutationHookOptions<AlituHostLoginMutation, AlituHostLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlituHostLoginMutation, AlituHostLoginMutationVariables>(AlituHostLoginDocument, options);
      }
export type AlituHostLoginMutationHookResult = ReturnType<typeof useAlituHostLoginMutation>;
export type AlituHostLoginMutationResult = Apollo.MutationResult<AlituHostLoginMutation>;
export type AlituHostLoginMutationOptions = Apollo.BaseMutationOptions<AlituHostLoginMutation, AlituHostLoginMutationVariables>;
export const CaptivateLoginDocument = gql`
    mutation captivateLogin($username: String!, $apiKey: String!, $userId: ID!) {
  captivateLogin(username: $username, apiKey: $apiKey, userId: $userId) {
    token
  }
}
    `;
export type CaptivateLoginMutationFn = Apollo.MutationFunction<CaptivateLoginMutation, CaptivateLoginMutationVariables>;

/**
 * __useCaptivateLoginMutation__
 *
 * To run a mutation, you first call `useCaptivateLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCaptivateLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [captivateLoginMutation, { data, loading, error }] = useCaptivateLoginMutation({
 *   variables: {
 *      username: // value for 'username'
 *      apiKey: // value for 'apiKey'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCaptivateLoginMutation(baseOptions?: Apollo.MutationHookOptions<CaptivateLoginMutation, CaptivateLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CaptivateLoginMutation, CaptivateLoginMutationVariables>(CaptivateLoginDocument, options);
      }
export type CaptivateLoginMutationHookResult = ReturnType<typeof useCaptivateLoginMutation>;
export type CaptivateLoginMutationResult = Apollo.MutationResult<CaptivateLoginMutation>;
export type CaptivateLoginMutationOptions = Apollo.BaseMutationOptions<CaptivateLoginMutation, CaptivateLoginMutationVariables>;
export const TransistorLoginDocument = gql`
    mutation transistorLogin($token: ID!) {
  transistorLogin(token: $token) {
    isTokenValid
  }
}
    `;
export type TransistorLoginMutationFn = Apollo.MutationFunction<TransistorLoginMutation, TransistorLoginMutationVariables>;

/**
 * __useTransistorLoginMutation__
 *
 * To run a mutation, you first call `useTransistorLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransistorLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transistorLoginMutation, { data, loading, error }] = useTransistorLoginMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useTransistorLoginMutation(baseOptions?: Apollo.MutationHookOptions<TransistorLoginMutation, TransistorLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransistorLoginMutation, TransistorLoginMutationVariables>(TransistorLoginDocument, options);
      }
export type TransistorLoginMutationHookResult = ReturnType<typeof useTransistorLoginMutation>;
export type TransistorLoginMutationResult = Apollo.MutationResult<TransistorLoginMutation>;
export type TransistorLoginMutationOptions = Apollo.BaseMutationOptions<TransistorLoginMutation, TransistorLoginMutationVariables>;
export const BuzzsproutLoginDocument = gql`
    mutation buzzsproutLogin($userId: ID!, $podcastId: ID!, $token: ID!) {
  buzzsproutLogin(userId: $userId, podcastId: $podcastId, token: $token) {
    success
  }
}
    `;
export type BuzzsproutLoginMutationFn = Apollo.MutationFunction<BuzzsproutLoginMutation, BuzzsproutLoginMutationVariables>;

/**
 * __useBuzzsproutLoginMutation__
 *
 * To run a mutation, you first call `useBuzzsproutLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuzzsproutLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buzzsproutLoginMutation, { data, loading, error }] = useBuzzsproutLoginMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      podcastId: // value for 'podcastId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useBuzzsproutLoginMutation(baseOptions?: Apollo.MutationHookOptions<BuzzsproutLoginMutation, BuzzsproutLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuzzsproutLoginMutation, BuzzsproutLoginMutationVariables>(BuzzsproutLoginDocument, options);
      }
export type BuzzsproutLoginMutationHookResult = ReturnType<typeof useBuzzsproutLoginMutation>;
export type BuzzsproutLoginMutationResult = Apollo.MutationResult<BuzzsproutLoginMutation>;
export type BuzzsproutLoginMutationOptions = Apollo.BaseMutationOptions<BuzzsproutLoginMutation, BuzzsproutLoginMutationVariables>;
export const CastosLoginDocument = gql`
    mutation castosLogin($token: ID!) {
  castosLogin(token: $token) {
    isTokenValid
  }
}
    `;
export type CastosLoginMutationFn = Apollo.MutationFunction<CastosLoginMutation, CastosLoginMutationVariables>;

/**
 * __useCastosLoginMutation__
 *
 * To run a mutation, you first call `useCastosLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCastosLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [castosLoginMutation, { data, loading, error }] = useCastosLoginMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCastosLoginMutation(baseOptions?: Apollo.MutationHookOptions<CastosLoginMutation, CastosLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CastosLoginMutation, CastosLoginMutationVariables>(CastosLoginDocument, options);
      }
export type CastosLoginMutationHookResult = ReturnType<typeof useCastosLoginMutation>;
export type CastosLoginMutationResult = Apollo.MutationResult<CastosLoginMutation>;
export type CastosLoginMutationOptions = Apollo.BaseMutationOptions<CastosLoginMutation, CastosLoginMutationVariables>;
export const CaptivatePublishDocument = gql`
    mutation captivatePublish($userId: ID!, $episodeId: ID!, $isDraft: Boolean!, $captivateShow: CaptivateShow!) {
  captivatePublish(
    userId: $userId
    episodeId: $episodeId
    isDraft: $isDraft
    captivateShow: $captivateShow
  ) {
    success
  }
}
    `;
export type CaptivatePublishMutationFn = Apollo.MutationFunction<CaptivatePublishMutation, CaptivatePublishMutationVariables>;

/**
 * __useCaptivatePublishMutation__
 *
 * To run a mutation, you first call `useCaptivatePublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCaptivatePublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [captivatePublishMutation, { data, loading, error }] = useCaptivatePublishMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      episodeId: // value for 'episodeId'
 *      isDraft: // value for 'isDraft'
 *      captivateShow: // value for 'captivateShow'
 *   },
 * });
 */
export function useCaptivatePublishMutation(baseOptions?: Apollo.MutationHookOptions<CaptivatePublishMutation, CaptivatePublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CaptivatePublishMutation, CaptivatePublishMutationVariables>(CaptivatePublishDocument, options);
      }
export type CaptivatePublishMutationHookResult = ReturnType<typeof useCaptivatePublishMutation>;
export type CaptivatePublishMutationResult = Apollo.MutationResult<CaptivatePublishMutation>;
export type CaptivatePublishMutationOptions = Apollo.BaseMutationOptions<CaptivatePublishMutation, CaptivatePublishMutationVariables>;
export const CaptivateShowsDocument = gql`
    query captivateShows($userId: ID!) {
  shows: captivateShows(userId: $userId) {
    id
    title
    timeZone
    feedUrl
  }
}
    `;

/**
 * __useCaptivateShowsQuery__
 *
 * To run a query within a React component, call `useCaptivateShowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaptivateShowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaptivateShowsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCaptivateShowsQuery(baseOptions: Apollo.QueryHookOptions<CaptivateShowsQuery, CaptivateShowsQueryVariables> & ({ variables: CaptivateShowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaptivateShowsQuery, CaptivateShowsQueryVariables>(CaptivateShowsDocument, options);
      }
export function useCaptivateShowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaptivateShowsQuery, CaptivateShowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaptivateShowsQuery, CaptivateShowsQueryVariables>(CaptivateShowsDocument, options);
        }
export function useCaptivateShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaptivateShowsQuery, CaptivateShowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CaptivateShowsQuery, CaptivateShowsQueryVariables>(CaptivateShowsDocument, options);
        }
export type CaptivateShowsQueryHookResult = ReturnType<typeof useCaptivateShowsQuery>;
export type CaptivateShowsLazyQueryHookResult = ReturnType<typeof useCaptivateShowsLazyQuery>;
export type CaptivateShowsSuspenseQueryHookResult = ReturnType<typeof useCaptivateShowsSuspenseQuery>;
export type CaptivateShowsQueryResult = Apollo.QueryResult<CaptivateShowsQuery, CaptivateShowsQueryVariables>;
export const CreateVideoJobDocument = gql`
    mutation createVideoJob($episodeId: ID!) {
  createVideoJob(episodeId: $episodeId) {
    id
  }
}
    `;
export type CreateVideoJobMutationFn = Apollo.MutationFunction<CreateVideoJobMutation, CreateVideoJobMutationVariables>;

/**
 * __useCreateVideoJobMutation__
 *
 * To run a mutation, you first call `useCreateVideoJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoJobMutation, { data, loading, error }] = useCreateVideoJobMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useCreateVideoJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateVideoJobMutation, CreateVideoJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVideoJobMutation, CreateVideoJobMutationVariables>(CreateVideoJobDocument, options);
      }
export type CreateVideoJobMutationHookResult = ReturnType<typeof useCreateVideoJobMutation>;
export type CreateVideoJobMutationResult = Apollo.MutationResult<CreateVideoJobMutation>;
export type CreateVideoJobMutationOptions = Apollo.BaseMutationOptions<CreateVideoJobMutation, CreateVideoJobMutationVariables>;
export const CastosPodcastsDocument = gql`
    query castosPodcasts {
  podcasts: castosPodcasts {
    id
    title
    feedUrl
  }
}
    `;

/**
 * __useCastosPodcastsQuery__
 *
 * To run a query within a React component, call `useCastosPodcastsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCastosPodcastsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCastosPodcastsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCastosPodcastsQuery(baseOptions?: Apollo.QueryHookOptions<CastosPodcastsQuery, CastosPodcastsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CastosPodcastsQuery, CastosPodcastsQueryVariables>(CastosPodcastsDocument, options);
      }
export function useCastosPodcastsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CastosPodcastsQuery, CastosPodcastsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CastosPodcastsQuery, CastosPodcastsQueryVariables>(CastosPodcastsDocument, options);
        }
export function useCastosPodcastsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CastosPodcastsQuery, CastosPodcastsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CastosPodcastsQuery, CastosPodcastsQueryVariables>(CastosPodcastsDocument, options);
        }
export type CastosPodcastsQueryHookResult = ReturnType<typeof useCastosPodcastsQuery>;
export type CastosPodcastsLazyQueryHookResult = ReturnType<typeof useCastosPodcastsLazyQuery>;
export type CastosPodcastsSuspenseQueryHookResult = ReturnType<typeof useCastosPodcastsSuspenseQuery>;
export type CastosPodcastsQueryResult = Apollo.QueryResult<CastosPodcastsQuery, CastosPodcastsQueryVariables>;
export const CastosPublishDocument = gql`
    mutation castosPublish($episodeId: ID!, $podcastId: ID!) {
  publish: castosPublish(episodeId: $episodeId, podcastId: $podcastId) {
    success
  }
}
    `;
export type CastosPublishMutationFn = Apollo.MutationFunction<CastosPublishMutation, CastosPublishMutationVariables>;

/**
 * __useCastosPublishMutation__
 *
 * To run a mutation, you first call `useCastosPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCastosPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [castosPublishMutation, { data, loading, error }] = useCastosPublishMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      podcastId: // value for 'podcastId'
 *   },
 * });
 */
export function useCastosPublishMutation(baseOptions?: Apollo.MutationHookOptions<CastosPublishMutation, CastosPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CastosPublishMutation, CastosPublishMutationVariables>(CastosPublishDocument, options);
      }
export type CastosPublishMutationHookResult = ReturnType<typeof useCastosPublishMutation>;
export type CastosPublishMutationResult = Apollo.MutationResult<CastosPublishMutation>;
export type CastosPublishMutationOptions = Apollo.BaseMutationOptions<CastosPublishMutation, CastosPublishMutationVariables>;
export const TransistorShowsDocument = gql`
    query transistorShows {
  shows: transistorShows {
    id
    title
    description
    feedUrl
  }
}
    `;

/**
 * __useTransistorShowsQuery__
 *
 * To run a query within a React component, call `useTransistorShowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransistorShowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransistorShowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransistorShowsQuery(baseOptions?: Apollo.QueryHookOptions<TransistorShowsQuery, TransistorShowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransistorShowsQuery, TransistorShowsQueryVariables>(TransistorShowsDocument, options);
      }
export function useTransistorShowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransistorShowsQuery, TransistorShowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransistorShowsQuery, TransistorShowsQueryVariables>(TransistorShowsDocument, options);
        }
export function useTransistorShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransistorShowsQuery, TransistorShowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransistorShowsQuery, TransistorShowsQueryVariables>(TransistorShowsDocument, options);
        }
export type TransistorShowsQueryHookResult = ReturnType<typeof useTransistorShowsQuery>;
export type TransistorShowsLazyQueryHookResult = ReturnType<typeof useTransistorShowsLazyQuery>;
export type TransistorShowsSuspenseQueryHookResult = ReturnType<typeof useTransistorShowsSuspenseQuery>;
export type TransistorShowsQueryResult = Apollo.QueryResult<TransistorShowsQuery, TransistorShowsQueryVariables>;
export const TransistorPublishDocument = gql`
    mutation transistorPublish($episodeId: ID!, $showId: ID!, $isDraft: Boolean!) {
  publish: transistorPublish(
    episodeId: $episodeId
    showId: $showId
    isDraft: $isDraft
  ) {
    success
  }
}
    `;
export type TransistorPublishMutationFn = Apollo.MutationFunction<TransistorPublishMutation, TransistorPublishMutationVariables>;

/**
 * __useTransistorPublishMutation__
 *
 * To run a mutation, you first call `useTransistorPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransistorPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transistorPublishMutation, { data, loading, error }] = useTransistorPublishMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      showId: // value for 'showId'
 *      isDraft: // value for 'isDraft'
 *   },
 * });
 */
export function useTransistorPublishMutation(baseOptions?: Apollo.MutationHookOptions<TransistorPublishMutation, TransistorPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransistorPublishMutation, TransistorPublishMutationVariables>(TransistorPublishDocument, options);
      }
export type TransistorPublishMutationHookResult = ReturnType<typeof useTransistorPublishMutation>;
export type TransistorPublishMutationResult = Apollo.MutationResult<TransistorPublishMutation>;
export type TransistorPublishMutationOptions = Apollo.BaseMutationOptions<TransistorPublishMutation, TransistorPublishMutationVariables>;
export const SpreakerShowsDocument = gql`
    query spreakerShows($userId: ID!) {
  shows: getSpreakerShows(userId: $userId) {
    id
    title
    feedUrl
  }
}
    `;

/**
 * __useSpreakerShowsQuery__
 *
 * To run a query within a React component, call `useSpreakerShowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpreakerShowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpreakerShowsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSpreakerShowsQuery(baseOptions: Apollo.QueryHookOptions<SpreakerShowsQuery, SpreakerShowsQueryVariables> & ({ variables: SpreakerShowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpreakerShowsQuery, SpreakerShowsQueryVariables>(SpreakerShowsDocument, options);
      }
export function useSpreakerShowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpreakerShowsQuery, SpreakerShowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpreakerShowsQuery, SpreakerShowsQueryVariables>(SpreakerShowsDocument, options);
        }
export function useSpreakerShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SpreakerShowsQuery, SpreakerShowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpreakerShowsQuery, SpreakerShowsQueryVariables>(SpreakerShowsDocument, options);
        }
export type SpreakerShowsQueryHookResult = ReturnType<typeof useSpreakerShowsQuery>;
export type SpreakerShowsLazyQueryHookResult = ReturnType<typeof useSpreakerShowsLazyQuery>;
export type SpreakerShowsSuspenseQueryHookResult = ReturnType<typeof useSpreakerShowsSuspenseQuery>;
export type SpreakerShowsQueryResult = Apollo.QueryResult<SpreakerShowsQuery, SpreakerShowsQueryVariables>;
export const SpreakerPublishDocument = gql`
    mutation spreakerPublish($userId: ID!, $episodeId: ID!, $additional: SpreakerAdditionalInput!) {
  publish: spreakerPublish(
    userId: $userId
    episodeId: $episodeId
    additional: $additional
  ) {
    success
  }
}
    `;
export type SpreakerPublishMutationFn = Apollo.MutationFunction<SpreakerPublishMutation, SpreakerPublishMutationVariables>;

/**
 * __useSpreakerPublishMutation__
 *
 * To run a mutation, you first call `useSpreakerPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSpreakerPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [spreakerPublishMutation, { data, loading, error }] = useSpreakerPublishMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      episodeId: // value for 'episodeId'
 *      additional: // value for 'additional'
 *   },
 * });
 */
export function useSpreakerPublishMutation(baseOptions?: Apollo.MutationHookOptions<SpreakerPublishMutation, SpreakerPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SpreakerPublishMutation, SpreakerPublishMutationVariables>(SpreakerPublishDocument, options);
      }
export type SpreakerPublishMutationHookResult = ReturnType<typeof useSpreakerPublishMutation>;
export type SpreakerPublishMutationResult = Apollo.MutationResult<SpreakerPublishMutation>;
export type SpreakerPublishMutationOptions = Apollo.BaseMutationOptions<SpreakerPublishMutation, SpreakerPublishMutationVariables>;
export const LibsynShowsDocument = gql`
    query libsynShows {
  shows: getLibsynShows {
    id
    title
    feedUrl
  }
}
    `;

/**
 * __useLibsynShowsQuery__
 *
 * To run a query within a React component, call `useLibsynShowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibsynShowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibsynShowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLibsynShowsQuery(baseOptions?: Apollo.QueryHookOptions<LibsynShowsQuery, LibsynShowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LibsynShowsQuery, LibsynShowsQueryVariables>(LibsynShowsDocument, options);
      }
export function useLibsynShowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LibsynShowsQuery, LibsynShowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LibsynShowsQuery, LibsynShowsQueryVariables>(LibsynShowsDocument, options);
        }
export function useLibsynShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibsynShowsQuery, LibsynShowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LibsynShowsQuery, LibsynShowsQueryVariables>(LibsynShowsDocument, options);
        }
export type LibsynShowsQueryHookResult = ReturnType<typeof useLibsynShowsQuery>;
export type LibsynShowsLazyQueryHookResult = ReturnType<typeof useLibsynShowsLazyQuery>;
export type LibsynShowsSuspenseQueryHookResult = ReturnType<typeof useLibsynShowsSuspenseQuery>;
export type LibsynShowsQueryResult = Apollo.QueryResult<LibsynShowsQuery, LibsynShowsQueryVariables>;
export const LibsynPublishDocument = gql`
    mutation libsynPublish($userId: ID!, $additional: LibsynUploadAdditional!, $episodeId: ID!) {
  publish: libsynPublish(
    userId: $userId
    additional: $additional
    episodeId: $episodeId
  ) {
    success
  }
}
    `;
export type LibsynPublishMutationFn = Apollo.MutationFunction<LibsynPublishMutation, LibsynPublishMutationVariables>;

/**
 * __useLibsynPublishMutation__
 *
 * To run a mutation, you first call `useLibsynPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLibsynPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [libsynPublishMutation, { data, loading, error }] = useLibsynPublishMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      additional: // value for 'additional'
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useLibsynPublishMutation(baseOptions?: Apollo.MutationHookOptions<LibsynPublishMutation, LibsynPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LibsynPublishMutation, LibsynPublishMutationVariables>(LibsynPublishDocument, options);
      }
export type LibsynPublishMutationHookResult = ReturnType<typeof useLibsynPublishMutation>;
export type LibsynPublishMutationResult = Apollo.MutationResult<LibsynPublishMutation>;
export type LibsynPublishMutationOptions = Apollo.BaseMutationOptions<LibsynPublishMutation, LibsynPublishMutationVariables>;
export const PodbeanPublishDocument = gql`
    mutation podbeanPublish($userId: ID!, $additional: PodbeanAdditional!, $episodeId: ID!) {
  publish: podbeanPublish(
    userId: $userId
    additional: $additional
    episodeId: $episodeId
  ) {
    success
  }
}
    `;
export type PodbeanPublishMutationFn = Apollo.MutationFunction<PodbeanPublishMutation, PodbeanPublishMutationVariables>;

/**
 * __usePodbeanPublishMutation__
 *
 * To run a mutation, you first call `usePodbeanPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePodbeanPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [podbeanPublishMutation, { data, loading, error }] = usePodbeanPublishMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      additional: // value for 'additional'
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function usePodbeanPublishMutation(baseOptions?: Apollo.MutationHookOptions<PodbeanPublishMutation, PodbeanPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PodbeanPublishMutation, PodbeanPublishMutationVariables>(PodbeanPublishDocument, options);
      }
export type PodbeanPublishMutationHookResult = ReturnType<typeof usePodbeanPublishMutation>;
export type PodbeanPublishMutationResult = Apollo.MutationResult<PodbeanPublishMutation>;
export type PodbeanPublishMutationOptions = Apollo.BaseMutationOptions<PodbeanPublishMutation, PodbeanPublishMutationVariables>;
export const BuzzsproutPublishDocument = gql`
    mutation buzzsproutPublish($userId: ID!, $additional: AdditionalInput!, $episodeId: ID!) {
  publish: buzzsproutPublish(
    userId: $userId
    additional: $additional
    episodeId: $episodeId
  ) {
    success
  }
}
    `;
export type BuzzsproutPublishMutationFn = Apollo.MutationFunction<BuzzsproutPublishMutation, BuzzsproutPublishMutationVariables>;

/**
 * __useBuzzsproutPublishMutation__
 *
 * To run a mutation, you first call `useBuzzsproutPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuzzsproutPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buzzsproutPublishMutation, { data, loading, error }] = useBuzzsproutPublishMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      additional: // value for 'additional'
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useBuzzsproutPublishMutation(baseOptions?: Apollo.MutationHookOptions<BuzzsproutPublishMutation, BuzzsproutPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuzzsproutPublishMutation, BuzzsproutPublishMutationVariables>(BuzzsproutPublishDocument, options);
      }
export type BuzzsproutPublishMutationHookResult = ReturnType<typeof useBuzzsproutPublishMutation>;
export type BuzzsproutPublishMutationResult = Apollo.MutationResult<BuzzsproutPublishMutation>;
export type BuzzsproutPublishMutationOptions = Apollo.BaseMutationOptions<BuzzsproutPublishMutation, BuzzsproutPublishMutationVariables>;
export const EpisodeJobStatusDocument = gql`
    query episodeJobStatus($id: ID!) {
  episodeJobStatus: episode(id: $id) {
    id
    file {
      id
      audioJob {
        id
        status
        schema
      }
      videoJob {
        id
        status
      }
      transcriptionJob {
        id
        status
      }
      aiJob {
        id
        status
      }
      metaDataJob {
        id
        status
      }
    }
  }
}
    `;

/**
 * __useEpisodeJobStatusQuery__
 *
 * To run a query within a React component, call `useEpisodeJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpisodeJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpisodeJobStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEpisodeJobStatusQuery(baseOptions: Apollo.QueryHookOptions<EpisodeJobStatusQuery, EpisodeJobStatusQueryVariables> & ({ variables: EpisodeJobStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpisodeJobStatusQuery, EpisodeJobStatusQueryVariables>(EpisodeJobStatusDocument, options);
      }
export function useEpisodeJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpisodeJobStatusQuery, EpisodeJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpisodeJobStatusQuery, EpisodeJobStatusQueryVariables>(EpisodeJobStatusDocument, options);
        }
export function useEpisodeJobStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodeJobStatusQuery, EpisodeJobStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EpisodeJobStatusQuery, EpisodeJobStatusQueryVariables>(EpisodeJobStatusDocument, options);
        }
export type EpisodeJobStatusQueryHookResult = ReturnType<typeof useEpisodeJobStatusQuery>;
export type EpisodeJobStatusLazyQueryHookResult = ReturnType<typeof useEpisodeJobStatusLazyQuery>;
export type EpisodeJobStatusSuspenseQueryHookResult = ReturnType<typeof useEpisodeJobStatusSuspenseQuery>;
export type EpisodeJobStatusQueryResult = Apollo.QueryResult<EpisodeJobStatusQuery, EpisodeJobStatusQueryVariables>;
export const PublishToAlituDocument = gql`
    mutation publishToAlitu($userId: ID!, $episodeId: ID!) {
  alituPublish(userId: $userId, episodeId: $episodeId) {
    success
  }
}
    `;
export type PublishToAlituMutationFn = Apollo.MutationFunction<PublishToAlituMutation, PublishToAlituMutationVariables>;

/**
 * __usePublishToAlituMutation__
 *
 * To run a mutation, you first call `usePublishToAlituMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishToAlituMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishToAlituMutation, { data, loading, error }] = usePublishToAlituMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function usePublishToAlituMutation(baseOptions?: Apollo.MutationHookOptions<PublishToAlituMutation, PublishToAlituMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishToAlituMutation, PublishToAlituMutationVariables>(PublishToAlituDocument, options);
      }
export type PublishToAlituMutationHookResult = ReturnType<typeof usePublishToAlituMutation>;
export type PublishToAlituMutationResult = Apollo.MutationResult<PublishToAlituMutation>;
export type PublishToAlituMutationOptions = Apollo.BaseMutationOptions<PublishToAlituMutation, PublishToAlituMutationVariables>;
export const UnpublishFromAlituDocument = gql`
    mutation unpublishFromAlitu($userId: ID!, $episodeId: ID!) {
  alituUnpublish(userId: $userId, episodeId: $episodeId) {
    success
  }
}
    `;
export type UnpublishFromAlituMutationFn = Apollo.MutationFunction<UnpublishFromAlituMutation, UnpublishFromAlituMutationVariables>;

/**
 * __useUnpublishFromAlituMutation__
 *
 * To run a mutation, you first call `useUnpublishFromAlituMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishFromAlituMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishFromAlituMutation, { data, loading, error }] = useUnpublishFromAlituMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useUnpublishFromAlituMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishFromAlituMutation, UnpublishFromAlituMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishFromAlituMutation, UnpublishFromAlituMutationVariables>(UnpublishFromAlituDocument, options);
      }
export type UnpublishFromAlituMutationHookResult = ReturnType<typeof useUnpublishFromAlituMutation>;
export type UnpublishFromAlituMutationResult = Apollo.MutationResult<UnpublishFromAlituMutation>;
export type UnpublishFromAlituMutationOptions = Apollo.BaseMutationOptions<UnpublishFromAlituMutation, UnpublishFromAlituMutationVariables>;
export const TranscriptionDocument = gql`
    query transcription($fileId: ID!) {
  transcription(fileId: $fileId) {
    id
    fileId
    speakerNames
    createdAt
    status
  }
}
    `;

/**
 * __useTranscriptionQuery__
 *
 * To run a query within a React component, call `useTranscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranscriptionQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useTranscriptionQuery(baseOptions: Apollo.QueryHookOptions<TranscriptionQuery, TranscriptionQueryVariables> & ({ variables: TranscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TranscriptionQuery, TranscriptionQueryVariables>(TranscriptionDocument, options);
      }
export function useTranscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TranscriptionQuery, TranscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TranscriptionQuery, TranscriptionQueryVariables>(TranscriptionDocument, options);
        }
export function useTranscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TranscriptionQuery, TranscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TranscriptionQuery, TranscriptionQueryVariables>(TranscriptionDocument, options);
        }
export type TranscriptionQueryHookResult = ReturnType<typeof useTranscriptionQuery>;
export type TranscriptionLazyQueryHookResult = ReturnType<typeof useTranscriptionLazyQuery>;
export type TranscriptionSuspenseQueryHookResult = ReturnType<typeof useTranscriptionSuspenseQuery>;
export type TranscriptionQueryResult = Apollo.QueryResult<TranscriptionQuery, TranscriptionQueryVariables>;
export const UpdateTranscriptionDocument = gql`
    mutation updateTranscription($fileId: ID!, $speakerNames: [String!]!) {
  updateTranscription(fileId: $fileId, speakerNames: $speakerNames) {
    id
    fileId
    speakerNames
  }
}
    `;
export type UpdateTranscriptionMutationFn = Apollo.MutationFunction<UpdateTranscriptionMutation, UpdateTranscriptionMutationVariables>;

/**
 * __useUpdateTranscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateTranscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranscriptionMutation, { data, loading, error }] = useUpdateTranscriptionMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      speakerNames: // value for 'speakerNames'
 *   },
 * });
 */
export function useUpdateTranscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTranscriptionMutation, UpdateTranscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTranscriptionMutation, UpdateTranscriptionMutationVariables>(UpdateTranscriptionDocument, options);
      }
export type UpdateTranscriptionMutationHookResult = ReturnType<typeof useUpdateTranscriptionMutation>;
export type UpdateTranscriptionMutationResult = Apollo.MutationResult<UpdateTranscriptionMutation>;
export type UpdateTranscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateTranscriptionMutation, UpdateTranscriptionMutationVariables>;
export const CustomerDocument = gql`
    query customer {
  customer {
    currency
    address {
      country
      postal_code
    }
  }
}
    `;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerQuery(baseOptions?: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
      }
export function useCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export function useCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<typeof useCustomerLazyQuery>;
export type CustomerSuspenseQueryHookResult = ReturnType<typeof useCustomerSuspenseQuery>;
export type CustomerQueryResult = Apollo.QueryResult<CustomerQuery, CustomerQueryVariables>;
export const CheckSubdomainDocument = gql`
    query checkSubdomain($subdomain: String!) {
  checkSubdomain(subdomain: $subdomain) {
    id
    name
  }
}
    `;

/**
 * __useCheckSubdomainQuery__
 *
 * To run a query within a React component, call `useCheckSubdomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSubdomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSubdomainQuery({
 *   variables: {
 *      subdomain: // value for 'subdomain'
 *   },
 * });
 */
export function useCheckSubdomainQuery(baseOptions: Apollo.QueryHookOptions<CheckSubdomainQuery, CheckSubdomainQueryVariables> & ({ variables: CheckSubdomainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSubdomainQuery, CheckSubdomainQueryVariables>(CheckSubdomainDocument, options);
      }
export function useCheckSubdomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSubdomainQuery, CheckSubdomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSubdomainQuery, CheckSubdomainQueryVariables>(CheckSubdomainDocument, options);
        }
export function useCheckSubdomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckSubdomainQuery, CheckSubdomainQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckSubdomainQuery, CheckSubdomainQueryVariables>(CheckSubdomainDocument, options);
        }
export type CheckSubdomainQueryHookResult = ReturnType<typeof useCheckSubdomainQuery>;
export type CheckSubdomainLazyQueryHookResult = ReturnType<typeof useCheckSubdomainLazyQuery>;
export type CheckSubdomainSuspenseQueryHookResult = ReturnType<typeof useCheckSubdomainSuspenseQuery>;
export type CheckSubdomainQueryResult = Apollo.QueryResult<CheckSubdomainQuery, CheckSubdomainQueryVariables>;
export const DeleteSubdomainDocument = gql`
    mutation deleteSubdomain($subdomain: String!, $id: ID!) {
  deleteSubdomain(subdomain: $subdomain, id: $id) {
    success
  }
}
    `;
export type DeleteSubdomainMutationFn = Apollo.MutationFunction<DeleteSubdomainMutation, DeleteSubdomainMutationVariables>;

/**
 * __useDeleteSubdomainMutation__
 *
 * To run a mutation, you first call `useDeleteSubdomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubdomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubdomainMutation, { data, loading, error }] = useDeleteSubdomainMutation({
 *   variables: {
 *      subdomain: // value for 'subdomain'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSubdomainMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubdomainMutation, DeleteSubdomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubdomainMutation, DeleteSubdomainMutationVariables>(DeleteSubdomainDocument, options);
      }
export type DeleteSubdomainMutationHookResult = ReturnType<typeof useDeleteSubdomainMutation>;
export type DeleteSubdomainMutationResult = Apollo.MutationResult<DeleteSubdomainMutation>;
export type DeleteSubdomainMutationOptions = Apollo.BaseMutationOptions<DeleteSubdomainMutation, DeleteSubdomainMutationVariables>;
export const SettingsPageDocument = gql`
    query settingsPage($projectId: ID!) {
  defaultIntroMusic: getDefaultMusic(type: "intro", projectId: $projectId) {
    ...DefaultMusicFields
  }
  defaultOutroMusic: getDefaultMusic(type: "outro", projectId: $projectId) {
    ...DefaultMusicFields
  }
}
    ${DefaultMusicFieldsFragmentDoc}`;

/**
 * __useSettingsPageQuery__
 *
 * To run a query within a React component, call `useSettingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsPageQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSettingsPageQuery(baseOptions: Apollo.QueryHookOptions<SettingsPageQuery, SettingsPageQueryVariables> & ({ variables: SettingsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettingsPageQuery, SettingsPageQueryVariables>(SettingsPageDocument, options);
      }
export function useSettingsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsPageQuery, SettingsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettingsPageQuery, SettingsPageQueryVariables>(SettingsPageDocument, options);
        }
export function useSettingsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SettingsPageQuery, SettingsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettingsPageQuery, SettingsPageQueryVariables>(SettingsPageDocument, options);
        }
export type SettingsPageQueryHookResult = ReturnType<typeof useSettingsPageQuery>;
export type SettingsPageLazyQueryHookResult = ReturnType<typeof useSettingsPageLazyQuery>;
export type SettingsPageSuspenseQueryHookResult = ReturnType<typeof useSettingsPageSuspenseQuery>;
export type SettingsPageQueryResult = Apollo.QueryResult<SettingsPageQuery, SettingsPageQueryVariables>;
export const DefaultMusicDocument = gql`
    query defaultMusic($projectId: ID!) {
  defaultIntroMusic: getDefaultMusic(type: "intro", projectId: $projectId) {
    ...DefaultMusicFields
  }
  defaultOutroMusic: getDefaultMusic(type: "outro", projectId: $projectId) {
    ...DefaultMusicFields
  }
}
    ${DefaultMusicFieldsFragmentDoc}`;

/**
 * __useDefaultMusicQuery__
 *
 * To run a query within a React component, call `useDefaultMusicQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultMusicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultMusicQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDefaultMusicQuery(baseOptions: Apollo.QueryHookOptions<DefaultMusicQuery, DefaultMusicQueryVariables> & ({ variables: DefaultMusicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefaultMusicQuery, DefaultMusicQueryVariables>(DefaultMusicDocument, options);
      }
export function useDefaultMusicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultMusicQuery, DefaultMusicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefaultMusicQuery, DefaultMusicQueryVariables>(DefaultMusicDocument, options);
        }
export function useDefaultMusicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefaultMusicQuery, DefaultMusicQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefaultMusicQuery, DefaultMusicQueryVariables>(DefaultMusicDocument, options);
        }
export type DefaultMusicQueryHookResult = ReturnType<typeof useDefaultMusicQuery>;
export type DefaultMusicLazyQueryHookResult = ReturnType<typeof useDefaultMusicLazyQuery>;
export type DefaultMusicSuspenseQueryHookResult = ReturnType<typeof useDefaultMusicSuspenseQuery>;
export type DefaultMusicQueryResult = Apollo.QueryResult<DefaultMusicQuery, DefaultMusicQueryVariables>;
export const UpdatePodcastDocument = gql`
    mutation updatePodcast($id: ID!, $podcast: PodcastInput!, $adobeArtwork: Boolean, $shouldRegenerateRssFeed: Boolean) {
  updatePodcast(
    id: $id
    podcast: $podcast
    adobeArtwork: $adobeArtwork
    shouldRegenerateRssFeed: $shouldRegenerateRssFeed
  ) {
    id
    name
    description
    categories {
      category
      subcategory
      thirdCategory
    }
    language
    feedLimit
    isExplicit
    type
    email
    hostName
    timeZone
    lockFeed
    statsUrlPrefix
    copyright
    artworkUrl
    subdomain
    links {
      apple
      spotify
      alituBadge
      facebookPage
      facebookGroup
      twitter
      instagram
      linkedin
      youtube
      website
      pandora
      iHeartRadio
      deezer
    }
    bitratePreference
    waveformPreference
    transcriptionPreferences {
      language
    }
    autoZoomPreference
    autoCenterPreference
    processingSettings {
      voiceAutoEq
      bgNoiseRemoval
      removeBreathings
    }
    thirdPartyRssFeed
  }
}
    `;
export type UpdatePodcastMutationFn = Apollo.MutationFunction<UpdatePodcastMutation, UpdatePodcastMutationVariables>;

/**
 * __useUpdatePodcastMutation__
 *
 * To run a mutation, you first call `useUpdatePodcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePodcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePodcastMutation, { data, loading, error }] = useUpdatePodcastMutation({
 *   variables: {
 *      id: // value for 'id'
 *      podcast: // value for 'podcast'
 *      adobeArtwork: // value for 'adobeArtwork'
 *      shouldRegenerateRssFeed: // value for 'shouldRegenerateRssFeed'
 *   },
 * });
 */
export function useUpdatePodcastMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePodcastMutation, UpdatePodcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePodcastMutation, UpdatePodcastMutationVariables>(UpdatePodcastDocument, options);
      }
export type UpdatePodcastMutationHookResult = ReturnType<typeof useUpdatePodcastMutation>;
export type UpdatePodcastMutationResult = Apollo.MutationResult<UpdatePodcastMutation>;
export type UpdatePodcastMutationOptions = Apollo.BaseMutationOptions<UpdatePodcastMutation, UpdatePodcastMutationVariables>;
export const SetDefaultMusicDocument = gql`
    mutation setDefaultMusic($id: ID!, $projectId: ID!, $newData: UpdateFile, $removeData: JSON) {
  updateFile(
    id: $id
    projectId: $projectId
    newData: $newData
    removeData: $removeData
  )
}
    `;
export type SetDefaultMusicMutationFn = Apollo.MutationFunction<SetDefaultMusicMutation, SetDefaultMusicMutationVariables>;

/**
 * __useSetDefaultMusicMutation__
 *
 * To run a mutation, you first call `useSetDefaultMusicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultMusicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultMusicMutation, { data, loading, error }] = useSetDefaultMusicMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *      newData: // value for 'newData'
 *      removeData: // value for 'removeData'
 *   },
 * });
 */
export function useSetDefaultMusicMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultMusicMutation, SetDefaultMusicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultMusicMutation, SetDefaultMusicMutationVariables>(SetDefaultMusicDocument, options);
      }
export type SetDefaultMusicMutationHookResult = ReturnType<typeof useSetDefaultMusicMutation>;
export type SetDefaultMusicMutationResult = Apollo.MutationResult<SetDefaultMusicMutation>;
export type SetDefaultMusicMutationOptions = Apollo.BaseMutationOptions<SetDefaultMusicMutation, SetDefaultMusicMutationVariables>;
export const ImportPodcastRssDocument = gql`
    mutation importPodcastRss($rssFeedUrl: String!) {
  importPodcastRss(rssFeedUrl: $rssFeedUrl) {
    success
    url {
      rss
    }
  }
}
    `;
export type ImportPodcastRssMutationFn = Apollo.MutationFunction<ImportPodcastRssMutation, ImportPodcastRssMutationVariables>;

/**
 * __useImportPodcastRssMutation__
 *
 * To run a mutation, you first call `useImportPodcastRssMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportPodcastRssMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importPodcastRssMutation, { data, loading, error }] = useImportPodcastRssMutation({
 *   variables: {
 *      rssFeedUrl: // value for 'rssFeedUrl'
 *   },
 * });
 */
export function useImportPodcastRssMutation(baseOptions?: Apollo.MutationHookOptions<ImportPodcastRssMutation, ImportPodcastRssMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportPodcastRssMutation, ImportPodcastRssMutationVariables>(ImportPodcastRssDocument, options);
      }
export type ImportPodcastRssMutationHookResult = ReturnType<typeof useImportPodcastRssMutation>;
export type ImportPodcastRssMutationResult = Apollo.MutationResult<ImportPodcastRssMutation>;
export type ImportPodcastRssMutationOptions = Apollo.BaseMutationOptions<ImportPodcastRssMutation, ImportPodcastRssMutationVariables>;
export const RedirectRssDocument = gql`
    mutation redirectRss($url: String!) {
  redirectRss(rssFeedUrl: $url) {
    success
  }
}
    `;
export type RedirectRssMutationFn = Apollo.MutationFunction<RedirectRssMutation, RedirectRssMutationVariables>;

/**
 * __useRedirectRssMutation__
 *
 * To run a mutation, you first call `useRedirectRssMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedirectRssMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redirectRssMutation, { data, loading, error }] = useRedirectRssMutation({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useRedirectRssMutation(baseOptions?: Apollo.MutationHookOptions<RedirectRssMutation, RedirectRssMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedirectRssMutation, RedirectRssMutationVariables>(RedirectRssDocument, options);
      }
export type RedirectRssMutationHookResult = ReturnType<typeof useRedirectRssMutation>;
export type RedirectRssMutationResult = Apollo.MutationResult<RedirectRssMutation>;
export type RedirectRssMutationOptions = Apollo.BaseMutationOptions<RedirectRssMutation, RedirectRssMutationVariables>;
export const FetchHostDocument = gql`
    query fetchHost {
  host
}
    `;

/**
 * __useFetchHostQuery__
 *
 * To run a query within a React component, call `useFetchHostQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchHostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchHostQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchHostQuery(baseOptions?: Apollo.QueryHookOptions<FetchHostQuery, FetchHostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchHostQuery, FetchHostQueryVariables>(FetchHostDocument, options);
      }
export function useFetchHostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchHostQuery, FetchHostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchHostQuery, FetchHostQueryVariables>(FetchHostDocument, options);
        }
export function useFetchHostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchHostQuery, FetchHostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchHostQuery, FetchHostQueryVariables>(FetchHostDocument, options);
        }
export type FetchHostQueryHookResult = ReturnType<typeof useFetchHostQuery>;
export type FetchHostLazyQueryHookResult = ReturnType<typeof useFetchHostLazyQuery>;
export type FetchHostSuspenseQueryHookResult = ReturnType<typeof useFetchHostSuspenseQuery>;
export type FetchHostQueryResult = Apollo.QueryResult<FetchHostQuery, FetchHostQueryVariables>;
export const DeleteHostTokenDocument = gql`
    mutation deleteHostToken($input: HostInput!) {
  deleteHostToken(input: $input) {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;
export type DeleteHostTokenMutationFn = Apollo.MutationFunction<DeleteHostTokenMutation, DeleteHostTokenMutationVariables>;

/**
 * __useDeleteHostTokenMutation__
 *
 * To run a mutation, you first call `useDeleteHostTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHostTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHostTokenMutation, { data, loading, error }] = useDeleteHostTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteHostTokenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHostTokenMutation, DeleteHostTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHostTokenMutation, DeleteHostTokenMutationVariables>(DeleteHostTokenDocument, options);
      }
export type DeleteHostTokenMutationHookResult = ReturnType<typeof useDeleteHostTokenMutation>;
export type DeleteHostTokenMutationResult = Apollo.MutationResult<DeleteHostTokenMutation>;
export type DeleteHostTokenMutationOptions = Apollo.BaseMutationOptions<DeleteHostTokenMutation, DeleteHostTokenMutationVariables>;
export const GetTranscriptionUsageAndLimitDocument = gql`
    query getTranscriptionUsageAndLimit {
  getTranscriptionUsageAndLimit {
    usage
    limit
  }
}
    `;

/**
 * __useGetTranscriptionUsageAndLimitQuery__
 *
 * To run a query within a React component, call `useGetTranscriptionUsageAndLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranscriptionUsageAndLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranscriptionUsageAndLimitQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTranscriptionUsageAndLimitQuery(baseOptions?: Apollo.QueryHookOptions<GetTranscriptionUsageAndLimitQuery, GetTranscriptionUsageAndLimitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranscriptionUsageAndLimitQuery, GetTranscriptionUsageAndLimitQueryVariables>(GetTranscriptionUsageAndLimitDocument, options);
      }
export function useGetTranscriptionUsageAndLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranscriptionUsageAndLimitQuery, GetTranscriptionUsageAndLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranscriptionUsageAndLimitQuery, GetTranscriptionUsageAndLimitQueryVariables>(GetTranscriptionUsageAndLimitDocument, options);
        }
export function useGetTranscriptionUsageAndLimitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTranscriptionUsageAndLimitQuery, GetTranscriptionUsageAndLimitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTranscriptionUsageAndLimitQuery, GetTranscriptionUsageAndLimitQueryVariables>(GetTranscriptionUsageAndLimitDocument, options);
        }
export type GetTranscriptionUsageAndLimitQueryHookResult = ReturnType<typeof useGetTranscriptionUsageAndLimitQuery>;
export type GetTranscriptionUsageAndLimitLazyQueryHookResult = ReturnType<typeof useGetTranscriptionUsageAndLimitLazyQuery>;
export type GetTranscriptionUsageAndLimitSuspenseQueryHookResult = ReturnType<typeof useGetTranscriptionUsageAndLimitSuspenseQuery>;
export type GetTranscriptionUsageAndLimitQueryResult = Apollo.QueryResult<GetTranscriptionUsageAndLimitQuery, GetTranscriptionUsageAndLimitQueryVariables>;
export const CreateUserDocument = gql`
    mutation createUser($token: String!, $email: String!, $password: String!, $name: String!, $emailOptIn: Boolean!, $marketingData: JSON) {
  createUser(
    token: $token
    email: $email
    password: $password
    name: $name
    emailOptIn: $emailOptIn
    marketingData: $marketingData
  ) {
    user {
      ...UserFragment
    }
    show {
      ...ShowFragment
    }
  }
}
    ${UserFragmentFragmentDoc}
${ShowFragmentFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      token: // value for 'token'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      name: // value for 'name'
 *      emailOptIn: // value for 'emailOptIn'
 *      marketingData: // value for 'marketingData'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const CreateCustomerDocument = gql`
    mutation createCustomer($company: Company, $promoCode: String, $address: StripeAddressParam, $plan: String!, $hostingPlan: String, $paymentMethod: String) {
  createCustomer(
    promoCode: $promoCode
    company: $company
    address: $address
    plan: $plan
    hostingPlan: $hostingPlan
    paymentMethod: $paymentMethod
  ) {
    clientSecret
    setupIntentId
  }
}
    `;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      company: // value for 'company'
 *      promoCode: // value for 'promoCode'
 *      address: // value for 'address'
 *      plan: // value for 'plan'
 *      hostingPlan: // value for 'hostingPlan'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation createSubscription($paymentMethod: String, $plan: String!, $hostingPlan: String, $isEuropeanUnion: Boolean!, $company: Company, $withTrial: Boolean, $promoCode: String, $address: StripeAddressParam) {
  createSubscription(
    paymentMethod: $paymentMethod
    plan: $plan
    hostingPlan: $hostingPlan
    isEuropeanUnion: $isEuropeanUnion
    company: $company
    withTrial: $withTrial
    promoCode: $promoCode
    address: $address
  ) {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
    ...SubscriptionInvoiceFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}
${SubscriptionInvoiceFragmentFragmentDoc}`;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      paymentMethod: // value for 'paymentMethod'
 *      plan: // value for 'plan'
 *      hostingPlan: // value for 'hostingPlan'
 *      isEuropeanUnion: // value for 'isEuropeanUnion'
 *      company: // value for 'company'
 *      withTrial: // value for 'withTrial'
 *      promoCode: // value for 'promoCode'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const CreateSubscriptionFromSetupIntentDocument = gql`
    mutation createSubscriptionFromSetupIntent($setupIntentId: String!) {
  createSubscriptionFromSetupIntent(setupIntentId: $setupIntentId) {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type CreateSubscriptionFromSetupIntentMutationFn = Apollo.MutationFunction<CreateSubscriptionFromSetupIntentMutation, CreateSubscriptionFromSetupIntentMutationVariables>;

/**
 * __useCreateSubscriptionFromSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionFromSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionFromSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionFromSetupIntentMutation, { data, loading, error }] = useCreateSubscriptionFromSetupIntentMutation({
 *   variables: {
 *      setupIntentId: // value for 'setupIntentId'
 *   },
 * });
 */
export function useCreateSubscriptionFromSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionFromSetupIntentMutation, CreateSubscriptionFromSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionFromSetupIntentMutation, CreateSubscriptionFromSetupIntentMutationVariables>(CreateSubscriptionFromSetupIntentDocument, options);
      }
export type CreateSubscriptionFromSetupIntentMutationHookResult = ReturnType<typeof useCreateSubscriptionFromSetupIntentMutation>;
export type CreateSubscriptionFromSetupIntentMutationResult = Apollo.MutationResult<CreateSubscriptionFromSetupIntentMutation>;
export type CreateSubscriptionFromSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionFromSetupIntentMutation, CreateSubscriptionFromSetupIntentMutationVariables>;
export const TaxPercentageDocument = gql`
    query taxPercentage($countryCode: String!, $vatNumber: String) {
  tax(countryCode: $countryCode, vatNumber: $vatNumber) {
    percentage
  }
}
    `;

/**
 * __useTaxPercentageQuery__
 *
 * To run a query within a React component, call `useTaxPercentageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxPercentageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxPercentageQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      vatNumber: // value for 'vatNumber'
 *   },
 * });
 */
export function useTaxPercentageQuery(baseOptions: Apollo.QueryHookOptions<TaxPercentageQuery, TaxPercentageQueryVariables> & ({ variables: TaxPercentageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxPercentageQuery, TaxPercentageQueryVariables>(TaxPercentageDocument, options);
      }
export function useTaxPercentageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxPercentageQuery, TaxPercentageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxPercentageQuery, TaxPercentageQueryVariables>(TaxPercentageDocument, options);
        }
export function useTaxPercentageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxPercentageQuery, TaxPercentageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxPercentageQuery, TaxPercentageQueryVariables>(TaxPercentageDocument, options);
        }
export type TaxPercentageQueryHookResult = ReturnType<typeof useTaxPercentageQuery>;
export type TaxPercentageLazyQueryHookResult = ReturnType<typeof useTaxPercentageLazyQuery>;
export type TaxPercentageSuspenseQueryHookResult = ReturnType<typeof useTaxPercentageSuspenseQuery>;
export type TaxPercentageQueryResult = Apollo.QueryResult<TaxPercentageQuery, TaxPercentageQueryVariables>;
export const CountriesDocument = gql`
    query countries {
  countries {
    name
    alpha2Code
    regionalBlocs {
      name
    }
  }
}
    `;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export function useCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesSuspenseQueryHookResult = ReturnType<typeof useCountriesSuspenseQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const PromoCodeDocument = gql`
    query promoCode($promoCode: String!, $planType: String!, $currency: String) {
  promoCode(promoCode: $promoCode, planType: $planType, currency: $currency) {
    id
    percent_off
    amount_off
    terms
    duration
    trial_days
  }
}
    `;

/**
 * __usePromoCodeQuery__
 *
 * To run a query within a React component, call `usePromoCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoCodeQuery({
 *   variables: {
 *      promoCode: // value for 'promoCode'
 *      planType: // value for 'planType'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function usePromoCodeQuery(baseOptions: Apollo.QueryHookOptions<PromoCodeQuery, PromoCodeQueryVariables> & ({ variables: PromoCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromoCodeQuery, PromoCodeQueryVariables>(PromoCodeDocument, options);
      }
export function usePromoCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromoCodeQuery, PromoCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromoCodeQuery, PromoCodeQueryVariables>(PromoCodeDocument, options);
        }
export function usePromoCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromoCodeQuery, PromoCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromoCodeQuery, PromoCodeQueryVariables>(PromoCodeDocument, options);
        }
export type PromoCodeQueryHookResult = ReturnType<typeof usePromoCodeQuery>;
export type PromoCodeLazyQueryHookResult = ReturnType<typeof usePromoCodeLazyQuery>;
export type PromoCodeSuspenseQueryHookResult = ReturnType<typeof usePromoCodeSuspenseQuery>;
export type PromoCodeQueryResult = Apollo.QueryResult<PromoCodeQuery, PromoCodeQueryVariables>;
export const SubscriptionPriceDocument = gql`
    query subscriptionPrice($countryCode: String!, $planType: String!, $hostingPlan: String) {
  subscriptionPrice(
    countryCode: $countryCode
    planType: $planType
    hostingPlan: $hostingPlan
  ) {
    price
    currency
    symbol
  }
}
    `;

/**
 * __useSubscriptionPriceQuery__
 *
 * To run a query within a React component, call `useSubscriptionPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionPriceQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      planType: // value for 'planType'
 *      hostingPlan: // value for 'hostingPlan'
 *   },
 * });
 */
export function useSubscriptionPriceQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionPriceQuery, SubscriptionPriceQueryVariables> & ({ variables: SubscriptionPriceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionPriceQuery, SubscriptionPriceQueryVariables>(SubscriptionPriceDocument, options);
      }
export function useSubscriptionPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionPriceQuery, SubscriptionPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionPriceQuery, SubscriptionPriceQueryVariables>(SubscriptionPriceDocument, options);
        }
export function useSubscriptionPriceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionPriceQuery, SubscriptionPriceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionPriceQuery, SubscriptionPriceQueryVariables>(SubscriptionPriceDocument, options);
        }
export type SubscriptionPriceQueryHookResult = ReturnType<typeof useSubscriptionPriceQuery>;
export type SubscriptionPriceLazyQueryHookResult = ReturnType<typeof useSubscriptionPriceLazyQuery>;
export type SubscriptionPriceSuspenseQueryHookResult = ReturnType<typeof useSubscriptionPriceSuspenseQuery>;
export type SubscriptionPriceQueryResult = Apollo.QueryResult<SubscriptionPriceQuery, SubscriptionPriceQueryVariables>;
export const UpdatePersonalisationDocument = gql`
    mutation updatePersonalisation($experienceLevel: ExperienceLevel, $podcastPurpose: PodcastPurpose, $heardAboutFrom: String) {
  updatePersonalisation(
    experienceLevel: $experienceLevel
    podcastPurpose: $podcastPurpose
    heardAboutFrom: $heardAboutFrom
  ) {
    user {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;
export type UpdatePersonalisationMutationFn = Apollo.MutationFunction<UpdatePersonalisationMutation, UpdatePersonalisationMutationVariables>;

/**
 * __useUpdatePersonalisationMutation__
 *
 * To run a mutation, you first call `useUpdatePersonalisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonalisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonalisationMutation, { data, loading, error }] = useUpdatePersonalisationMutation({
 *   variables: {
 *      experienceLevel: // value for 'experienceLevel'
 *      podcastPurpose: // value for 'podcastPurpose'
 *      heardAboutFrom: // value for 'heardAboutFrom'
 *   },
 * });
 */
export function useUpdatePersonalisationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonalisationMutation, UpdatePersonalisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonalisationMutation, UpdatePersonalisationMutationVariables>(UpdatePersonalisationDocument, options);
      }
export type UpdatePersonalisationMutationHookResult = ReturnType<typeof useUpdatePersonalisationMutation>;
export type UpdatePersonalisationMutationResult = Apollo.MutationResult<UpdatePersonalisationMutation>;
export type UpdatePersonalisationMutationOptions = Apollo.BaseMutationOptions<UpdatePersonalisationMutation, UpdatePersonalisationMutationVariables>;
export const StatisticsPageDocument = gql`
    query statisticsPage($showId: ID!) {
  show(id: $showId) {
    artworkUrl
    links {
      spotify
    }
  }
}
    `;

/**
 * __useStatisticsPageQuery__
 *
 * To run a query within a React component, call `useStatisticsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatisticsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatisticsPageQuery({
 *   variables: {
 *      showId: // value for 'showId'
 *   },
 * });
 */
export function useStatisticsPageQuery(baseOptions: Apollo.QueryHookOptions<StatisticsPageQuery, StatisticsPageQueryVariables> & ({ variables: StatisticsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatisticsPageQuery, StatisticsPageQueryVariables>(StatisticsPageDocument, options);
      }
export function useStatisticsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatisticsPageQuery, StatisticsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatisticsPageQuery, StatisticsPageQueryVariables>(StatisticsPageDocument, options);
        }
export function useStatisticsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StatisticsPageQuery, StatisticsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StatisticsPageQuery, StatisticsPageQueryVariables>(StatisticsPageDocument, options);
        }
export type StatisticsPageQueryHookResult = ReturnType<typeof useStatisticsPageQuery>;
export type StatisticsPageLazyQueryHookResult = ReturnType<typeof useStatisticsPageLazyQuery>;
export type StatisticsPageSuspenseQueryHookResult = ReturnType<typeof useStatisticsPageSuspenseQuery>;
export type StatisticsPageQueryResult = Apollo.QueryResult<StatisticsPageQuery, StatisticsPageQueryVariables>;
export const GetEpisodeStatsDocument = gql`
    query getEpisodeStats($episodeId: ID!) {
  getEpisodeStats(episodeId: $episodeId) {
    downloadsToday
    downloadsYesterday
    downloadsLastWeek
    downloadsLastMonth
    downloadsLastQuarter
    downloadsAllTime
  }
}
    `;

/**
 * __useGetEpisodeStatsQuery__
 *
 * To run a query within a React component, call `useGetEpisodeStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodeStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodeStatsQuery({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useGetEpisodeStatsQuery(baseOptions: Apollo.QueryHookOptions<GetEpisodeStatsQuery, GetEpisodeStatsQueryVariables> & ({ variables: GetEpisodeStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEpisodeStatsQuery, GetEpisodeStatsQueryVariables>(GetEpisodeStatsDocument, options);
      }
export function useGetEpisodeStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEpisodeStatsQuery, GetEpisodeStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEpisodeStatsQuery, GetEpisodeStatsQueryVariables>(GetEpisodeStatsDocument, options);
        }
export function useGetEpisodeStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEpisodeStatsQuery, GetEpisodeStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEpisodeStatsQuery, GetEpisodeStatsQueryVariables>(GetEpisodeStatsDocument, options);
        }
export type GetEpisodeStatsQueryHookResult = ReturnType<typeof useGetEpisodeStatsQuery>;
export type GetEpisodeStatsLazyQueryHookResult = ReturnType<typeof useGetEpisodeStatsLazyQuery>;
export type GetEpisodeStatsSuspenseQueryHookResult = ReturnType<typeof useGetEpisodeStatsSuspenseQuery>;
export type GetEpisodeStatsQueryResult = Apollo.QueryResult<GetEpisodeStatsQuery, GetEpisodeStatsQueryVariables>;
export const GetPodcastStatsDocument = gql`
    query getPodcastStats($projectId: ID!) {
  getPodcastStats(projectId: $projectId) {
    downloadsToday
    downloadsYesterday
    downloadsLastWeek
    downloadsLastMonth
    downloadsLastQuarter
    downloadsAllTime
  }
}
    `;

/**
 * __useGetPodcastStatsQuery__
 *
 * To run a query within a React component, call `useGetPodcastStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPodcastStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPodcastStatsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetPodcastStatsQuery(baseOptions: Apollo.QueryHookOptions<GetPodcastStatsQuery, GetPodcastStatsQueryVariables> & ({ variables: GetPodcastStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPodcastStatsQuery, GetPodcastStatsQueryVariables>(GetPodcastStatsDocument, options);
      }
export function useGetPodcastStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPodcastStatsQuery, GetPodcastStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPodcastStatsQuery, GetPodcastStatsQueryVariables>(GetPodcastStatsDocument, options);
        }
export function useGetPodcastStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPodcastStatsQuery, GetPodcastStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPodcastStatsQuery, GetPodcastStatsQueryVariables>(GetPodcastStatsDocument, options);
        }
export type GetPodcastStatsQueryHookResult = ReturnType<typeof useGetPodcastStatsQuery>;
export type GetPodcastStatsLazyQueryHookResult = ReturnType<typeof useGetPodcastStatsLazyQuery>;
export type GetPodcastStatsSuspenseQueryHookResult = ReturnType<typeof useGetPodcastStatsSuspenseQuery>;
export type GetPodcastStatsQueryResult = Apollo.QueryResult<GetPodcastStatsQuery, GetPodcastStatsQueryVariables>;
export const GetPodcastAveragesStatsDocument = gql`
    query getPodcastAveragesStats($projectId: ID!, $period: String!) {
  getPodcastAveragesStats(projectId: $projectId, period: $period) {
    dailyAverage
    weeklyAverage
    monthlyAverage
  }
}
    `;

/**
 * __useGetPodcastAveragesStatsQuery__
 *
 * To run a query within a React component, call `useGetPodcastAveragesStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPodcastAveragesStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPodcastAveragesStatsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetPodcastAveragesStatsQuery(baseOptions: Apollo.QueryHookOptions<GetPodcastAveragesStatsQuery, GetPodcastAveragesStatsQueryVariables> & ({ variables: GetPodcastAveragesStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPodcastAveragesStatsQuery, GetPodcastAveragesStatsQueryVariables>(GetPodcastAveragesStatsDocument, options);
      }
export function useGetPodcastAveragesStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPodcastAveragesStatsQuery, GetPodcastAveragesStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPodcastAveragesStatsQuery, GetPodcastAveragesStatsQueryVariables>(GetPodcastAveragesStatsDocument, options);
        }
export function useGetPodcastAveragesStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPodcastAveragesStatsQuery, GetPodcastAveragesStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPodcastAveragesStatsQuery, GetPodcastAveragesStatsQueryVariables>(GetPodcastAveragesStatsDocument, options);
        }
export type GetPodcastAveragesStatsQueryHookResult = ReturnType<typeof useGetPodcastAveragesStatsQuery>;
export type GetPodcastAveragesStatsLazyQueryHookResult = ReturnType<typeof useGetPodcastAveragesStatsLazyQuery>;
export type GetPodcastAveragesStatsSuspenseQueryHookResult = ReturnType<typeof useGetPodcastAveragesStatsSuspenseQuery>;
export type GetPodcastAveragesStatsQueryResult = Apollo.QueryResult<GetPodcastAveragesStatsQuery, GetPodcastAveragesStatsQueryVariables>;
export const GetEpisodeDownloadsOverviewStatsDocument = gql`
    query getEpisodeDownloadsOverviewStats($episodeId: ID!) {
  getEpisodeDownloadsOverviewStats(episodeId: $episodeId) {
    downloadsToday
    downloadsYesterday
    downloadsLastWeek
    downloadsLastMonth
    downloadsLastQuarter
    downloadsForever
  }
}
    `;

/**
 * __useGetEpisodeDownloadsOverviewStatsQuery__
 *
 * To run a query within a React component, call `useGetEpisodeDownloadsOverviewStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodeDownloadsOverviewStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodeDownloadsOverviewStatsQuery({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useGetEpisodeDownloadsOverviewStatsQuery(baseOptions: Apollo.QueryHookOptions<GetEpisodeDownloadsOverviewStatsQuery, GetEpisodeDownloadsOverviewStatsQueryVariables> & ({ variables: GetEpisodeDownloadsOverviewStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEpisodeDownloadsOverviewStatsQuery, GetEpisodeDownloadsOverviewStatsQueryVariables>(GetEpisodeDownloadsOverviewStatsDocument, options);
      }
export function useGetEpisodeDownloadsOverviewStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEpisodeDownloadsOverviewStatsQuery, GetEpisodeDownloadsOverviewStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEpisodeDownloadsOverviewStatsQuery, GetEpisodeDownloadsOverviewStatsQueryVariables>(GetEpisodeDownloadsOverviewStatsDocument, options);
        }
export function useGetEpisodeDownloadsOverviewStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEpisodeDownloadsOverviewStatsQuery, GetEpisodeDownloadsOverviewStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEpisodeDownloadsOverviewStatsQuery, GetEpisodeDownloadsOverviewStatsQueryVariables>(GetEpisodeDownloadsOverviewStatsDocument, options);
        }
export type GetEpisodeDownloadsOverviewStatsQueryHookResult = ReturnType<typeof useGetEpisodeDownloadsOverviewStatsQuery>;
export type GetEpisodeDownloadsOverviewStatsLazyQueryHookResult = ReturnType<typeof useGetEpisodeDownloadsOverviewStatsLazyQuery>;
export type GetEpisodeDownloadsOverviewStatsSuspenseQueryHookResult = ReturnType<typeof useGetEpisodeDownloadsOverviewStatsSuspenseQuery>;
export type GetEpisodeDownloadsOverviewStatsQueryResult = Apollo.QueryResult<GetEpisodeDownloadsOverviewStatsQuery, GetEpisodeDownloadsOverviewStatsQueryVariables>;
export const GetOsStatsDocument = gql`
    query getOSStats($projectId: ID!, $period: String!) {
  getOSStats(projectId: $projectId, period: $period) {
    androidDownloads
    windowsDownloads
    macosDownloads
    iosDownloads
    others
  }
}
    `;

/**
 * __useGetOsStatsQuery__
 *
 * To run a query within a React component, call `useGetOsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOsStatsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetOsStatsQuery(baseOptions: Apollo.QueryHookOptions<GetOsStatsQuery, GetOsStatsQueryVariables> & ({ variables: GetOsStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOsStatsQuery, GetOsStatsQueryVariables>(GetOsStatsDocument, options);
      }
export function useGetOsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOsStatsQuery, GetOsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOsStatsQuery, GetOsStatsQueryVariables>(GetOsStatsDocument, options);
        }
export function useGetOsStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOsStatsQuery, GetOsStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOsStatsQuery, GetOsStatsQueryVariables>(GetOsStatsDocument, options);
        }
export type GetOsStatsQueryHookResult = ReturnType<typeof useGetOsStatsQuery>;
export type GetOsStatsLazyQueryHookResult = ReturnType<typeof useGetOsStatsLazyQuery>;
export type GetOsStatsSuspenseQueryHookResult = ReturnType<typeof useGetOsStatsSuspenseQuery>;
export type GetOsStatsQueryResult = Apollo.QueryResult<GetOsStatsQuery, GetOsStatsQueryVariables>;
export const GetDevicesStatsDocument = gql`
    query getDevicesStats($projectId: ID!, $period: String!) {
  getDevicesStats(projectId: $projectId, period: $period) {
    mobileDownloads
    allDownloads
  }
}
    `;

/**
 * __useGetDevicesStatsQuery__
 *
 * To run a query within a React component, call `useGetDevicesStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevicesStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevicesStatsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetDevicesStatsQuery(baseOptions: Apollo.QueryHookOptions<GetDevicesStatsQuery, GetDevicesStatsQueryVariables> & ({ variables: GetDevicesStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDevicesStatsQuery, GetDevicesStatsQueryVariables>(GetDevicesStatsDocument, options);
      }
export function useGetDevicesStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDevicesStatsQuery, GetDevicesStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDevicesStatsQuery, GetDevicesStatsQueryVariables>(GetDevicesStatsDocument, options);
        }
export function useGetDevicesStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDevicesStatsQuery, GetDevicesStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDevicesStatsQuery, GetDevicesStatsQueryVariables>(GetDevicesStatsDocument, options);
        }
export type GetDevicesStatsQueryHookResult = ReturnType<typeof useGetDevicesStatsQuery>;
export type GetDevicesStatsLazyQueryHookResult = ReturnType<typeof useGetDevicesStatsLazyQuery>;
export type GetDevicesStatsSuspenseQueryHookResult = ReturnType<typeof useGetDevicesStatsSuspenseQuery>;
export type GetDevicesStatsQueryResult = Apollo.QueryResult<GetDevicesStatsQuery, GetDevicesStatsQueryVariables>;
export const GetCountriesStatsDocument = gql`
    query getCountriesStats($projectId: ID!, $period: String!) {
  getCountriesStats(projectId: $projectId, period: $period) {
    countriesStats
  }
}
    `;

/**
 * __useGetCountriesStatsQuery__
 *
 * To run a query within a React component, call `useGetCountriesStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesStatsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetCountriesStatsQuery(baseOptions: Apollo.QueryHookOptions<GetCountriesStatsQuery, GetCountriesStatsQueryVariables> & ({ variables: GetCountriesStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesStatsQuery, GetCountriesStatsQueryVariables>(GetCountriesStatsDocument, options);
      }
export function useGetCountriesStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesStatsQuery, GetCountriesStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesStatsQuery, GetCountriesStatsQueryVariables>(GetCountriesStatsDocument, options);
        }
export function useGetCountriesStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountriesStatsQuery, GetCountriesStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountriesStatsQuery, GetCountriesStatsQueryVariables>(GetCountriesStatsDocument, options);
        }
export type GetCountriesStatsQueryHookResult = ReturnType<typeof useGetCountriesStatsQuery>;
export type GetCountriesStatsLazyQueryHookResult = ReturnType<typeof useGetCountriesStatsLazyQuery>;
export type GetCountriesStatsSuspenseQueryHookResult = ReturnType<typeof useGetCountriesStatsSuspenseQuery>;
export type GetCountriesStatsQueryResult = Apollo.QueryResult<GetCountriesStatsQuery, GetCountriesStatsQueryVariables>;
export const GetShowDetailsStatsDocument = gql`
    query getShowDetailsStats($limit: Int!, $offset: Int!, $order: String!) {
  getShowDetailsStats(limit: $limit, offset: $offset, order: $order) {
    total
    episodeStats {
      episodeId
      name
      episodeNumber
      deletedAt
      today
      yesterday
      week
      month
      quarter
      forever
    }
  }
}
    `;

/**
 * __useGetShowDetailsStatsQuery__
 *
 * To run a query within a React component, call `useGetShowDetailsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShowDetailsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShowDetailsStatsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetShowDetailsStatsQuery(baseOptions: Apollo.QueryHookOptions<GetShowDetailsStatsQuery, GetShowDetailsStatsQueryVariables> & ({ variables: GetShowDetailsStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShowDetailsStatsQuery, GetShowDetailsStatsQueryVariables>(GetShowDetailsStatsDocument, options);
      }
export function useGetShowDetailsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShowDetailsStatsQuery, GetShowDetailsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShowDetailsStatsQuery, GetShowDetailsStatsQueryVariables>(GetShowDetailsStatsDocument, options);
        }
export function useGetShowDetailsStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShowDetailsStatsQuery, GetShowDetailsStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShowDetailsStatsQuery, GetShowDetailsStatsQueryVariables>(GetShowDetailsStatsDocument, options);
        }
export type GetShowDetailsStatsQueryHookResult = ReturnType<typeof useGetShowDetailsStatsQuery>;
export type GetShowDetailsStatsLazyQueryHookResult = ReturnType<typeof useGetShowDetailsStatsLazyQuery>;
export type GetShowDetailsStatsSuspenseQueryHookResult = ReturnType<typeof useGetShowDetailsStatsSuspenseQuery>;
export type GetShowDetailsStatsQueryResult = Apollo.QueryResult<GetShowDetailsStatsQuery, GetShowDetailsStatsQueryVariables>;
export const GetAppsStatsDocument = gql`
    query getAppsStats($start: String) {
  getAppsStats(start: $start) {
    appName
    downloads
    percentage
  }
}
    `;

/**
 * __useGetAppsStatsQuery__
 *
 * To run a query within a React component, call `useGetAppsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppsStatsQuery({
 *   variables: {
 *      start: // value for 'start'
 *   },
 * });
 */
export function useGetAppsStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetAppsStatsQuery, GetAppsStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppsStatsQuery, GetAppsStatsQueryVariables>(GetAppsStatsDocument, options);
      }
export function useGetAppsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppsStatsQuery, GetAppsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppsStatsQuery, GetAppsStatsQueryVariables>(GetAppsStatsDocument, options);
        }
export function useGetAppsStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppsStatsQuery, GetAppsStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppsStatsQuery, GetAppsStatsQueryVariables>(GetAppsStatsDocument, options);
        }
export type GetAppsStatsQueryHookResult = ReturnType<typeof useGetAppsStatsQuery>;
export type GetAppsStatsLazyQueryHookResult = ReturnType<typeof useGetAppsStatsLazyQuery>;
export type GetAppsStatsSuspenseQueryHookResult = ReturnType<typeof useGetAppsStatsSuspenseQuery>;
export type GetAppsStatsQueryResult = Apollo.QueryResult<GetAppsStatsQuery, GetAppsStatsQueryVariables>;
export const UniversalFilesDocument = gql`
    query universalFiles($offset: Int, $limit: Int, $projectId: ID!) {
  universalFiles(offset: $offset, limit: $limit, projectId: $projectId) {
    total
    categories {
      name
      previewFile
      files {
        id
        name
        duration
        users
        isAddedToLibrary
      }
    }
  }
}
    `;

/**
 * __useUniversalFilesQuery__
 *
 * To run a query within a React component, call `useUniversalFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniversalFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniversalFilesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUniversalFilesQuery(baseOptions: Apollo.QueryHookOptions<UniversalFilesQuery, UniversalFilesQueryVariables> & ({ variables: UniversalFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniversalFilesQuery, UniversalFilesQueryVariables>(UniversalFilesDocument, options);
      }
export function useUniversalFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniversalFilesQuery, UniversalFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniversalFilesQuery, UniversalFilesQueryVariables>(UniversalFilesDocument, options);
        }
export function useUniversalFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UniversalFilesQuery, UniversalFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UniversalFilesQuery, UniversalFilesQueryVariables>(UniversalFilesDocument, options);
        }
export type UniversalFilesQueryHookResult = ReturnType<typeof useUniversalFilesQuery>;
export type UniversalFilesLazyQueryHookResult = ReturnType<typeof useUniversalFilesLazyQuery>;
export type UniversalFilesSuspenseQueryHookResult = ReturnType<typeof useUniversalFilesSuspenseQuery>;
export type UniversalFilesQueryResult = Apollo.QueryResult<UniversalFilesQuery, UniversalFilesQueryVariables>;
export const LinkFileDocument = gql`
    mutation linkFile($id: ID!, $projectId: ID!) {
  linkFile(id: $id, projectId: $projectId)
}
    `;
export type LinkFileMutationFn = Apollo.MutationFunction<LinkFileMutation, LinkFileMutationVariables>;

/**
 * __useLinkFileMutation__
 *
 * To run a mutation, you first call `useLinkFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkFileMutation, { data, loading, error }] = useLinkFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useLinkFileMutation(baseOptions?: Apollo.MutationHookOptions<LinkFileMutation, LinkFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkFileMutation, LinkFileMutationVariables>(LinkFileDocument, options);
      }
export type LinkFileMutationHookResult = ReturnType<typeof useLinkFileMutation>;
export type LinkFileMutationResult = Apollo.MutationResult<LinkFileMutation>;
export type LinkFileMutationOptions = Apollo.BaseMutationOptions<LinkFileMutation, LinkFileMutationVariables>;
export const UnlinkFileDocument = gql`
    mutation unlinkFile($id: ID!, $projectId: ID!) {
  unlinkFile(id: $id, projectId: $projectId)
}
    `;
export type UnlinkFileMutationFn = Apollo.MutationFunction<UnlinkFileMutation, UnlinkFileMutationVariables>;

/**
 * __useUnlinkFileMutation__
 *
 * To run a mutation, you first call `useUnlinkFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkFileMutation, { data, loading, error }] = useUnlinkFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUnlinkFileMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkFileMutation, UnlinkFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkFileMutation, UnlinkFileMutationVariables>(UnlinkFileDocument, options);
      }
export type UnlinkFileMutationHookResult = ReturnType<typeof useUnlinkFileMutation>;
export type UnlinkFileMutationResult = Apollo.MutationResult<UnlinkFileMutation>;
export type UnlinkFileMutationOptions = Apollo.BaseMutationOptions<UnlinkFileMutation, UnlinkFileMutationVariables>;